import Vue from 'vue';
import Vuex from 'vuex';
import router from '@/router';
import axiosAuth from '@/axios-auth';
import axios from 'axios';
import i18n from '@/i18n';
import fs, { Stats } from 'fs';
import _ from 'lodash'; //Para ordenamiento de arreglos.
// import path from 'path';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        version: '2.8.3',
        appTitle: 'Retroaliméntame',
        mainLogo: require('@/assets/tw.png'),
        mainLogoAppBar: require('@/assets/tw_app_bar.png'),
        retroalimentameLogo: require('@/assets/retroalimentame.png'),
        mainBackgroundImg: '../assets/floriane-vita-FyD3OWBuXnY-unsplash.jpg',
        disclaimerImg: require('@/assets/disclaimer.jpg'),
        bWaitCursor: false,
        bFailedLogin: false,
        isAuthenticated: false,
        bInactiveUser: false,
        userName: '', //Nombre del usuario logueado.
        bAdmin: false,
        //authHeader: null,
        idToken: null,
        userID: null,
        //userType: 0, //1 = superadmin, 2 = admin. prepago, 3 = admin. de seguimiento, 4 = encuestado.
        companyID: null, //ID de la empresa del usuario logueado.
        questionnaireID: 0, //ID del cuestionario logueado, si se trata de un admin. de encuestas prepagadas.
        company: null, //Empresa del usuario logueado, si el usuario no es administrador.
        companySales: 0,
        companySalesCurrency: '1', //MXP por default.

        user: null,
        users: null,
        administrators: null,
        //bUserConfigDlg: false, //Indica que en la ventana Users hay que desplegar la ventana de Configuración de Usuario
        bDuplicatedUserError: false, //Indica que hay que desplegar un mensaje de error ya que se intentó registrar a un usuario con un correo previamente registrado.
        bUserWithNoSurveys: false, //Indica que el usuario encuestado logueado no tiene encuestas activas.
        bUserWithNoPendingSurveys: false, //Indica que el usuario encuestado no tiene ninguna encuesta activa sin contestar.

        //Banderas que indican que la configuración del usuario se pudo obtener del servidor:
        //userFunctionsFetched: false,
        userRolesFetched: false,
        userBusinessUnitsFetched: false,
        userDepartmentsFetched: false,
        userConfigOK: false, //Indica que se pudieron obtener todas las tablas de configuración del usuario,
        //por lo que, si el usuario es administrador, puede ver la ventana de configuración, y si
        //el usuario es usuario normal, puede realizar una valuación.

        bShowDepartmentsDlg: false, //Indica si se debe mostrar la subventana (componente) de Direcciones en la ventana de Empresas.
        bShowBusinessUnitsDlg: false, //Indica si se debe mostrar la subventana (componente) de Unidades de Negocio en la ventana de Empresas.
        bShowCompanyFunctionsDlg: false, //Indica si se debe mostrar el modal de las funciones asignadas a una empresa.
        bShowSelectFunctionDlg: false, //Indica si se debe mostrar la subventana (componente) para asignar una función a una empresa.
        bShowValFunctionDlg: false, //Indica si se debe mostrar la subventana (componente) para seleccionar una función para una valuación.
        valFunctionID: 0, //ID de la función seleccionada para una valuación.
        valFunctionName: '', //Nombre de la función seleccionada para una valuación.

        companies: [],
        selectedCompanyIndex: -1, //Indice de la empresa seleccionada en la ventana Empresas.
        bSearchNewCompany: false, //Indica si se debe buscar el índice de la empresa que se acaba de registrar.
        newCompanyName: '', //Indica el nombre de una nueva empresa registrada, para poder seleccionarla después en la ventana Empresas.
        companyLogoImg: null, //Logo de la compañía seleccionada, para las ventanas Empresas, Encuestas y Encuesta.

        userTypes: [],
        selectedUserTypeIndex: -1,
        bSearchNewUserType: false,
        newUserTypeName: '',

        answerSets: [],
        selectedAnswerSetIndex: -1,
        bSearchNewAnswerSet: false,
        newAnswerSetName: '',

        answers: [],
        languageAnswers: [],
        answerTable: [],
        answerTableHeader: [], //Header de la tabla de respuestas, para la ventana AnswerSets.vue.
        languagesAnswerSet: [], //Arreglo con todos los idiomas, indicando si cada idioma está configurado para un set de respuestas, para la ventana AnswerSets.vue

        questionnaires: [],
        selectedQuestionnaireIndex: -1,
        bSearchNewQuestionnaire: false, //Indica a Questionnaires.vue que debe buscar la información de un nuevo cuestionario (mediante un watch).
        newQuestionnaireID: 0,

        questionnaireNameTable: [],
        questionnaireNames: [],
        questionnaireSkills: [],
        questionnaireSkillsLang: [],
        questionnaireSkillTable: [],
        questionnaireQuestions: [],
        questionnaireQuestionsLang: [],
        questionnaireQuestionTable: [],
        questionnaireQuestionHeader: [],
        questionnaireTablesHeader: [], //Header de las tablas del cuestionario, para la ventana Questionnaires.vue.
        questionnaireGeneralAnswerSetID: 0,
        bQuestionnaireNotDeletedWarning: false,
        bServerResponse: false, //Indica si el servidor ya respondió ante un request de borrado de cuestionario.

        surveyQuestModulesTeams: [], //Módulos de los cuestionarios que tienen módulos de "Equipos" (no todos los cuestionarios tienen módulos).
        surveyQuestModulesCulture: [], //Módulos de los cuestionarios que tienen módulos de "Cultura" (no todos los cuestionarios tienen módulos).
        surveyQuestModulesIndex: [], //Módulos de los cuestionarios que tienen módulos de "Índice de determinación" (no todos los cuestionarios tienen módulos).
        surveyQuestModulesLifeCircleDx: [], //Módulos de los cuestionarios que tienen módulos de "Diagnóstico círculo de vida" (no todos los cuestionarios tienen módulos).
        surveyQuestModulesLifeCircleDxLeadership: [], //Módulos de los cuestionarios que tienen módulos de "Diagnóstico círculo de vida liderazgo" (no todos los cuestionarios tienen módulos).

        surveys: [],
        surveysToDisplay: [], //Encuestas a desplegar en la lista de Encuestas en Surveys.vue
        selectedSurveyIndex: -1,
        bSearchNewSurvey: false, //Indica a Surveys.vue que debe buscar la información de una nueva encuesta (mediante un watch).
        newSurveyID: 0,
        survey: null, //Encuesta seleccionada en la ventana Encuestas.
        //surveyUsers: [],
        surveyRolleLabels: [], //Etiquetas para los roles de una encuesta. Este arreglo es el que usa el select del modal para asignar al usuario de una encuesta.
        rolleLabelTable: [], //Tabla de etiquetas para los roles de una encuesta.
        surveyUserTable: [],
        bSurveyLoaded: false, //Indica si ya se recibió la información de una encuesta seleccionada, para después poder obtener la información relacionada.
        bLoadingSurvey: false, //Indica si la información de una encuesta está siendo cargada, para no dejar cambiarse a ninguna otra encuesta antes de que se reciba toda la información.
        //Si no, se pueden mezclar los usuarios si se cambia de encuesta antes de terminarse de bajar los usuarios de una encuesta.

        userSurveys: [], //Encuestas del usuario encuestado logueado.
        userSurvey: null, //Encuesta seleccionada por el usuario encuestado logueado.
        userSurveyLangID: 0, //Idioma seleccionado por el usuario para contestar una encuesta.
        userSurveyData: null, //Información de la encuesta a contestar por el usuario.
        surveyCompany: null,
        surveyNumQuestions: 0, //Número de preguntas de una encuesta, para poder calcular el porcentaje de avance.
        bShowThankYouDlg: false,

        bSearchNewUser: false, //Indica si se debe buscar el índice del usuario que se acaba de registrar.
        newUserEmail: '', //Indica el email de un nuevo usuario registrado, para poder seleccionarlo después en la ventana Usuarios.
        selectedUserIndex: -1, //Indice del usuario seleccionado en la ventana Usuarios.

        languages: [],
        selectedLanguageIndex: -1, //Indice del idioma seleccionado en la ventana Idiomas.
        bSearchNewLanguage: false, //Indica si se debe buscar el índice del idioma que se acaba de registrar.
        newLanguageName: '', //Indica el nombre de un nuevo idioma registrado, para poder seleccionarlo después en la ventana Idiomas.

        //Arreglos para el catálogo de funciones:
        primaryFunctions: [],
        specializedFunctions: [],
        disaggregatedFunctions: [],
        specializedFunctionsToShow: [], //Arreglo para sólo mostrar las funciones especializadas cuando se escoge el radio "Especiaizadas",
        //ya que las funciones especializadas se obtienen cuando se selecciona una función primaria, pero
        //en ese momento no se deben desplegar.
        disaggregatedFunctionsToShow: [], //Arreglo para sólo mostrar las funciones desagregadas cuando se escoge el radio "Desagregadas",
        //ya que las funciones desagregadas se obtienen cuando se selecciona una función especializada, pero
        //en ese momento no se deben desplegar.

        //Arreglos para el diálogo para seleccionar una función para una valuación:
        primaryFunctionsVal: [],
        specializedFunctionsVal: [],
        disaggregatedFunctionsVal: [],
        specializedFunctionsValToShow: [],
        disaggregatedFunctionsValToShow: [],

        //Arreglos para el diálogo de las funciones asignadas a una empresa:
        primaryFunctionsCompany: [],
        specializedFunctionsCompany: [],
        disaggregatedFunctionsCompany: [],
        specializedFunctionsCompanyToShow: [],
        disaggregatedFunctionsCompanyToShow: [],

        bSpecialized: false, //Indica si la función primaria seleccionada tiene funciones especializadas.
        bSpecializedVal: false,
        bSpecializedCompany: false,

        bDisaggregated: false, //Indica si la función especializada seleccionada tiene funciones desagregadas.
        bDisaggregatedVal: false,
        bDisaggregatedCompany: false,

        companyFunctions: [], //Arreglo que contiene a todas las funciones asignadas a una empresa, usado para el catálogo de funciones de la empresa.
        companyFunctionsVal: [], //Arreglo que contiene a todas las funciones de una empresa, usado para una valuación.

        // functionsExt: [], //Arreglo que incluye el nombre personalizado para cada usuario.
        // userFunctions: [], //Funciones asignadas a un usuario.
        // originalUserFunctions: [], //Arreglo para poder comparar los cambios que se hagan.
        // userFunctionsToSave: [], //Arreglo para actualizar la base de datos.
        selectedFunctionIndex: -1,
        selectedPrimaryIndex: -1,
        selectedSpecializedIndex: -1,
        selectedDisaggregatedIndex: -1,
        selectedPrimaryValIndex: -1,
        selectedSpecializedValIndex: -1,
        selectedDisaggregatedValIndex: -1,
        selectedPrimaryCompanyIndex: -1,
        selectedSpecializedCompanyIndex: -1,
        selectedDisaggregatedCompanyIndex: -1,
        bSearchNewFunction: false,
        newFunctionName: '',
        bFunctionAssigned: false, //Indica si se debe mostrar un mensaje que diga que la función seleccionada fue asignada a una empresa.
        bFunctionDuplicated: false, //Indica si se debe mostrar un mensaje que diga que la función seleccionada ya había sido asignada antes a una empresa.

        roles: [],
        rolesExt: [], //Arreglo que incluye el nombre personalizado para cada usuario.
        userRoles: [], //Roles asignados a un usuario.
        originalUserRoles: [], //Arreglo para poder comparar los cambios que se hagan.
        userRolesToSave: [], //Arreglo para actualizar la base de datos.
        selectedRoleIndex: -1,
        bSearchNewRole: false,
        newRoleName: '',

        businessUnits: [],
        businessUnitsExt: [], //Arreglo que incluye el nombre personalizado para cada usuario.
        userBusinessUnits: [], //Unidades de negocio asignadas a un usuario.
        originalUserBusinessUnits: [], //Arreglo para poder comparar los cambios que se hagan.
        userBusinessUnitsToSave: [], //Arreglo para actualizar la base de datos.
        selectedBusinessUnitIndex: -1,
        bSearchNewBusinessUnit: false,
        newBusinessUnitName: '',
        businessUnitForUser: {
            bAssigned: false,
            id: 0,
            name: ''
        },

        departments: [],
        departmentsExt: [], //Arreglo que incluye el nombre personalizado para cada usuario.
        userDepartments: [], //Direcciones asignadas a un usuario.
        originalUserDepartments: [], //Arreglo para poder comparar los cambios que se hagan.
        userDepartmentsToSave: [], //Arreglo para actualizar la base de datos.
        selectedDepartmentIndex: -1,
        bSearchNewDepartment: false,
        newDepartmentName: '',

        companySize: 0,
        factoresEmpresaID: 0, //Generado por el servidor cuando se calcula el tamaño de la empresa en una valuación.

        results: null,
        bShowResultsDlg: null,
        companyReportResults: null,
        departmentReportResults: null,
        bShowCompanyReportResultsDlg: null,
        bShowDepartmentReportResultsDlg: null,
        selectedDeptForReport: null, //Nombre del departamento del cual se va a hacer el reporte.

        /********************************************** */
        bShowNuestrasHerramientasDxTx: null,
        bShowComoFuncionaTxt: null,
        bShowRecursosTxt: null,
        bShowDocumentosInteresTxt: null,
        bShowGuiaInterpretacionTxt: null,
        bShowContactoTxt: null,

        bReportProcessed: false, //Indica que el servidor ya mandó el reporte procesado.
        iReportWarning: 0, //Indica la causa por la que no se generó el reporte.
        pdfPath: '',

        bExcelProcessed: false, //Indica que el servidor ya mandó el reporte en Excel.
        excelPath: '',

        bBelbinReportProcessed: false, //Indica que el servidor ya mandó el reporte.
        belbinReportPath: '',

        bSendUserSurveyError: false, //Indica si hubo un error de comunicación con el servidor al momento de finalizar una encuesta.

        sessionExpires: false, //Indica si la encuesta del usuario logueado tiene tiempo límite para contestar.
        sessionTimeLeft: '', //String del tiempo restante de la sesión de una encuesta, en caso de que la encuesta esté configuara con tiempo límite.
        sessionEnding: false, //Indica que falta menos de un minuto para terminar la encuesta.
        sessionEnded: false, //Para poder desactivar el timer.

        userActivityLogs: [],
        askToSelectSurvey: false //Indica que el usuario logueado tiene más de una encuesta, por lo que siempre al terminar de responder cada una pedirá
        //que seleccione la siguiente, aunque ya nada más falte una.
    },

    mutations: {
        setShowNuestrasHerramientasDxTx(state, bShow) {
            state.bShowNuestrasHerramientasDxTx = bShow;
        },
        setShowComoFuncionaTxt(state, bShow) {
            state.bShowComoFuncionaTxt = bShow;
        },
        setShowRecursosTxt(state, bShow)
        {
            state.bShowRecursosTxt = bShow;
        },
        setShowDocumentosInteresTxt(state, bShow)
        {
            state.bShowDocumentosInteresTxt = bShow;
        },
        setShowGuiaInterpretacionTxt(state, bShow) {
            state.bShowGuiaInterpretacionTxt = bShow;
        },
        setShowContactoTxt(state, bShow) {
            state.bShowContactoTxt = bShow;
        },
        setFailedLogin(state, payload) {
            state.bFailedLogin = payload;
        },
        setInactiveUser(state, payload) {
            state.bInactiveUser = payload;
        },
        authUser(state, userData) {
            //state.authHeader = userData.authHeader;
            state.idToken = userData.idToken;
            state.userID = userData.userID;
        },
        clearAuthData(state) {
            //state.authHeader = null,
            console.log('clearAuthData...');

            state.idToken = null;
            state.userID = null;
            state.isAuthenticated = false;
        },
        setDuplicatedUserError(state, payload) {
            state.bDuplicatedUserError = payload;
        },
        setIsAuthenticated(state, payload) {
            state.isAuthenticated = payload;
        },
        setUser(state, user) {
            state.user = user;
            state.userName = user.nombre + ' ' + user.appaterno + ' ' + user.apmaterno;
            state.companyID = user.empresaid;
            state.questionnaireID = user.cuestionarioid;
            if (state.user.tipoid === 1) {
                //Super administrador
                state.bAdmin = true;
            } //Usuario normal
            else {
                state.bAdmin = false;
            }
        },
        setUserWithNoSurveys(state, bNoSurveys) {
            state.bUserWithNoSurveys = bNoSurveys;
        },
        setUserWithNoPendingSurveys(state, bNoPendingSurveys) {
            state.bUserWithNoPendingSurveys = bNoPendingSurveys;
        },
        setCompanySize(state, size) {
            state.companySize = size;
        },
        setCompanySales(state, payload) {
            state.companySales = payload.ventas;
            state.companySalesCurrency = payload.moneda;
        },
        setFactoresEmpresa(state, factoresempresaid) {
            state.factoresEmpresaID = factoresempresaid;
        },

        setShowDepartmentsDlg(state, bShowDlg) {
            state.bShowDepartmentsDlg = bShowDlg;
        },
        setShowBusinessUnitsDlg(state, bShowDlg) {
            state.bShowBusinessUnitsDlg = bShowDlg;
        },
        setShowCompanyFunctionsDlg(state, bShowDlg) {
            state.bShowCompanyFunctionsDlg = bShowDlg;
        },
        setShowSelectFunctionDlg(state, bShowDlg) {
            state.bShowSelectFunctionDlg = bShowDlg;
        },
        setShowValFunctionDlg(state, bShowDlg) {
            state.bShowValFunctionDlg = bShowDlg;
            console.log('bShowValFunctionDlg = ', state.bShowValFunctionDlg);
        },

        // setCompany(state, company) {
        //     state.company = company;
        // },

        setResults(state, results) {
            state.results = results;
            state.bShowResultsDlg = true;
        },
        setCompanyReportResults(state, results) {
            state.companyReportResults = results;
            state.bShowCompanyReportResultsDlg = true;
        },
        setDepartmentReportResults(state, results) {
            state.departmentReportResults = results;
            state.bShowDepartmentReportResultsDlg = true;
        },

        setShowResultsDlg(state, bShow) {
            state.bShowResultsDlg = bShow;
        },
        setShowCompanyReportResultsDlg(state, bShow) {
            state.bShowCompanyReportResultsDlg = bShow;
        },
        setShowDepartmentReportResultsDlg(state, bShow) {
            state.bShowDepartmentReportResultsDlg = bShow;
        },
        setSelectedDeptForReport(state, name) {
            state.selectedDeptForReport = name;
        },
        setUserConfigOK(state, bOK) {
            state.userConfigOK = bOK;
        },

        setCompanies(state, companies) {
            state.bWaitCursor = true;
            state.companies = companies;

            if (state.bSearchNewCompany) {
                var i;
                for (i = 0; i < companies.length; i++) {
                    if (state.newCompanyName === companies[i].empresanombre) {
                        state.selectedCompanyIndex = i;
                        state.bSearchNewCompany = false;
                        state.newCompanyName = '';
                    }
                }
            }

            //Busca el nombre de la empresa del usuario logueado:
            var i;
            for (i = 0; i < companies.length; i++) {
                if (companies[i].empresaid === state.companyID) {
                    state.company = companies[i];
                    break;
                }
            }
            state.bWaitCursor = false;
        },

        setCompanyLogoImg(state, logo) {
            // var logoFileURL = URL.createObjectURL(logo);
            // console.logo("logo = ", logoFileURL);
            state.companyLogoImg = logo;
            //console.log("En setCompanyLogoImg, companyLogoImg = ", state.companyLogoImg);
        },

        setUserTypes(state, userTypes) {
            state.bWaitCursor = true;
            state.userTypes = userTypes;

            if (state.bSearchNewUserType) {
                var i;
                for (i = 0; i < userTypes.length; i++) {
                    if (state.newUserTypeName === userTypes[i].nombre) {
                        state.selectedUserTypeIndex = i;
                        state.bSearchNewUserType = false;
                        state.newUserTypeName = '';
                    }
                }
            }
            state.bWaitCursor = false;
        },

        setAnswerSets(state, answerSets) {
            state.bWaitCursor = true;
            state.answerSets = answerSets;

            if (state.bSearchNewAnswerSet) {
                var i;
                for (i = 0; i < answerSets.length; i++) {
                    if (state.newAnswerSetName === answerSets[i].respuesta) {
                        state.selectedAnswerSetIndex = i;
                        state.bSearchNewAnswerSet = false;
                        state.newAnswerSetName = '';
                    }
                }
            }
            state.bWaitCursor = false;
        },

        setAnswers(state, answers) {
            state.bWaitCursor = true;
            state.answers = answers;
            state.bWaitCursor = false;
        },

        setLanguageAnswers(state, languageAnswers) {
            state.bWaitCursor = true;
            state.languageAnswers = languageAnswers;
            state.bWaitCursor = false;
        },

        setSelectedAnswerSetIndex: (state, index) => {
            state.selectedAnswerSetIndex = index;
        },

        setAnswerTable(state, answerTable) {
            state.answerTable = answerTable;
        },

        setAnswerTableHeader(state, answerHeader) {
            state.answerTableHeader = answerHeader;
        },

        setLanguagesAnswerSet(state, languagesAnswerSet) {
            state.languagesAnswerSet = languagesAnswerSet;
        },

        setQuestionnaires(state, questionnaires) {
            state.bWaitCursor = true;
            state.questionnaires = questionnaires;

            if (state.newQuestionnaireID !== 0) {
                var i;
                for (i = 0; i < questionnaires.length; i++) {
                    if (state.newQuestionnaireID === questionnaires[i].id) {
                        state.selectedQuestionnaireIndex = i;
                        state.bSearchNewQuestionnaire = true;
                    }
                }
            }
            state.bWaitCursor = false;
        },

        setSelectedQuestionnaireIndex: (state, index) => {
            state.selectedQuestionnaireIndex = index;
        },

        setSearchNewQuestionnaire: (state, search) => {
            state.bSearchNewQuestionnaire = search;
        },

        setNewQuestionnaireID: (state, id) => {
            state.newQuestionnaireID = id;
        },

        setQuestionnaireNames(state, questionnaireNames) {
            state.bWaitCursor = true;
            state.questionnaireNames = questionnaireNames;
            state.bWaitCursor = false;
        },

        setQuestionnaireNameTable(state, questionnaireNameTable) {
            state.bWaitCursor = true;
            state.questionnaireNameTable = questionnaireNameTable;
            state.bWaitCursor = false;
        },

        setQuestionnaireTablesHeader(state, questionnaireHeader) {
            state.questionnaireTablesHeader = questionnaireHeader;
        },

        setQuestionnaireQuestionHeader(state, questionHeader) {
            state.questionnaireQuestionHeader = questionHeader;
        },

        setQuestionnaireSkills(state, skills) {
            state.bWaitCursor = true;
            state.questionnaireSkills = skills;
            state.bWaitCursor = false;
        },

        setQuestionnaireSkillsLang(state, questionnaireSkillsLang) {
            state.bWaitCursor = true;
            state.questionnaireSkillsLang = questionnaireSkillsLang;
            state.bWaitCursor = false;
        },

        setQuestionnaireQuestions(state, questionnaireQuestions) {
            state.bWaitCursor = true;
            state.questionnaireQuestions = questionnaireQuestions;
            state.bWaitCursor = false;
        },

        setQuestionnaireQuestionsLang(state, questionnaireQuestionsLang) {
            state.bWaitCursor = true;
            state.questionnaireQuestionsLang = questionnaireQuestionsLang;
            state.bWaitCursor = false;
        },

        setQuestionnaireGeneralAnswerSetID(state, answerSetID) {
            state.bWaitCursor = true;
            state.questionnaireGeneralAnswerSetID = answerSetID;
            state.bWaitCursor = false;
        },

        setQuestionnaireSkillTable(state, questionnaireSkillTable) {
            state.bWaitCursor = true;
            state.questionnaireSkillTable = questionnaireSkillTable;
            state.bWaitCursor = false;
        },

        setQuestionnaireQuestionTable(state, questionnaireQuestionTable) {
            state.bWaitCursor = true;
            state.questionnaireQuestionTable = questionnaireQuestionTable;
            state.bWaitCursor = false;
        },

        setQuestionnaireNotDeletedWarning(state, bWarning) {
            state.bQuestionnaireNotDeletedWarning = bWarning;
        },

        setSurveyQuestModulesTeams(state, modules) {
            state.bWaitCursor = true;
            state.surveyQuestModulesTeams = modules;
            state.bWaitCursor = false;
        },

        setSurveyQuestModulesCulture(state, modules) {
            state.bWaitCursor = true;
            state.surveyQuestModulesCulture = modules;
            state.bWaitCursor = false;
        },

        setSurveyQuestModulesIndex(state, modules) {
            state.bWaitCursor = true;
            state.surveyQuestModulesIndex = modules;
            state.bWaitCursor = false;
        },

        setSurveyQuestModulesLifeCircleDx(state, modules)
        {
            state.bWaitCursor = true;
            state.surveyQuestModulesLifeCircleDx = modules;
            state.bWaitCursor = false;
        },

        setSurveyQuestModulesLifeCircleDxLeadership(state, modules)
        {
            state.bWaitCursor = true;
            state.surveyQuestModulesLifeCircleDxLeadership = modules;
            state.bWaitCursor = false;
        },

        setServerResponse(state, bResponse) {
            state.bServerResponse = bResponse;
        },

        setSurveys(state, surveys) {
            state.bWaitCursor = true;
            state.surveys = surveys;

            state.surveysToDisplay = JSON.parse(JSON.stringify(state.surveys));

            if (state.newSurveyID !== 0) {
                var i;
                for (i = 0; i < surveys.length; i++) {
                    if (state.newSurveyID === surveys[i].encuestaID) {
                        state.selectedSurveyIndex = i;
                        state.bSearchNewSurvey = true;
                    }
                }
                state.newSurveyID = 0;
            }
            state.bWaitCursor = false;
        },

        setSurveysToDisplay(state, surveys) {
            state.bWaitCursor = true;
            state.surveysToDisplay = surveys;
            state.bWaitCursor = false;
        },

        setSurveyRolleLabels(state, surveyRolleLabels) {
            state.bWaitCursor = true;

            //Se inicializa la tabla para los alias de los roles:
            state.rolleLabelTable = [
                {
                    rolleID: 1,
                    objectName: 'autoretroalimentado',
                    rolle: 'Autoretroalimentado',
                    label: ''
                },
                {
                    rolleID: 2,
                    objectName: 'jefeDirecto',
                    rolle: 'Jefe Directo',
                    label: ''
                },
                {
                    rolleID: 3,
                    objectName: 'jefeFuncional',
                    rolle: 'Jefe Funcional',
                    label: ''
                },
                {
                    rolleID: 4,
                    objectName: 'colega',
                    rolle: 'Colega',
                    label: ''
                },
                {
                    rolleID: 5,
                    objectName: 'cliente',
                    rolle: 'Cliente/Proveedor Interno',
                    label: ''
                },
                {
                    rolleID: 6,
                    objectName: 'colaborador',
                    rolle: 'Colaborador',
                    label: ''
                }
            ];

            state.surveyUserTable = [];

            //console.log("surveyRolleLabels = ", surveyRolleLabels);

            //Si no sólo se va a inicializar la tabla, se llenan las etiquetas correspondientes:
            if (surveyRolleLabels.length !== 0) {
                var i;
                for (i = 0; i < state.rolleLabelTable.length; i++) {
                    if (state.rolleLabelTable[i].rolleID === 1) {
                        state.rolleLabelTable[i].label = surveyRolleLabels.autoretroalimentado;
                    } else if (state.rolleLabelTable[i].rolleID === 2) {
                        state.rolleLabelTable[i].label = surveyRolleLabels.jefeDirecto;
                    } else if (state.rolleLabelTable[i].rolleID === 3) {
                        state.rolleLabelTable[i].label = surveyRolleLabels.jefeFuncional;
                    } else if (state.rolleLabelTable[i].rolleID === 4) {
                        state.rolleLabelTable[i].label = surveyRolleLabels.colega;
                    } else if (state.rolleLabelTable[i].rolleID === 5) {
                        state.rolleLabelTable[i].label = surveyRolleLabels.cliente;
                    } else if (state.rolleLabelTable[i].rolleID === 6) {
                        state.rolleLabelTable[i].label = surveyRolleLabels.colaborador;
                    }
                }

                //Se crea el arreglo con el que se llena el select para asignar a los usuarios de una encuesta,
                //el cual tiene o el nombre origina del rol o su etiqueta:

                //console.log('state.rolleLabelTable = ', state.rolleLabelTable);

                var rolleLabels = [];
                for (i = 0; i < state.rolleLabelTable.length; i++) {
                    const rolle = {
                        rolleID: state.rolleLabelTable[i].rolleID,
                        label: ''
                    };

                    if (state.rolleLabelTable[i].label !== '') {
                        rolle.label = state.rolleLabelTable[i].label;
                    } else {
                        rolle.label = state.rolleLabelTable[i].rolle;
                    }

                    rolleLabels.push(rolle);
                }

                //Crea la tabla de los usuarios con las etiquetas correspondientes:
                var surveyUserTable = [];
                for (i = 0; i < state.survey.usuarios.length; i++) {
                    var user = {
                        usuarioID: state.survey.usuarios[i].usuarioID,
                        num: state.survey.usuarios[i].num,
                        nombre: state.survey.usuarios[i].nombre,
                        correo: state.survey.usuarios[i].correo,
                        rolID: state.survey.usuarios[i].rolID,
                        rol: '',
                        estado: state.survey.usuarios[i].estado,
                        password: state.survey.usuarios[i].password,
                        reporte: state.survey.usuarios[i].reporte
                    };

                    var j;
                    for (j = 0; j < rolleLabels.length; j++) {
                        if (rolleLabels[j].rolleID === user.rolID) {
                            user.rol = rolleLabels[j].label;
                            break;
                        }
                    }
                    surveyUserTable.push(user);
                }

                state.surveyRolleLabels = rolleLabels;
                state.surveyUserTable = surveyUserTable;
            }

            state.bWaitCursor = false;
        },

        setSelectedSurveyIndex: (state, index) => {
            state.selectedSurveyIndex = index;
        },

        setSearchNewSurvey: (state, search) => {
            state.bSearchNewSurvey = search;
        },

        setNewSurveyID: (state, id) => {
            state.newSurveyID = id;
            state.survey.encuestaID = id;
        },

        initSurveyData(state) {
            //Inicializa el modelo de una encuesta, antes de desplegar la ventana Encuestas:

            //console.log("initSurveyData...");
            state.survey = {
                encuestaID: 0,
                masivaID: 0,
                adminCreadorID: 0, //Creador (superadmin, o admin de prepago) (usuario logueado cuando se crea la encuesta)
                adminSegInternoID: 0, //Select, todos los usuarios que son admin. de seg. interno de la compañía seleccionada, es opcional.
                enviarReporte: '0', //0 = Sólo al usuario, 1 = al administrador de seguimiento interno, 2 a ambos, 3 a ninguno
                nombreEncuesta: '',
                evaluado: '',
                invitacionMandada: false,
                fechaRegistro: '',
                fechaInicio: '',
                fechaCierre: '',
                empresaID: 0,
                numRespuestas: 0,
                cuestionarioID: 0,
                idiomas: [],
                google360: false,
                mandarEstados: false,
                mandarEstadosDias: 0,
                mandarRecordatorios: false,
                mandarRecordatoriosDias: 0,
                textoInvitacion: '',
                alias: {
                    autoretroalimentado: '',
                    jefeDirecto: '',
                    jefeFuncional: '',
                    colega: '',
                    cliente: '',
                    colaborador: ''
                },
                usuarios: [],
                modulos: [],
                reporteEmail: '',
                usuariosCreados: false
            };
        },

        setSurveyData(state, survey) {
            state.survey = survey;
            //console.log('setSurvey, survey = ', state.survey);
        },

        setSurveyLoaded(state, bLoaded) {
            state.bSurveyLoaded = bLoaded;
        },

        setLoadingSurvey(state, bLoading) {
            state.bLoadingSurvey = bLoading;
        },

        setUserSurveys(state, surveys) {
            state.userSurveys = surveys;
        },

        setUserSurvey(state, survey) {
            state.userSurvey = survey;

            //Si la encuesta sólo tiene un idioma, éste se selecciona automáticamente y se redirecciona a la encuesta:
            // if (state.userSurvey.idiomas.length === 1) {
            //     state.userSurveyLangID = state.userSurvey.idiomas[0];
            //     router.push('/usersurvey').catch(err => { });
            // }
            // else  //Si la encuesta tiene más de un idioma, se pide seleccionar el idioma:
            //     if (state.userSurvey.idiomas.length > 1) {
            //         router.push('/selectsurveylang').catch(err => { });
            //     }
        },

        setUserSurveyLanguage(state, languageID) {
            state.userSurveyLangID = languageID;
            if (languageID === 1) {
                //Español
                i18n.locale = 'es';
            } else if (languageID === 2) {
                //Inglés
                i18n.locale = 'en';
            } else if (languageID === 3) {
                //Portugués
                i18n.locale = 'pt';
            } else if (languageID === 4) {
                //Alemán
                i18n.locale = 'de';
            }
        },

        setUserSurveyData(state, surveyData) {
            state.userSurveyData = surveyData;

            //Cuenta el número de preguntas de la encuesta, para poder calcular el porcentaje del avance:
            var numberOfQuestions = 0;
            var i;
            for (i = 0; i < surveyData.modulos.length; i++) {
                var j;
                for (j = 0; j < surveyData.modulos[i].gruposPreguntas.length; j++) {
                    var k;
                    for (
                        k = 0;
                        k < surveyData.modulos[i].gruposPreguntas[j].preguntas.length;
                        k++
                    ) {
                        numberOfQuestions++;

                        //Si la pregunta es de ordenamiento, ordena las respuestas con base en el campo 'respuesta':
                        if (surveyData.modulos[i].gruposPreguntas[j].preguntas[k].tipo === 3) {
                            console.log(
                                'Ordenando preguntas...',
                                surveyData.modulos[i].gruposPreguntas[j].preguntas[k].respuestas
                            );
                            surveyData.modulos[i].gruposPreguntas[j].preguntas[
                                k
                            ].respuestas = _.orderBy(
                                surveyData.modulos[i].gruposPreguntas[j].preguntas[k].respuestas,
                                'respuesta'
                            );
                            console.log(
                                'Preguntas ordenadas...',
                                surveyData.modulos[i].gruposPreguntas[j].preguntas[k].respuestas
                            );
                        }
                    }
                }
            }
            //console.log("Número de preguntas: ", numberOfQuestions);
            state.surveyNumQuestions = numberOfQuestions;
        },

        setSurveyCompany(state, company) {
            state.surveyCompany = company;
        },

        setShowThankYouDlg(state, bShow) {
            state.bShowThankYouDlg = bShow;
        },

        setLanguages(state, languages) {
            state.bWaitCursor = true;
            state.languages = languages;

            if (state.bSearchNewLanguage) {
                var i;
                for (i = 0; i < languages.length; i++) {
                    if (state.newLanguageName === languages[i].idioma) {
                        state.selectedLanguageIndex = i;
                        state.bSearchNewLanguage = false;
                        state.newLanguageName = '';
                    }
                }
            }
            state.bWaitCursor = false;
        },

        updateSelectedCompanyIndex: (state, index) => {
            state.selectedCompanyIndex = index;
        },

        updateSelectedLanguageIndex: (state, index) => {
            state.selectedLanguageIndex = index;
        },

        setUsers(state, users) {
            if (state.users !== null) {
                state.users.length = 0;
            }

            state.bWaitCursor = true;
            state.users = users;

            var i;
            for (i = 0; i < users.length; i++) {
                // const user = {
                //     name: users[i].apaterno + " " + users[i].amaterno + " " + users[i].nombre,
                //     id: users[i].usuariosid
                // };

                if (state.bSearchNewUser) {
                    if (state.newUserEmail === users[i].email) {
                        //console.log("Nuevo usuario identificado, ", users[i].email);
                        state.selectedUserIndex = i;
                        state.bSearchNewUser = false;
                        state.newUserEmail = '';
                    }
                }
            }
            state.bWaitCursor = false;
        },
        setAdministrators(state, users) {
            if (state.administrators !== null) {
                state.administrators.length = 0;
            }

            state.bWaitCursor = true;
            state.administrators = users;

            var i;
            for (i = 0; i < users.length; i++) {
                // const user = {
                //     name: users[i].apaterno + " " + users[i].amaterno + " " + users[i].nombre,
                //     id: users[i].usuariosid
                // };

                if (state.bSearchNewUser) {
                    if (state.newUserEmail === users[i].correo) {
                        //console.log("Nuevo usuario identificado, ", users[i].email);
                        state.selectedUserIndex = i;
                        state.bSearchNewUser = false;
                        state.newUserEmail = '';
                    }
                }
            }
            state.bWaitCursor = false;
        },
        addNewUser(state, newUser) {
            state.users.push(newUser);
        },
        addNewAdministrator(state, newUser) {
            state.administrators.push(newUser);
        },
        updateSelectedUserIndex: (state, index) => {
            state.selectedUserIndex = index;
        },

        //*Funciones ********************************************************************/
        setFunctionAssigned(state, payload) {
            state.bFunctionAssigned = payload;
        },

        setFunctionDuplicated(state, payload) {
            state.bFunctionDuplicated = payload;
        },

        setPrimaryFunctions(state, functions) {
            state.bWaitCursor = true;
            state.primaryFunctions = functions;
            state.bWaitCursor = false;
        },
        setPrimaryFunctionsVal(state, functions) {
            state.bWaitCursor = true;
            state.primaryFunctionsVal = functions;
            state.bWaitCursor = false;
        },
        setPrimaryFunctionsCompany(state, functions) {
            state.bWaitCursor = true;
            state.primaryFunctionsCompany = functions;
            state.bWaitCursor = false;
        },
        setSpecializedFunctions(state, functions) {
            state.bWaitCursor = true;
            state.bSpecialized = false;

            state.specializedFunctions = functions;
            if (state.specializedFunctions.length > 0) {
                state.bSpecialized = true;
            }
            state.bWaitCursor = false;
        },
        setSpecializedFunctionsVal(state, functions) {
            state.bWaitCursor = true;
            state.bSpecializedVal = false;

            state.specializedFunctionsVal = functions;
            if (state.specializedFunctionsVal.length > 0) {
                state.bSpecializedVal = true;
            }
            state.bWaitCursor = false;
        },
        setSpecializedFunctionsCompany(state, functions) {
            state.bWaitCursor = true;
            state.bSpecializedCompany = false;

            state.specializedFunctionsCompany = functions;
            if (state.specializedFunctionsCompany.length > 0) {
                state.bSpecializedCompany = true;
            }
            state.bWaitCursor = false;
        },
        setDisaggregatedFunctions(state, functions) {
            state.bWaitCursor = true;
            state.bDisaggregated = false;

            state.disaggregatedFunctions = functions;
            if (state.disaggregatedFunctions.length > 0) {
                state.bDisaggregated = true;
            }
            state.bWaitCursor = false;
        },
        setDisaggregatedFunctionsCompany(state, functions) {
            state.bWaitCursor = true;
            state.bDisaggregatedCompany = false;

            state.disaggregatedFunctionsCompany = functions;
            if (state.disaggregatedFunctionsCompany.length > 0) {
                state.bDisaggregatedCompany = true;
            }
            state.bWaitCursor = false;
        },
        setDisaggregatedFunctionsVal(state, functions) {
            state.bWaitCursor = true;
            state.bDisaggregatedVal = false;

            state.disaggregatedFunctionsVal = functions;
            if (state.disaggregatedFunctionsVal.length > 0) {
                state.bDisaggregatedVal = true;
            }
            state.bWaitCursor = false;
        },
        setCompanyFunctionsVal(state, companyFunctions) {
            state.bWaitCursor = true;
            state.companyFunctionsVal = companyFunctions;
            state.bWaitCursor = false;
        },
        setCompanyFunctions(state, companyFunctions) {
            state.bWaitCursor = true;
            state.companyFunctions = companyFunctions;
            state.bWaitCursor = false;
        },
        setFunctionsExtended(state, functions) {
            state.bWaitCursor = true;
            state.functionsExt = functions;
            state.bWaitCursor = false;
        },
        updateSelectedFunctionIndex: (state, index) => {
            state.selectedFunctionIndex = index;
        },
        updateSelectedPrimaryIndex: (state, index) => {
            state.selectedPrimaryIndex = index;
        },
        updateSelectedSpecializedIndex: (state, index) => {
            state.selectedSpecializedIndex = index;
        },
        updateSelectedDisaggregatedIndex: (state, index) => {
            state.selectedDisaggregatedIndex = index;
        },
        updateSelectedPrimaryValIndex: (state, index) => {
            state.selectedPrimaryValIndex = index;
        },
        updateSelectedSpecializedValIndex: (state, index) => {
            state.selectedSpecializedValIndex = index;
        },
        updateSelectedDisaggregatedValIndex: (state, index) => {
            state.selectedDisaggregatedValIndex = index;
        },
        updateSelectedPrimaryCompanyIndex: (state, index) => {
            state.selectedPrimaryCompanyIndex = index;
        },
        updateSelectedSpecializedCompanyIndex: (state, index) => {
            state.selectedSpecializedCompanyIndex = index;
        },
        updateSelectedDisaggregatedCompanyIndex: (state, index) => {
            state.selectedDisaggregatedCompanyIndex = index;
        },

        //*Roles ********************************************************************/
        setRoles(state, roles) {
            state.bWaitCursor = true;
            state.roles = roles;

            if (state.bSearchNewRole) {
                var i;
                for (i = 0; i < roles.length; i++) {
                    if (state.newRoleName === roles[i].rol) {
                        state.selectedRoleIndex = i;
                        state.bSearchNewRole = false;
                        state.newRoleName = '';
                    }
                }
            }
            state.bWaitCursor = false;
        },
        setRolesExtended(state, roles) {
            state.bWaitCursor = true;
            state.rolesExt = roles;
            state.bWaitCursor = false;
        },
        updateSelectedRoleIndex: (state, index) => {
            state.selectedRoleIndex = index;
        },
        initUserRoles(state, { userID, roles }) {
            //console.log("initUserRoles()");

            state.bWaitCursor = true;
            //state.userRoles = roles;

            //Agrega a state.roles el campo para el nombre personalizado:
            state.rolesExt = [];
            //var userID = roles[0].usuariosid; //Se obtiene el ID del usuario.
            var i;
            for (i = 0; i < state.roles.length; i++) {
                const rol = {
                    rolesid: state.roles[i].rolesid,
                    rol: state.roles[i].rol,
                    talento: state.roles[i].talento,
                    contribucion: state.roles[i].contribucion,
                    total: state.roles[i].total,
                    tamanoaplicacion: state.roles[i].tamanoaplicacion + '%',
                    factor1: state.roles[i].factor1,
                    factor2: state.roles[i].factor2,
                    nombre: state.roles[i].rol, //Se repite el nombre. Si está en userRoles se sobreescribe con el valor de ahí.
                    usuariosid: userID,
                    usuariosrolesid: 0 //Se llena más adelante.
                };
                state.rolesExt.push(rol);
            }

            //console.log("En inittUserRoles, roles = ", roles);

            //Crea el arreglo userRoles agregándole todos los campos del arreglo roles:

            state.userRoles = [];

            for (i = 0; i < roles.length; i++) {
                var j;
                for (j = 0; j < state.rolesExt.length; j++) {
                    if (roles[i].rolesid === state.rolesExt[j].rolesid) {
                        const rol = {
                            rolesid: state.rolesExt[j].rolesid,
                            rol: state.rolesExt[j].rol,
                            talento: state.rolesExt[j].talento,
                            contribucion: state.rolesExt[j].contribucion,
                            total: state.rolesExt[j].total,
                            tamanoaplicacion: state.rolesExt[j].tamanoaplicacion,
                            factor1: state.rolesExt[j].factor1,
                            factor2: state.rolesExt[j].factor2,
                            nombre: roles[i].nombre, //nombre personalizado
                            usuariosid: roles[i].usuariosid,
                            usuariosrolesid: roles[i].usuariosrolesid
                        };
                        state.userRoles.push(rol);

                        //Pone el nombre personalizado en el arreglo de todos los roles, en los registros que coinciden con los del
                        //arreglo de roles del usuario:
                        state.rolesExt[j].nombre = roles[i].nombre;
                        state.rolesExt[j].usuariosrolesid = roles[i].usuariosrolesid;
                        break;
                    }
                }
            }
            //console.log("userRoles = ", state.userRoles);
            //console.log("rolesExt = ", state.rolesExt);
            state.originalUserRoles = JSON.parse(JSON.stringify(state.userRoles));

            state.bWaitCursor = false;
        },
        setUserRoles(state, roles) {
            state.userRoles = roles;
        },
        restoreUserRoles(state) {
            state.userRoles = JSON.parse(JSON.stringify(state.originalUserRoles));
        },

        //*Unidades de Negocio ********************************************************************/
        setBusinessUnits(state, units) {
            state.bWaitCursor = true;
            state.businessUnits = units;

            if (state.bSearchNewBusinessUnit) {
                var i;
                for (i = 0; i < units.length; i++) {
                    if (state.newBusinessUnitName === units[i].nombre) {
                        state.selectedBusinessUnitIndex = i;
                        state.bSearchNewBusinessUnit = false;
                        state.newBusinessUnitName = '';
                    }
                }
            }
            state.bWaitCursor = false;
        },
        setBusinessUnitsExtended(state, units) {
            state.bWaitCursor = true;
            state.businessUnitsExt = units;
            state.bWaitCursor = false;
        },
        updateSelectedBusinessUnitIndex: (state, index) => {
            state.selectedBusinessUnitIndex = index;
        },
        initUserBusinessUnits(state, { userID, businessUnits }) {
            //console.log("initUserBusinessUnits()");

            state.bWaitCursor = true;

            //Agrega a state.businessUnits el campo para el nombre personalizado:
            state.businessUnitsExt = [];
            //var userID = businessUnits[0].usuariosid; //Se obtiene el ID del usuario.
            var i;
            for (i = 0; i < state.businessUnits.length; i++) {
                const businessUnit = {
                    unidadnegocioid: state.businessUnits[i].unidadnegocioid,
                    nombre: state.businessUnits[i].nombre,
                    nombreUsuario: state.businessUnits[i].nombre, //Se repite el nombre. Si está en userBusinessUnits se sobreescribe con el valor de ahí.
                    usuariosid: userID,
                    usuariosunidadesdenegocioid: 0 //Se llena más adelante
                };
                state.businessUnitsExt.push(businessUnit);
            }

            //console.log("En initUserBusinessUnits, businessUnits = ", state.businessUnits);
            //console.log("En initUserBusinessUnits, businessUnitsExt = ", state.businessUnitsExt);

            //Crea el arreglo userBusinessUnits agregándole todos los campos del arreglo businessUnits:

            state.userBusinessUnits = [];

            for (i = 0; i < businessUnits.length; i++) {
                var j;
                for (j = 0; j < state.businessUnitsExt.length; j++) {
                    if (
                        businessUnits[i].unidadnegocioid ===
                        state.businessUnitsExt[j].unidadnegocioid
                    ) {
                        const businessUnit = {
                            unidadnegocioid: state.businessUnitsExt[j].unidadnegocioid,
                            nombre: state.businessUnitsExt[j].nombre,
                            nombreUsuario: businessUnits[i].nombre, //nombre personalizado
                            usuariosid: businessUnits[i].usuariosid,
                            usuariosunidadesdenegocioid:
                                businessUnits[i].usuariosunidadesdenegocioid,
                            moneda: businessUnits[i].moneda,
                            ventas: businessUnits[i].ventas,
                            tamanio: businessUnits[i].tamanio
                        };
                        state.userBusinessUnits.push(businessUnit);

                        //Pone el nombre personalizado en el arreglo de todas las unidades de negocio, en los registros que coinciden con los del
                        //arreglo de unidades de negocio del usuario:
                        state.businessUnitsExt[j].nombreUsuario = businessUnits[i].nombre;
                        state.businessUnitsExt[j].usuariosunidadesdenegocioid =
                            businessUnits[i].usuariosunidadesdenegocioid;
                        break;
                    }
                }
            }
            //console.log("businessUnits recibidas = ", businessUnits);
            //console.log("userBusinessUnits = ", state.userBusinessUnits);
            //console.log("businessUnitsExt = ", state.businessUnitsExt);
            state.originalUserBusinessUnits = JSON.parse(JSON.stringify(state.userBusinessUnits));

            state.bWaitCursor = false;

            state.userBusinessUnitsFetched = true;
            //if (state.userFunctionsFetched && state.userRolesFetched && state.userBusinessUnitsFetched && state.userDepartmentsFetched) {
            if (
                state.userRolesFetched &&
                state.userBusinessUnitsFetched &&
                state.userDepartmentsFetched
            ) {
                state.userConfigOK = true;
            }
        },
        setUserBusinessUnits(state, businessUnits) {
            state.userBusinessUnits = businessUnits;
        },
        restoreUserBusinessUnits(state) {
            state.userBusinessUnits = JSON.parse(JSON.stringify(state.originalUserBusinessUnits));
        },
        setBusinessUnitForUser(state, businessUnit) {
            var bAssigned = false;
            if (businessUnit.usuariosunidadesdenegocioid !== 0) {
                bAssigned = true;
            }

            state.businessUnitForUser = {
                id: businessUnit.usuariosunidadesdenegocioid,
                name: businessUnit.nombre,
                bAssigned: bAssigned
            };
        },

        //*Direcciones ********************************************************************/
        setDepartments(state, departments) {
            state.bWaitCursor = true;
            state.departments = departments;

            //console.log("bSearchNewDepartment = ", state.bSearchNewDepartment);
            //console.log("newDepartmentName = ", state.newDepartmentName);

            if (state.bSearchNewDepartment) {
                var i;
                for (i = 0; i < departments.length; i++) {
                    if (state.newDepartmentName === departments[i].direccion) {
                        state.selectedDepartmentIndex = i;
                        state.bSearchNewDepartment = false;
                        state.newDepartmentName = '';
                    }
                }
            }
            state.bWaitCursor = false;
        },
        setDepartmentsExtended(state, departments) {
            state.bWaitCursor = true;
            state.departmentsExt = departments;
            state.bWaitCursor = false;
        },
        updateSelectedDepartmentIndex: (state, index) => {
            state.selectedDepartmentIndex = index;
        },
        initUserDepartments(state, { userID, departments }) {
            //console.log("InitUserDepartments, departments = ", departments);

            state.bWaitCursor = true;
            //state.userDepartments = departments;
            state.bWaitCursor = false;

            //Agrega a state.departments el campo para el nombre personalizado:
            state.departmentsExt = [];
            //var userID = departments[0].usuariosid; //Se obtiene el ID del usuario.
            var i;
            for (i = 0; i < state.departments.length; i++) {
                const department = {
                    direccionesid: state.departments[i].direccionesid,
                    direccion: state.departments[i].direccion,
                    nombreUsuario: state.departments[i].direccion, //Se repite el nombre. Si está en userDepartments se sobreescribe con el valor de ahí.
                    usuariosid: userID,
                    usuariosdireccionesid: 0 //Se llena más adelante.
                };
                state.departmentsExt.push(department);
            }

            //Crea el arreglo userDepartments agregándole todos los campos del arreglo departments:

            state.userDepartments = [];

            for (i = 0; i < departments.length; i++) {
                var j;
                for (j = 0; j < state.departmentsExt.length; j++) {
                    if (departments[i].direccionesid === state.departmentsExt[j].direccionesid) {
                        const department = {
                            direccionesid: state.departmentsExt[j].direccionesid,
                            direccion: state.departmentsExt[j].direccion,
                            nombreUsuario: departments[i].nombre, //nombre personalizado
                            usuariosid: departments[i].usuariosid,
                            usuariosdireccionesid: departments[i].usuariosdireccionesid
                        };
                        state.userDepartments.push(department);

                        //Pone el nombre personalizado en el arreglo de todas las direcciones, en los registros que coinciden con los del
                        //arreglo de direcciones del usuario:
                        state.departmentsExt[j].nombreUsuario = departments[i].nombre;
                        state.departmentsExt[j].usuariosdireccionesid =
                            departments[i].usuariosdireccionesid;
                        break;
                    }
                }
            }
            //console.log("direcciones recibidas = ", departments);
            //console.log("En initUserDep, userDepartments = ", state.userDepartments);
            //console.log("departmentsExt = ", state.departmentsExt);

            //Se copia el arreglo en un arreglo temporal, para poder revisar los cambios que se hagan:
            //state.originalUserFunctions = [...state.userFunctions]; //Para arreglos esto sólo copia la referencia.
            state.originalUserDepartments = JSON.parse(JSON.stringify(state.userDepartments));
        },
        setUserDepartments(state, departments) {
            state.userDepartments = departments;
        },
        restoreUserDepartments(state) {
            state.userDepartments = JSON.parse(JSON.stringify(state.originalUserDepartments));
        },
        setValFunction(state, functionID) {
            //functionID es empresasfuncionesid
            state.bWaitCursor = true;
            state.valFunctionID = functionID;
            var i;
            for (i = 0; i < state.companyFunctionsVal.length; i++) {
                if (state.companyFunctionsVal[i].funcionesid === functionID) {
                    //state.valFunctionName = state.companyFunctionsVal[i].nombreLargo;
                    state.valFunctionName = state.companyFunctionsVal[i].funcion;
                    break;
                }
            }
            state.bWaitCursor = false;
        },
        setValFunctionName(state, name) {
            state.valFunctionName = name;
        },
        setValFunctionID(state, id) {
            state.valFunctionID = id;
        },
        setSpecializedFunctionsToShow(state, payload) {
            state.specializedFunctionsToShow = payload;
        },
        setDisaggregatedFunctionsToShow(state, payload) {
            state.disaggregatedFunctionsToShow = payload;
        },
        setSpecializedFunctionsValToShow(state, payload) {
            state.specializedFunctionsValToShow = payload;
        },
        setDisaggregatedFunctionsValToShow(state, payload) {
            state.disaggregatedFunctionsValToShow = payload;
        },
        setSpecializedFunctionsCompanyToShow(state, payload) {
            state.specializedFunctionsCompanyToShow = payload;
        },
        setDisaggregatedFunctionsCompanyToShow(state, payload) {
            state.disaggregatedFunctionsCompanyToShow = payload;
        },
        setReportProcessed(state, payload) {
            state.bReportProcessed = payload;
        },
        setReportWarning(state, payload) {
            state.iReportWarning = payload;
        },
        setPdfPath(state, strPath) {
            state.pdfPath = strPath;
        },
        setExcelProcessed(state, payload) {
            state.bExcelProcessed = payload;
        },
        setExcelPath(state, strPath) {
            state.excelPath = strPath;
        },
        setBelbinReportProcessed(state, payload) {
            state.bBelbinReportProcessed = payload;
        },
        setBelbinReportPath(state, strPath) {
            state.belbinReportPath = strPath;
        },
        setSurveyNumQuestions(state, numQuestions) {
            state.surveyNumQuestions = numQuestions;
        },
        setSendUserSurveyError(state, bError) {
            state.bSendUserSurveyError = bError;
        },

        setSessionExpires(state, bExpires) {
            state.sessionExpires = bExpires;
        },

        setSessionTimeLeft(state, strTimeLeft) {
            state.sessionTimeLeft = strTimeLeft;
        },

        setSessionEnding(state, bEnding) {
            state.sessionEnding = bEnding;
        },

        setSessionEnded(state, bEnded) {
            state.sessionEnded = bEnded;
            state.sessionEnding = !bEnded;
        },

        setUserActivityLogs(state, payload) {
            state.userActivityLogs = payload;
        }
    },
    actions: {
        updateShowNuestrasHerramientasDxTx({ commit }, bShowDlg) {
            commit('setShowNuestrasHerramientasDxTx', bShowDlg);
        },
        updateShowComoFuncionaTxt({ commit }, bShowDlg) {
            commit('setShowComoFuncionaTxt', bShowDlg);
        },
        updateShowRecursosTxt({ commit }, bShowDlg)
        {
            commit('setShowRecursosTxt', bShowDlg);
        },
        updateShowDocumentosInteresTxt({ commit }, bShowDlg)
        {
            commit('setShowDocumentosInteresTxt', bShowDlg);
        },
        updateShowGuiaInterpretacionTxt({ commit }, bShowDlg) {
            commit('setShowGuiaInterpretacionTxt', bShowDlg);
        },
        updateShowContactoTxt({ commit }, bShowDlg) {
            commit('setShowContactoTxt', bShowDlg);
        },
        login({ commit, dispatch, state }, authData) {
            state.bWaitCursor = true;

            //pruebas Web Service Primero Seguros

            // let xmls='<soapenv:Envelope xmlns:soap="http://schemas.xmlsoap.org/wsdl/soap/"\
            //                 xmlns:web="http://ws.businessunits.primero.com/">\
            //             <soapenv:Header/>\
            //             <soapenv:Body>\
            //             <web:Colonias>\
            //                 <web:proveedor></web:proveedor>\
            //                 <web:usuario>PS3689</web:usuario>\
            //                 <web:password>4xm2S3kn</web:password>\
            //                 <web:cp>06140</web:cp>\
            //             </web:Colonias>\
            //             </soapenv:Body>\
            //         </soapenv:Envelope>';

            // axios.post('https://pruebas.primeroseguros.com/webservices/cotizador?wsdl',
            //         xmls,
            //         {headers:
            //             {'Content-Type': 'text/xml'}
            //         }).then(res=>{
            //             console.log("Respuesta de primero seguros...");
            //             console.log(res);
            //         }).catch(err=>{console.log(err)});

            //Fin pruebas web service Primero Seguros

            //Obtención de browser y sistema operativo:
            let userAgent = navigator.userAgent;
            let browserName;

            if (userAgent.match(/chrome|chromium|crios/i)) {
                browserName = 'Chrome';
            } else if (userAgent.match(/firefox|fxios/i)) {
                browserName = 'Firefox';
            } else if (userAgent.match(/safari/i)) {
                browserName = 'Safari';
            } else if (userAgent.match(/opr\//i)) {
                browserName = 'Opera';
            } else if (userAgent.match(/edg/i)) {
                browserName = 'Edge';
            } else {
                browserName = 'Browser no detectado';
            }

            console.log('browserName = ', browserName);

            var OSName = 'OS desconocido';
            if (navigator.userAgent.indexOf('Win') != -1) OSName = 'Windows';
            if (navigator.userAgent.indexOf('Mac') != -1) OSName = 'MacOS';
            if (navigator.userAgent.indexOf('Linux') != -1) OSName = 'Linux';
            if (navigator.userAgent.indexOf('Android') != -1) OSName = 'Android';
            if (navigator.userAgent.indexOf('like Mac') != -1) OSName = 'iOS';
            if (navigator.userAgent.indexOf('X11') != -1) OSName = 'UNIX';

            console.log('Your OS: ' + OSName);

            var ipAddress;

            fetch('https://api.ipify.org?format=json')
                .then(response => response.json())
                .then(data => {
                    ipAddress = data.ip;
                    console.log('data = ', data);
                    console.log('IP address = ', ipAddress);

                    //Autenticación en Jocoque:
                    axiosAuth
                        .post('/usuarios/login/', null, {
                            params: {
                                user: authData.email,
                                password: authData.password,
                                ip: ipAddress,
                                navegador: browserName,
                                so: OSName
                            }
                        })
                        .then(res => {
                            state.bWaitCursor = false;
                            console.log('Autenticación OK, res = ', res);

                            var user = res.data;
                            if (user.error === 0) {
                                var idToken = user.token.slice(7);

                                //axios.defaults.headers.common['Authorization'] = user.token;

                                commit('authUser', {
                                    //authHeader: user.token,
                                    idToken: idToken,
                                    userID: user.usuarioid
                                });

                                //console.log("state.idToken = ", state.idToken);
                                //console.log("state.authData = ", state.authHeader);

                                commit('setIsAuthenticated', true);
                                commit('setUser', user);

                                if (user.tipoid === 1 || user.tipoid === 2 || user.tipoid == 3) {
                                    //Carga todas las tablas de configuración:
                                    dispatch('fetchAdminConfigData');
                                } else if (user.tipoid === 4) {
                                    //Encuestado
                                    state.askToSelectSurvey = false;
                                    dispatch('fetchLanguages');
                                    dispatch('fetchUserSurveys');
                                }

                                const now = new Date();
                                const expirationDate = new Date(
                                    now.getTime() + res.data.expiresin * 1000
                                ); //Con getTime() se obtiene el tiempo en milisegundos
                                console.log('ExpirationDate = ', expirationDate);

                                //localStorage.setItem('authHeader', res.data.token)
                                //localStorage.setItem('token', res.data.idToken);
                                localStorage.setItem('token', idToken);
                                localStorage.setItem('userID', res.data.localId);
                                localStorage.setItem('expirationDate', expirationDate);
                                localStorage.setItem('userEmail', res.data.email);
                                dispatch('setLogoutTimer', res.data.expiresin);

                                state.bWaitCursor = false;
                                //router.push('/');

                                //Si el usuario no es encuestado, se redirecciona a home (si es encuestado, se redirecciona al lugar adecuado
                                //desde fetchUSerSurveys, según el número de encuestas que tenga asignadas):

                                if (user.tipoid === 1 || user.tipoid === 2 || user.tipoid == 3) {
                                    router.push('/').catch(err => {});
                                }
                            } else if (user.error === 3) {
                                //Usuario Inactivo...
                                state.bWaitCursor = false;
                                commit('setIsAuthenticated', false);
                                commit('setInactiveUser', true);
                            } else if (user.error === 4) {
                                //Usuario encuestado sin encuestas activas...
                                state.bWaitCursor = false;
                                commit('setIsAuthenticated', false);
                                commit('setUserWithNoSurveys', true);
                            } //Error en nombre de usuario o password...
                            else {
                                console.log('Error de autenticación #', user.error);
                                state.bWaitCursor = false;
                                //commit('clearAuthData');
                                commit('setIsAuthenticated', false);
                                commit('setFailedLogin', true);
                            }
                        })
                        .catch(error => {
                            console.log('Error de autenticación #0: ', error);
                            state.bWaitCursor = false;

                            //commit('clearAuthData');
                            commit('setIsAuthenticated', false);
                            commit('setFailedLogin', true);
                        });
                });
        },
        updateFailedLogin({ commit }, failedLogin) {
            commit('setFailedLogin', failedLogin);
        },
        updateInactiveUser({ commit }, inactiveUser) {
            commit('setInactiveUser', inactiveUser);
        },
        setLogoutTimer({ commit }, expirationTime) {
            setTimeout(() => {
                console.log('Llamando a clearAuthData desde setLogoutTimer');
                commit('clearAuthData');
                router.replace('/sign-in'); //Aparentemente es mejor replace que push porque con replace el usuario no puede irse hacia atrás.
            }, expirationTime * 1000);
        },
        logout({ commit, state }) {
            commit('setSessionEnded', true);
            axios.delete('/sesion/deleteSession/' + state.idToken); //Borra la sesión
            console.log('Llamando a clearAuthData desde logout');
            commit('clearAuthData');
            //localStorage.removeItem('authHeader');
            localStorage.removeItem('token');
            localStorage.removeItem('userID');
            localStorage.removeItem('expirationDate');
            localStorage.removeItem('userEmail');
            //router.replace('/sign-in');//Se supone que es mejor replace que push porque con replace el usuario no puede irse hacia atrás.
            router.replace('/sign-in').catch(err => {}); //Se supone que es mejor replace que push porque con replace el usuario no puede irse hacia atrás.
        },
        tryAutoLogin({ commit, dispatch }) {
            console.log('TryAutoLogin...');
            const token = localStorage.getItem('token');
            if (!token) {
                console.log('No hay token...');
                return;
            }

            const expirationDate = new Date(localStorage.getItem('expirationDate'));
            const now = new Date();

            if (now >= expirationDate) {
                console.log('Time has expired...');
                return;
            }
            const userID = localStorage.getItem('userID');
            this.commit('authUser', {
                //authHeader: authHeader,
                idToken: token,
                userID: userID
            });

            const userEmail = localStorage.getItem('userEmail');
            commit('setIsAuthenticated', true);

            //Carga al usuario logueado:
            dispatch('userAutoLogin', userEmail);

            router.push('/').catch(err => {});
        },
        userAutoLogin({ commit, dispatch, state }, email) {
            if (!state.idToken) {
                return;
            }

            axios
                .get('/usuarios/getByEmail/' + email + '/' + state.idToken, { crossDomain: true })
                .then(res => {
                    console.log('res de userAutoLogin: ', res);

                    //error 0 = No hay error.
                    if (res.data.error === 1) {
                        console.log('Error. Sesión no válida.');
                        dispatch('logout');
                    } else {
                        const user = res.data;
                        console.log('user = ', user);
                        commit('setUser', user);

                        if (
                            state.user.tipoid === 1 ||
                            state.user.tipoid === 2 ||
                            state.user.tipoid == 3
                        ) {
                            //Carga todas las tablas de configuración:
                            dispatch('fetchAdminConfigData');
                        } else if (state.user.tipoid === 4) {
                            //Encuestado
                            dispatch('fetchLanguages');
                            dispatch('fetchUserSurveys');
                        }
                    }
                })
                .catch(error => {
                    alert('Error en login: ' + error);
                    console.log('Error en login: ', error);
                    dispatch('logout');
                });
        },

        fetchAdminConfigData({ dispatch, state }) {
            if (!state.idToken) {
                return;
            }

            dispatch('fetchUserTypes');
            dispatch('fetchQuestionnaires');
            dispatch('fetchSurveyQuestModulesTeams');
            dispatch('fetchSurveyQuestModulesCulture');
            dispatch('fetchSurveyQuestModulesIndex');
            dispatch('fetchSurveyQuestModulesLifeCircleDx');
            dispatch('fetchSurveyQuestModulesLifeCircleDxLeadership');
            dispatch('fetchAnswerSets');

            dispatch('fetchCompanies');
            dispatch('fetchLanguages');
            dispatch('fetchUsers');

            dispatch('fetchSurveys');
        },

        updateUserWithNoSurveys({ commit }, bNoSurveys) {
            commit('setUserWithNoSurveys', bNoSurveys);
        },

        updateUserWithNoPendingSurveys({ commit }, bNoPendingSurveys) {
            commit('setUserWithNoPendingSurveys', bNoPendingSurveys);
        },

        fetchUserSurveys({ dispatch, state }) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;

            // var surveys = [
            //     {
            //         encuestaID: 956,
            //         nombreEncuesta: "Encuesta de Prueba 1"
            //     },
            //     {
            //         encuestaID: 1,
            //         nombreEncuesta: "Encuesta de Prueba 2"
            //     },
            // ]

            axios
                .get('/usuarios/getEncuestasUsuario/' + state.userID + '/' + state.idToken, {
                    crossDomain: true
                })
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('fetchUserSurveys, res = ', res);
                    const surveys = res.data;
                    //Primero se checa si el usuario tiene por lo menos una encuesta activa. Si no tiene encuestas activas,
                    //el servidor devuelve un arreglo con un solo elemento con el campo error = 2:
                    // if ((surveys.length === 1) && (surveys[0].error === 2)) {
                    //     //El usuario no tiene encuestas activas...
                    //     state.bUserWithNoSurveys = true;
                    // }
                    // else
                    //     //Si el usuario tiene una sola encuesta pero ya la contestó,
                    //     //el servidor devuelve un arreglo con un solo elemento con el campo error = 3:
                    //     if ((surveys.length === 1) && (surveys[0].error === 3)) {
                    //         state.bUserWithNoPendingSurveys = true;
                    //     }
                    //     else {
                    console.log('userSurveys = ', surveys);
                    dispatch('updateUserSurveys', surveys);
                    // }
                })
                .catch(error => {
                    console.log('Error en FetchSurveys, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        updateUserSurveys({ dispatch, commit, state }, userSurveys) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;

            commit('setUserSurveys', userSurveys);

            //Si sólo hay una encuesta, y el usuario logueado no tenía originalmente más que una encuesta, ésta se selecciona automáticamente:
            if (userSurveys.length === 1 && !state.askToSelectSurvey) {
                dispatch('updateUserSurvey', userSurveys[0]);

                //Si la encuesta sólo tiene un idioma, éste se selecciona automáticamente y se redirecciona a la encuesta:
                if (userSurveys[0].idiomas.length === 1) {
                    dispatch('updateUserSurveyLanguage', userSurveys[0].idiomas[0]);
                } //Si la encuesta tiene más de un idioma, se pide seleccionar el idioma:
                else {
                    router.push('/selectsurveylang').catch(err => {});
                }
            } //Si hay más de una encuesta, se pide seleccionar la encuesta:
            //else if (userSurveys.length > 1) {
            else {
                //Si hay más de una encuesta, o el usuario originalmente tenía más de una, se muestra
                //la ventana para seleccionar encuesta. Si el usuario tenía más de una, aunque ya sólo le quede
                //una esto se hace para que en la última encuesta quede claro que se está comenzando una nueva.
                router.push('/surveyselection').catch(err => {});
            }
            state.bWaitCursor = false;
        },

        updateUserSurvey({ commit }, userSurvey) {
            commit('setUserSurvey', userSurvey);
        },

        getUserSurvey({ dispatch, state }, surveyID) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;

            axios
                .get('/encuestas/getEncuestasById/' + surveyID + '/' + state.idToken, {
                    crossDomain: true
                })
                .then(res => {
                    //console.log('getUserSurvey, res = ', res);
                    const survey = res.data;
                    if (survey.encuestaID !== 0) {
                        console.log('En getUserSurvey, userSurvey = ', survey);
                        dispatch('updateUserSurvey', survey);

                        //Si la encuesta sólo tiene un idioma, éste se selecciona automáticamente y se redirecciona a la encuesta:
                        if (survey.idiomas.length === 1) {
                            dispatch('updateUserSurveyLanguage', survey.idiomas[0]);
                        } //Si la encuesta tiene más de un idioma, se pide seleccionar el idioma:
                        else {
                            router.push('/selectsurveylang').catch(err => {});
                        }
                    }

                    state.bWaitCursor = false;
                })
                .catch(error => {
                    console.log('Error en getUserSurvey, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        updateUserSurveyLanguage({ commit, dispatch }, languageID) {
            //console.log("updateUserSurveyLanguage, languageID = ", languageID);
            commit('setUserSurveyLanguage', languageID);

            //Se obtiene la información de la encuesta (preguntas, sets de respuestas, etc.):
            dispatch('getUserSurveyData');
        },

        updateShowThankYouDlg({ commit }, bShow) {
            commit('setShowThankYouDlg', bShow);
        },

        testExit({ state }) {
            axios
                .get('/roles/getRoles/' + state.idToken, { crossDomain: true })
                .then(res => {
                    console.log('getRoles, res = ', res);
                })
                .catch(error => {
                    console.log('Error en getRoles, error = ', error);
                });
        },

        getUserSurveyData({ dispatch, state }) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;

            //Tipos de preguntas:
            //Tipo 1 = Opción múltiple
            //Tipo 2 = Respuestas etiquetadas como "alternativas"
            //Tipo 3 = Ordenamiento
            //Tipo 4 = Texto libre
            //Tipo 5 = Selección múltiple
            //Tipo 6 = Diagnóstico círculo de vida

            //Inicio pruebas: ***********************************************************************************************
            
            /*var surveyData = {
                evaluado: 'María Tortolero',
                usuarioID: 1,
                empresaID: 1,
                intro:
                    'Bienvenido a la Encuesta de Retroalimentación 360° de Equipos.\\n\\n Andrés Tortolero te ha invitado a brindar tu retroalimentación con respecto a diferentes aspectos de la dinámica y funcionamiento del equipo conformado por las siguientes personas:\\nAl dar tu retroalimentación, recuerda que esta encuesta evalúa el funcionamiento y la dinámica del EQUIPO definido y NO a un integrante en particular.\\\nMuchas Gracias por tu participación en este proceso!',
                modulos: [
                    {
                        numModulo: 1,
                        tituloModulo: 'Módulo 1',
                        gruposPreguntas: [
                            {
                                numGrupo: 1,
                                tituloGrupo: 'Grupo 1 del Módulo 1',
                                preguntas: [
                                    {
                                        numPregunta: 1,
                                        preguntaID: 1,
                                        numGral: 1,
                                        pregunta:
                                            'A continuación le pedimos que seleccione de las 7 competencias presentadas, las 3 que considere más relevantes para un mejor desempeño del ejecutivo:',
                                        tipo: 5, //Selección múltiple
                                        respuestaUsuario: 0,
                                        respuestas: [
                                            {
                                                num: 1,
                                                texto: 'Manejo de sí mismo(a)',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 2,
                                                texto: 'Resultados',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 3,
                                                texto: 'Pensamiento estratégico',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 4,
                                                texto: 'Manejo del cambio',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 5,
                                                texto: 'Liderazgo del equipo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 6,
                                                texto: 'Colaboración de mpacto',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: 'Tooltip de prueba'
                                            },
                                            {
                                                num: 7,
                                                texto: 'Desarrollo de talento',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            }
                                        ]
                                    },
                                    {
                                        numPregunta: 2,
                                        preguntaID: 2,
                                        numGral: 2,
                                        pregunta:
                                            'Las decisiones y acciones cotidianas del Ejecutivo están encaminadas al logro de su visión de empresa.',
                                        tipo: 1, //Opción múltiple
                                        respuestas: [
                                            {
                                                num: 1,
                                                texto: 'Totalmente en desacuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: 'Tooltip de respuesta 1'
                                            },
                                            {
                                                num: 2,
                                                texto: 'Parcialmente en desacuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: 'Tooltip de respuesta 2'
                                            },
                                            {
                                                num: 3,
                                                texto: 'Parcialmente de acuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 4,
                                                texto: 'Totalmente de acuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 5,
                                                texto: 'No sé',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            }
                                        ]
                                    },
                                    {
                                        numPregunta: 3,
                                        preguntaID: 3,
                                        numGral: 3,
                                        pregunta:
                                            'La presentación de excusas ante la falta de resultados es una práctica poco común en el equipo.',
                                        tipo: 1, //Opción múltiple
                                        respuestas: [
                                            {
                                                num: 1,
                                                texto: 'Totalmente en desacuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 2,
                                                texto: 'Parcialmente en desacuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 3,
                                                texto: 'Parcialmente de acuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 4,
                                                texto: 'Totalmente de acuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 5,
                                                texto: 'No sé',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            }
                                        ]
                                    },
                                    {
                                        numPregunta: 4,
                                        preguntaID: 4,
                                        numGral: 4,
                                        pregunta:
                                            'El equipo admite sus errores y conoce sus áreas de oportunidad como equipo.',
                                        tipo: 1, //Opción múltiple
                                        respuestas: [
                                            {
                                                num: 1,
                                                texto: 'Totalmente en desacuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 2,
                                                texto: 'Parcialmente en desacuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 3,
                                                texto: 'Parcialmente de acuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 4,
                                                texto: 'Totalmente de acuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 5,
                                                texto: 'No sé',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            }
                                        ]
                                    },
                                    {
                                        numPregunta: 5,
                                        preguntaID: 5,
                                        numGral: 5,
                                        pregunta:
                                            "Los indicadores clave (KPI's) del equipo son aceptados por todos sus miembros y se monitorean continuamente.",
                                        tipo: 1, //Opción múltiple
                                        respuestas: [
                                            {
                                                num: 1,
                                                texto: 'Totalmente en desacuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 2,
                                                texto: 'Parcialmente en desacuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 3,
                                                texto: 'Parcialmente de acuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 4,
                                                texto: 'Totalmente de acuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 5,
                                                texto: 'No sé',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            }
                                        ]
                                    },
                                    {
                                        numPregunta: 6,
                                        preguntaID: 6,
                                        numGral: 6,
                                        pregunta:
                                            'Los miembros del equipo invierten poco tiempo en la búsqueda de culpables y mucho tiempo en la búsqueda de soluciones.',
                                        tipo: 1, //Opción múltiple
                                        respuestas: [
                                            {
                                                num: 1,
                                                texto: 'Totalmente en desacuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 2,
                                                texto: 'Parcialmente en desacuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 3,
                                                texto: 'Parcialmente de acuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 4,
                                                texto: 'Totalmente de acuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 5,
                                                texto: 'No sé',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            }
                                        ]
                                    },
                                    {
                                        numPregunta: 7,
                                        preguntaID: 7,
                                        numGral: 7,
                                        pregunta:
                                            'Las discusiones sobre un tema siempre se desarrollan en un ambiente respetuoso y profesional.',
                                        tipo: 1, //Opción múltiple
                                        respuestas: [
                                            {
                                                num: 1,
                                                texto: 'Totalmente en desacuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 2,
                                                texto: 'Parcialmente en desacuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 3,
                                                texto: 'Parcialmente de acuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 4,
                                                texto: 'Totalmente de acuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 5,
                                                texto: 'No sé',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                numGrupo: 2,
                                tituloGrupo: 'Grupo 2 del Módulo 1',
                                preguntas: [
                                    {
                                        numPregunta: 1,
                                        preguntaID: 8,
                                        numGral: 8,
                                        pregunta: 'Pregunta 1 del grupo de preguntas 2, módulo 1.',
                                        tipo: 1, //Opción múltiple
                                        respuestas: [
                                            {
                                                num: 1,
                                                texto: 'Totalmente en desacuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 2,
                                                texto: 'Parcialmente en desacuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 3,
                                                texto: 'Parcialmente de acuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 4,
                                                texto: 'Totalmente de acuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 5,
                                                texto: 'No sé',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            }
                                        ]
                                    },
                                    {
                                        numPregunta: 2,
                                        preguntaID: 9,
                                        numGral: 9,
                                        pregunta: 'Ésta es la pregunta 2 del grupo 2 del módulo 1.',
                                        tipo: 1, //Opción múltiple
                                        respuestas: [
                                            {
                                                num: 1,
                                                texto: 'Totalmente en desacuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 2,
                                                texto: 'Parcialmente en desacuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 3,
                                                texto: 'Parcialmente de acuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 4,
                                                texto: 'Totalmente de acuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 5,
                                                texto: 'No sé',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            }
                                        ]
                                    },
                                    {
                                        numPregunta: 3,
                                        preguntaID: 10,
                                        numGral: 10,
                                        pregunta: 'Pregunta 3',
                                        tipo: 1, //Opción múltiple
                                        respuestas: [
                                            {
                                                num: 1,
                                                texto: 'Totalmente en desacuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 2,
                                                texto: 'Parcialmente en desacuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 3,
                                                texto: 'Parcialmente de acuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 4,
                                                texto: 'Totalmente de acuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 5,
                                                texto: 'No sé',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }, //Fin módulo 1
                    {
                        numModulo: 2,
                        tituloModulo: 'Módulo 2',
                        gruposPreguntas: [
                            {
                                numGrupo: 1,
                                tituloGrupo: '',
                                preguntas: [
                                    {
                                        numPregunta: 1,
                                        preguntaID: 11,
                                        numGral: 11,
                                        pregunta:
                                            'Indica cuál de los siguientes grupos de comportamientos caracterizan mejor el accionar de tu equipo:',
                                        tipo: 2, //Respuestas etiquetadas como "alternativas"
                                        respuestas: [
                                            {
                                                num: 1,
                                                texto:
                                                    '- Misión y objetivos claros.\\n- Objetivos individuales claros.\\nConfianza mutua y apoyo\\nConfianza mutua y apoyo.\\n- Excelente comunicación.\\n- Feedback presente en lo cotidiano.\\n- Cultura de "No Culpabilidad".\\n- Reuniones Efectivas.',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 2,
                                                texto:
                                                    'Comportamiento cauteloso.\\n- Falta de claridad con respecto a los roles y las metas.\\n- Muchas preguntas.\\n- Deseo de aceptación.\\n- No hay sentido de urgencia.\\n- El camino por delante puede parecer "nebuloso".',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }, //Fin módulo 2
                    {
                        numModulo: 3,
                        tituloModulo: 'Módulo 3',
                        gruposPreguntas: [
                            {
                                numGrupo: 1,
                                tituloGrupo: 'Grupo 1 del Módulo 3',
                                preguntas: [
                                    {
                                        numPregunta: 1,
                                        preguntaID: 12,
                                        numGral: 12,
                                        pregunta:
                                            'Ordena los motivos por los que permaneces en la organización, poniendo hasta arriba el más importante y hasta abajo el menos importante:',
                                        tipo: 3, //Ordenamiento
                                        respuestas: [
                                            {
                                                num: 1,
                                                texto: 'El salario que me pagan',
                                                valor: 0,
                                                respuesta: '1',
                                                tooltip: null
                                            },
                                            {
                                                num: 2,
                                                texto: 'Las prestaciones y beneficios que recibo',
                                                valor: 0,
                                                respuesta: '2',
                                                tooltip: null
                                            },
                                            {
                                                num: 3,
                                                texto:
                                                    'Mi balance de vida - trabajo (vacaciones, duración de la jornada, etc.)',
                                                valor: 0,
                                                respuesta: '3',
                                                tooltip: null
                                            },
                                            {
                                                num: 4,
                                                texto: 'La relación con mi supervisor directo',
                                                valor: 0,
                                                respuesta: '4',
                                                tooltip: null
                                            },
                                            {
                                                num: 5,
                                                texto:
                                                    'El ambiente físico donde trabajo (oficinas, áreas recreativas, comedores, etc.)',
                                                valor: 0,
                                                respuesta: '5',
                                                tooltip: null
                                            }
                                        ]
                                    },
                                    {
                                        numPregunta: 2,
                                        preguntaID: 13,
                                        numGral: 13,
                                        pregunta:
                                            'Ordena los motivos por los que considerarías opciones laborales fuera de la organización, poniendo hasta arriba el más importante y hasta abajo el menos importante',
                                        tipo: 3, //Ordenamiento
                                        respuestas: [
                                            {
                                                num: 1,
                                                texto:
                                                    'El salario que me pagan me resulta insatisfactorio',
                                                valor: 5,
                                                respuesta: '1',
                                                tooltip: null
                                            },
                                            {
                                                num: 2,
                                                texto:
                                                    'Las prestaciones y beneficios que recibo no me son atractivos',
                                                valor: 4,
                                                respuesta: '2',
                                                tooltip: null
                                            },
                                            {
                                                num: 3,
                                                texto:
                                                    'Mal balance de vida - trabajo (vacaciones, duración de la jornada, etc.)',
                                                valor: 3,
                                                respuesta: '3',
                                                tooltip: null
                                            },
                                            {
                                                num: 4,
                                                texto:
                                                    'Insatisfactoria la relación con mi supervisor directo',
                                                valor: 2,
                                                respuesta: '4',
                                                tooltip: null
                                            },
                                            {
                                                num: 5,
                                                texto:
                                                    'El ambiente físico donde trabajo no me gusta(oficinas, áreas recreativas, comedores, etc.)',
                                                valor: 1,
                                                respuesta: '5',
                                                tooltip: null
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                numGrupo: 2,
                                tituloGrupo:
                                    'Mi nivel de satisfacción actual con los siguientes elementos:',
                                preguntas: [
                                    {
                                        numPregunta: 1,
                                        preguntaID: 14,
                                        numGral: 14,
                                        pregunta: 'Mi balance actual de vida - trabajo es bueno',
                                        tipo: 1, //Opción múltiple
                                        respuestas: [
                                            {
                                                num: 1,
                                                texto: 'Totalmente en desacuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 2,
                                                texto: 'Parcialmente en desacuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 3,
                                                texto: 'Parcialmente de acuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 4,
                                                texto: 'Totalmente de acuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 5,
                                                texto: 'No sé',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            }
                                        ]
                                    },
                                    {
                                        numPregunta: 2,
                                        preguntaID: 15,
                                        numGral: 15,
                                        pregunta: 'Mi balance actual de vida - trabajo es malo',
                                        tipo: 1, //Opción múltiple
                                        respuestas: [
                                            {
                                                num: 1,
                                                texto: 'Totalmente en desacuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 2,
                                                texto: 'Parcialmente en desacuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 3,
                                                texto: 'Parcialmente de acuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 4,
                                                texto: 'Totalmente de acuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 5,
                                                texto: 'No sé',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }, //Fin del módulo 3
                    {
                        numModulo: 4,
                        tituloModulo: 'Módulo 4',
                        gruposPreguntas: [
                            {
                                numGrupo: 1,
                                tituloGrupo: 'Grupo 1 del Módulo 4',
                                preguntas: [
                                    {
                                        numPregunta: 1,
                                        preguntaID: 16,
                                        numGral: 16,
                                        pregunta:
                                            '¿Qué crees que impide al equipo alcanzar su pleno potencial?',
                                        tipo: 4, //Texto libre
                                        respuestas: [
                                            {
                                                num: 1,
                                                texto: '',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            }
                                        ]
                                    },
                                    {
                                        numPregunta: 2,
                                        preguntaID: 17,
                                        numGral: 17,
                                        pregunta:
                                            '¿Cómo describirías las interacciones entre los miembros del equipo?',
                                        tipo: 4, //Texto libre
                                        respuestas: [
                                            {
                                                num: 1,
                                                texto: '',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            }
                                        ]
                                    },
                                    {
                                        numPregunta: 3,
                                        preguntaID: 18,
                                        numGral: 18,
                                        pregunta: '¿Cómo se toman las decisiones en el equipo?',
                                        tipo: 4, //Texto libre
                                        respuestas: [
                                            {
                                                num: 1,
                                                texto: '',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }, //Fin módulo 4
                    {
                        numModulo: 5,
                        tituloModulo:
                            'Para terminar, ayúdenos a contestar esta evaluación de 360 de Google: Andrés',
                        gruposPreguntas: [
                            {
                                numGrupo: 1,
                                tituloGrupo: 'Grupo 1 del Módulo 5',
                                preguntas: [
                                    {
                                        numPregunta: 1,
                                        preguntaID: 19,
                                        numGral: 19,
                                        pregunta:
                                            'Mi líder me da retroalimentación práctica que me ayudan a mejorar mi desempeño.',
                                        tipo: 1,
                                        respuestas: [
                                            {
                                                num: 1,
                                                texto: 'Totalmente en desacuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 2,
                                                texto: 'Parcialmente en desacuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 3,
                                                texto: 'Parcialmente de acuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 4,
                                                texto: 'Totalmente de acuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 5,
                                                texto: 'No sé',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            }
                                        ]
                                    },
                                    {
                                        numPregunta: 2,
                                        preguntaID: 20,
                                        numGral: 20,
                                        pregunta:
                                            'Mi líder no hace "supervisión demasiado estrecha" (involucrarse en detalles que deben manejarse en otros niveles).',
                                        tipo: 1,
                                        respuestas: [
                                            {
                                                num: 1,
                                                texto: 'Totalmente en desacuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 2,
                                                texto: 'Parcialmente en desacuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 3,
                                                texto: 'Parcialmente de acuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 4,
                                                texto: 'Totalmente de acuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 5,
                                                texto: 'No sé',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            }
                                        ]
                                    },
                                    {
                                        numPregunta: 3,
                                        preguntaID: 21,
                                        numGral: 21,
                                        pregunta: 'Comentarios:',
                                        tipo: 4,
                                        respuestas: [
                                            {
                                                num: 1,
                                                texto: '',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                numGrupo: 2,
                                tituloGrupo: 'Grupo 2 del Módulo 5',
                                preguntas: [
                                    {
                                        numPregunta: 1,
                                        preguntaID: 22,
                                        numGral: 22,
                                        pregunta:
                                            '¿Qué crees que impide al equipo alcanzar su pleno potencial?',
                                        tipo: 4, //Texto libre
                                        respuestas: [
                                            {
                                                num: 1,
                                                texto: '',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            }
                                        ]
                                    },
                                    {
                                        numPregunta: 2,
                                        preguntaID: 23,
                                        numGral: 23,
                                        pregunta:
                                            '¿Cómo describirías las interacciones entre los miembros del equipo?',
                                        tipo: 4, //Texto libre
                                        respuestas: [
                                            {
                                                num: 1,
                                                texto: 'Las interacciones son regulares.',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            }
                                        ]
                                    },
                                    {
                                        numPregunta: 3,
                                        preguntaID: 24,
                                        numGral: 24,
                                        pregunta:
                                            '¿Cómo describirías las interacciones entre los miembros de todos los equipos?',
                                        tipo: 4, //Texto libre
                                        respuestas: [
                                            {
                                                num: 1,
                                                texto: '',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            }
                                        ]
                                    },
                                    {
                                        numPregunta: 4,
                                        preguntaID: 25,
                                        numGral: 25,
                                        pregunta: 'Este cuestionario es muy largo.',
                                        tipo: 1,
                                        respuestas: [
                                            {
                                                num: 1,
                                                texto: 'Totalmente en desacuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 2,
                                                texto: 'Parcialmente en desacuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 3,
                                                texto: 'Parcialmente de acuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 4,
                                                texto: 'Totalmente de acuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 5,
                                                texto: 'No sé',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            }
                                        ]
                                    },
                                    {
                                        numPregunta: 5,
                                        preguntaID: 26,
                                        numGral: 26,
                                        pregunta:
                                            '¿Cómo te sientes al haber contestado este cuestionario?',
                                        tipo: 4,
                                        respuestas: [
                                            {
                                                num: 1,
                                                texto: '',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            }
                                        ]
                                    },
                                    {
                                        numPregunta: 6,
                                        preguntaID: 27,
                                        numGral: 27,
                                        pregunta: 'Cuéntanos una historia pequeña.',
                                        tipo: 4,
                                        respuestas: [
                                            {
                                                num: 1,
                                                texto: '',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            }
                                        ]
                                    },
                                    {
                                        numPregunta: 7,
                                        preguntaID: 28,
                                        numGral: 28,
                                        pregunta: 'Comentarios Finales 1:',
                                        tipo: 4,
                                        respuestas: [
                                            {
                                                num: 1,
                                                texto: '',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            }
                                        ]
                                    },
                                    {
                                        numPregunta: 8,
                                        preguntaID: 29,
                                        numGral: 29,
                                        pregunta: 'Comentarios Finales 2:',
                                        tipo: 4,
                                        respuestas: [
                                            {
                                                num: 1,
                                                texto: '',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            }
                                        ]
                                    },
                                    {
                                        numPregunta: 9,
                                        preguntaID: 30,
                                        numGral: 30,
                                        pregunta: 'Comentarios Finales 3:',
                                        tipo: 4,
                                        respuestas: [
                                            {
                                                num: 1,
                                                texto: '',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            }
                                        ]
                                    },
                                    {
                                        numPregunta: 10,
                                        preguntaID: 31,
                                        numGral: 31,
                                        pregunta: 'Comentarios Finales 4:',
                                        tipo: 4,
                                        respuestas: [
                                            {
                                                num: 1,
                                                texto: '',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            }
                                        ]
                                    },
                                    {
                                        numPregunta: 11,
                                        preguntaID: 32,
                                        numGral: 32,
                                        pregunta: 'Comentarios Finales 5:',
                                        tipo: 4,
                                        respuestas: [
                                            {
                                                num: 1,
                                                texto: '',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            }
                                        ]
                                    },
                                    {
                                        numPregunta: 12,
                                        preguntaID: 33,
                                        numGral: 33,
                                        pregunta: 'Comentarios Finales 6:',
                                        tipo: 4,
                                        respuestas: [
                                            {
                                                num: 1,
                                                texto: '',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            }
                                        ]
                                    },
                                    {
                                        numPregunta: 13,
                                        preguntaID: 34,
                                        numGral: 34,
                                        pregunta: 'Esta encuesta resultó sumamente larga',
                                        tipo: 1, //Opción múltiple
                                        respuestas: [
                                            {
                                                num: 1,
                                                texto: 'Totalmente en desacuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 2,
                                                texto: 'Parcialmente en desacuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 3,
                                                texto: 'Parcialmente de acuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 4,
                                                texto: 'Totalmente de acuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 5,
                                                texto: 'No sé',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            }
                                        ]
                                    },
                                    {
                                        numPregunta: 14,
                                        preguntaID: 35,
                                        numGral: 35,
                                        pregunta: 'Últimos Comentarios Finales:',
                                        tipo: 4,
                                        respuestas: [
                                            {
                                                num: 1,
                                                texto: '',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }, //Fin Módulo 5
                    {
                        numModulo: 6,
                        tituloModulo: '',
                        evaluarSubordinados: 1,
                        //subordinados: 0,
                        gruposPreguntas: [
                            {
                                numGrupo: 1,
                                tituloGrupo: 'Grupo 1 del Módulo 6',
                                preguntas: [
                                    {
                                        numPregunta: 1,
                                        preguntaID: 36,
                                        numGral: 36,
                                        pregunta:
                                            'XXX me da retroalimentación práctica que me ayudan a mejorar mi desempeño.',
                                        tipo: 1,
                                        respuestas: [
                                            {
                                                num: 1,
                                                texto: 'Totalmente en desacuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 2,
                                                texto: 'Parcialmente en desacuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 3,
                                                texto: 'Parcialmente de acuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 4,
                                                texto: 'Totalmente de acuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 5,
                                                texto: 'No sé',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            }
                                        ]
                                    },
                                    {
                                        numPregunta: 2,
                                        preguntaID: 37,
                                        numGral: 37,
                                        pregunta:
                                            'XXX no hace "supervisión demasiado estrecha" (involucrarse en detalles que deben manejarse en otros niveles).',
                                        tipo: 1,
                                        respuestas: [
                                            {
                                                num: 1,
                                                texto: 'Totalmente en desacuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 2,
                                                texto: 'Parcialmente en desacuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 3,
                                                texto: 'Parcialmente de acuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 4,
                                                texto: 'Totalmente de acuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 5,
                                                texto: 'No sé',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            }
                                        ]
                                    },
                                    {
                                        numPregunta: 3,
                                        preguntaID: 38,
                                        numGral: 38,
                                        pregunta: 'XXX es muy mala onda',
                                        tipo: 1,
                                        respuestas: [
                                            {
                                                num: 1,
                                                texto: 'Totalmente en desacuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 2,
                                                texto: 'Parcialmente en desacuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 3,
                                                texto: 'Parcialmente de acuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 4,
                                                texto: 'Totalmente de acuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 5,
                                                texto: 'No sé',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            }
                                        ]
                                    },
                                    {
                                        numPregunta: 4,
                                        preguntaID: 39,
                                        numGral: 39,
                                        pregunta: 'XXX me cae bien.',
                                        tipo: 1,
                                        respuestas: [
                                            {
                                                num: 1,
                                                texto: 'Totalmente en desacuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 2,
                                                texto: 'Parcialmente en desacuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 3,
                                                texto: 'Parcialmente de acuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 4,
                                                texto: 'Totalmente de acuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 5,
                                                texto: 'No sé',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    } //Fin Módulo 6
                    {
                        numModulo: 7,
                        tituloModulo: 'Módulo 7',
                        gruposPreguntas: [
                            {
                                numGrupo: 1,
                                tituloGrupo: 'Grupo 1 del Módulo 7',
                                preguntas: [
                                    {
                                        numPregunta: 1,
                                        preguntaID: 12,
                                        numGral: 12,
                                        pregunta:
                                            'A continuación aparecen 8 temas relacionados a tu vida personal, te pedimos que les asignes a cada uno la importancia (ponderación) que consideres que tiene en tu momento de vida actual:',
                                        tipo: 6, //Diagnóstico círculo de la vida
                                        respuestas: [
                                            {
                                                num: 1,
                                                texto: 'Amigos',
                                                valor: 0,
                                                respuesta: '0', //Aquí se guarda la selección del usuario
                                                tooltip: null
                                            },
                                            {
                                                num: 2,
                                                texto: 'Desarrollo personal',
                                                valor: 0,
                                                respuesta: '0', //Aquí se guarda la selección del usuario
                                                tooltip: null
                                            },
                                            {
                                                num: 3,
                                                texto: 'Familia',
                                                valor: 0,
                                                respuesta: '0', //Aquí se guarda la selección del usuario
                                                tooltip: null
                                            },
                                            {
                                                num: 4,
                                                texto: 'Finanzas personales',
                                                valor: 0,
                                                respuesta: '0', //Aquí se guarda la selección del usuario
                                                tooltip: null
                                            },
                                            {
                                                num: 5,
                                                texto: 'Recreación / Diversión',
                                                valor: 0,
                                                respuesta: '0', //Aquí se guarda la selección del usuario
                                                tooltip: null
                                            },
                                            {
                                                num: 6,
                                                texto: 'Salud física y mental',
                                                valor: 0,
                                                respuesta: '0', //Aquí se guarda la selección del usuario
                                                tooltip: null
                                            },
                                            {
                                                num: 7,
                                                texto: 'Vida profesional',
                                                valor: 0,
                                                respuesta: '0', //Aquí se guarda la selección del usuario
                                                tooltip: null
                                            },
                                            {
                                                num: 8,
                                                texto: 'Vida sentimental',
                                                valor: 0,
                                                respuesta: '0', //Aquí se guarda la selección del usuario
                                                tooltip: null
                                            }
                                        ]
                                    },
                                ]
                            },
                            {
                                numGrupo: 2,
                                tituloGrupo:
                                    'Mi nivel de satisfacción actual con los siguientes elementos:',
                                preguntas: [
                                    {
                                        numPregunta: 1,
                                        preguntaID: 14,
                                        numGral: 14,
                                        pregunta: 'Mi balance actual de vida - trabajo es bueno',
                                        tipo: 1, //Opción múltiple
                                        respuestas: [
                                            {
                                                num: 1,
                                                texto: 'Totalmente en desacuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 2,
                                                texto: 'Parcialmente en desacuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 3,
                                                texto: 'Parcialmente de acuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 4,
                                                texto: 'Totalmente de acuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 5,
                                                texto: 'No sé',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            }
                                        ]
                                    },
                                    {
                                        numPregunta: 2,
                                        preguntaID: 15,
                                        numGral: 15,
                                        pregunta: 'Mi balance actual de vida - trabajo es malo',
                                        tipo: 1, //Opción múltiple
                                        respuestas: [
                                            {
                                                num: 1,
                                                texto: 'Totalmente en desacuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 2,
                                                texto: 'Parcialmente en desacuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 3,
                                                texto: 'Parcialmente de acuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 4,
                                                texto: 'Totalmente de acuerdo',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            },
                                            {
                                                num: 5,
                                                texto: 'No sé',
                                                valor: 0,
                                                respuesta: '',
                                                tooltip: null
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }, //Fin del módulo 7
                ]
            };

            console.log('en UpdateUserSurveyData, surveyData = ', surveyData);

            dispatch('updateUserSurveyData', surveyData);
            */

            //Fin pruebas ***********************************************

            axios
                .get(
                    '/encuestas/getDataEncuestasById/' +
                        state.userSurvey.encuestaID +
                        '/' +
                        state.userID +
                        '/' +
                        state.userSurveyLangID +
                        '/' +
                        state.idToken,
                    { crossDomain: true }
                )
                .then(res => {
                    console.log('getUserSurveyData, res = ', res);
                    const surveyData = res.data;
                    if (surveyData.encuestaID !== 0) {
                        console.log('getUserSurveyData, surveyData = ', surveyData);
                        dispatch('updateUserSurveyData', surveyData);
                    }

                    state.bWaitCursor = false;
                })
                .catch(error => {
                    console.log('Error en getUserSurveyData, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        updateUserSurveyData({ dispatch, commit, state }, userSurveyData) {
            state.bWaitCursor = true;
            commit('setUserSurveyData', userSurveyData);
            state.companyLogoImg = require('@/assets/no-logo.png');

            //Obtiene nombre y logo de la empresa:
            if (userSurveyData.empresaID !== 0) {
                axios
                    .get('empresas/getById/' + userSurveyData.empresaID + '/' + state.idToken, {
                        crossDomain: true
                    })
                    .then(res => {
                        console.log('Get Company, res = ', res);
                        const company = res.data;

                        state.bWaitCursor = false;
                        dispatch('updateSurveyCompany', company);
                    })
                    .catch(error => {
                        console.log('Error en Get Company, error = ', error);
                        state.bWaitCursor = false;
                    });
            }

            //Si la encuesta es masiva, pedirNombre = true y entonces se ignora el nombre dado en la autenticación:
            if (userSurveyData.pedirNombre) {
                state.userName = ''; //El nombre se pide al usuario más adelante.
            }

            router.push('/usersurvey').catch(err => {});
        },

        updateUserSurveyName({ state }, userName) {
            //Para escribir el nombre de usuario de una encuesta masiva:
            state.userName = userName;
        },

        sendUserSurvey({ dispatch, commit, state }) {
            state.bWaitCursor = true;
            axios
                .post(
                    'encuestas/saveRespuestasEncuesta/' +
                        state.userSurvey.encuestaID +
                        '/' +
                        state.idToken,
                    state.userSurveyData
                )
                .then(res => {
                    //Se checa si el usuario tiene todavía encuestas sin contestar:

                    axios
                        .get(
                            '/usuarios/getEncuestasUsuario/' + state.userID + '/' + state.idToken,
                            {
                                crossDomain: true
                            }
                        )
                        .then(res => {
                            state.bWaitCursor = false;
                            console.log('fetchUSerSurveys después de sendUserSurvey, res = ', res);
                            const surveys = res.data;
                            console.log('userSurveys = ', surveys);
                            //Si hay por lo menos una encuesta que falte por contestar,
                            //se vuelve a llamar a updateUserSurveys y se
                            //levanta una bandera para que aunque después ya nada más falte una encuesta,
                            //siempre se mande a la ventana para escogerla:
                            //if (surveys.length > 0) {
                            if (surveys[0].error !== 2) {
                                state.askToSelectSurvey = true;
                                //console.log('Regresando a updateUserSurveys...');
                                dispatch('updateUserSurveys', surveys);
                            }
                            //Si ya no hay encuestas, se finaliza:
                            else {
                                //console.log('Finalizando...');
                                dispatch('logout');
                                dispatch('updateShowThankYouDlg', true);
                                state.bWaitCursor = false;
                            }
                        })
                        .catch(error => {
                            console.log('Error en getEncuestasUsuario, error = ', error);
                            state.bWaitCursor = false;
                        });

                    // dispatch('logout');
                    // dispatch('updateShowThankYouDlg', true);
                    //state.bWaitCursor = false;
                })
                .catch(error => {
                    console.log('Error en sendUserSurvey, error = ', error);
                    dispatch('updateSendUserSurveyError', true);
                    state.bWaitCursor = false;
                });
        },

        updateSendUserSurveyError({ commit }, bError) {
            commit('setSendUserSurveyError', bError);
        },

        updateSurveyCompany({ dispatch, commit }, company) {
            commit('setSurveyCompany', company);
            if (company.logoInfo.id !== null) {
                dispatch('getCompanyLogo', company.logoInfo);
            }
        },

        updateUserConfigOK({ commit }, bOK) {
            commit('setUserConfigOK', bOK);
        },

        updateShowDepartmentsDlg({ commit }, bShowDlg) {
            commit('setShowDepartmentsDlg', bShowDlg);
        },

        updateShowBusinessUnitsDlg({ commit }, bShowDlg) {
            commit('setShowBusinessUnitsDlg', bShowDlg);
        },

        updateShowCompanyFunctionsDlg({ commit }, bShowDlg) {
            commit('setShowCompanyFunctionsDlg', bShowDlg);
        },

        updateShowSelectFunctionDlg({ commit }, bShowDlg) {
            commit('setShowSelectFunctionDlg', bShowDlg);
        },

        updateShowValFunctionDlg({ commit }, bShowDlg) {
            commit('setShowValFunctionDlg', bShowDlg);
        },

        valuate({ commit, state }, valuationData) {
            console.log('valuationData: ', valuationData);
            state.bWaitCursor = true;
            axios
                .post('/valuacion/' + state.idToken, valuationData)
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('Valuación, res = ', res);

                    const data = res.data;
                    commit('setResults', data);
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },
        companyReport({ commit, state }, companyID) {
            state.bWaitCursor = true;
            console.log('CompanyID = ', companyID);
            axios
                .get('/valuacion/getValuacionesByEmpresa/' + companyID + '/' + state.idToken, {
                    crossDomain: true
                })
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('Reportes, res = ', res);

                    const data = res.data;
                    if (data[0].valuacionid === 0) {
                        //No hubo resultados...
                        commit('setCompanyReportResults', []);
                    } else {
                        commit('setCompanyReportResults', data);
                    }
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },
        departmentReport({ commit, state }, department) {
            state.bWaitCursor = true;
            axios
                .get(
                    '/valuacion/getValuacionesByDireccion/' +
                        department.departmentID +
                        '/' +
                        state.idToken,
                    { crossDomain: true }
                )
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('Reportes, res = ', res);
                    commit('setSelectedDeptForReport', department.name);

                    const data = res.data;
                    if (data[0].valuacionid === 0) {
                        //No hubo resultados...
                        commit('setDepartmentReportResults', []);
                    } else {
                        commit('setDepartmentReportResults', data);
                    }
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },
        updateSelectedDeptForReport({ commit, state }, name) {
            commit('setSelectedDeptForReport', name);
        },

        updateShowResultsDlg({ commit }, bShow) {
            commit('setShowResultsDlg', bShow);
        },

        updateShowCompanyReportResultsDlg({ commit }, bShow) {
            commit('setShowCompanyReportResultsDlg', bShow);
        },

        updateShowDepartmentReportResultsDlg({ commit }, bShow) {
            commit('setShowDepartmentReportResultsDlg', bShow);
        },

        fetchLanguages({ commit, state }) {
            state.bWaitCursor = true;

            axios
                .get('/idiomas/getIdiomas/' + state.idToken, { crossDomain: true })
                .then(res => {
                    console.log('FetchLanguages, res = ', res);
                    const data = res.data;
                    const languages = [];
                    var i;
                    for (i = 0; i < data.length; i++) {
                        const language = data[i];
                        languages.push(language);
                    }
                    state.bWaitCursor = false;
                    commit('setLanguages', languages);
                })
                .catch(error => {
                    console.log('Error en FetchLanguages, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        fetchUserTypes({ commit, state }) {
            state.bWaitCursor = true;

            axios
                .get('/tiposUsuario/getTiposUsuario/' + state.idToken, { crossDomain: true })
                .then(res => {
                    console.log('FetchUserTypes, res = ', res);
                    const userTypes = res.data;
                    state.bWaitCursor = false;
                    commit('setUserTypes', userTypes);
                })
                .catch(error => {
                    console.log('Error en fetchUserTypes, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        fetchQuestionnaires({ commit, state }) {
            state.bWaitCursor = true;

            axios
                .get('/cuestionarios/getCuestionarios/' + state.idToken, { crossDomain: true })
                .then(res => {
                    console.log('FetchQuestionnaires, res = ', res);
                    const questionnaires = res.data;
                    state.bWaitCursor = false;
                    commit('setQuestionnaires', questionnaires);
                })
                .catch(error => {
                    console.log('Error en FetchQuestionnaires, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        fetchSurveyQuestModulesTeams({ commit, state }) {
            state.bWaitCursor = true;

            // axios.get('/modulosEquipos/getModulosEquipo/1/' + state.idToken, { crossDomain: true })
            axios
                .get('/modulosEncuestas/getModulosEncuestas/1/' + state.idToken, {
                    crossDomain: true
                })
                .then(res => {
                    console.log('FetchSurveyQuestModulesTeams, res = ', res);
                    const modules = res.data;
                    state.bWaitCursor = false;
                    commit('setSurveyQuestModulesTeams', modules);
                })
                .catch(error => {
                    console.log('Error en FetchSurveyQuestModulesTeams, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        fetchSurveyQuestModulesCulture({ commit, state }) {
            state.bWaitCursor = true;

            //axios.get('/modulosEquipos/getModulosEquipo/2/' + state.idToken, { crossDomain: true })
            axios
                .get('/modulosEncuestas/getModulosEncuestas/2/' + state.idToken, {
                    crossDomain: true
                })
                .then(res => {
                    console.log('FetchSurveyQuestModulesCulture, res = ', res);
                    const modules = res.data;
                    state.bWaitCursor = false;
                    commit('setSurveyQuestModulesCulture', modules);
                })
                .catch(error => {
                    console.log('Error en FetchSurveyQuestModulesCulture, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        fetchSurveyQuestModulesIndex({ commit, state }) {
            state.bWaitCursor = true;

            //axios.get('/modulosEquipos/getModulosEquipo/3/' + state.idToken, { crossDomain: true })
            axios
                .get('/modulosEncuestas/getModulosEncuestas/3/' + state.idToken, {
                    crossDomain: true
                })
                .then(res => {
                    console.log('FetchSurveyQuestModulesIndex, res = ', res);
                    const modules = res.data;
                    state.bWaitCursor = false;
                    commit('setSurveyQuestModulesIndex', modules);
                })
                .catch(error => {
                    console.log('Error en FetchSurveyQuestModulesIndex, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        fetchSurveyQuestModulesLifeCircleDx({ commit, state }) {
            state.bWaitCursor = true;

            axios
                .get('/modulosEncuestas/getModulosEncuestas/4/' + state.idToken, {
                    crossDomain: true
                })
                .then(res => {
                    console.log('FetchSurveyQuestModulesLifeCircleDx, res = ', res);
                    const modules = res.data;
                    state.bWaitCursor = false;
                    commit('setSurveyQuestModulesLifeCircleDx', modules);
                })
                .catch(error => {
                    console.log('Error en FetchSurveyQuestModulesLifeCircleDx, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        fetchSurveyQuestModulesLifeCircleDxLeadership({ commit, state }) {
            state.bWaitCursor = true;

            axios
                .get('/modulosEncuestas/getModulosEncuestas/5/' + state.idToken, {
                    crossDomain: true
                })
                .then(res => {
                    console.log('FetchSurveyQuestModulesLifeCircleDxLeadership, res = ', res);
                    const modules = res.data;
                    state.bWaitCursor = false;
                    commit('setSurveyQuestModulesLifeCircleDxLeadership', modules);
                })
                .catch(error => {
                    console.log('Error en FetchSurveyQuestModulesLifeCircleDxLeadership, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        fetchSurveys({ commit, state }) {
            state.bWaitCursor = true;

            axios
                .get('/encuestas/getEncuestasByAdminId/' + state.userID + '/' + state.idToken, {
                    crossDomain: true
                })
                .then(res => {
                    console.log('FetchSurveys, res = ', res);
                    const surveys = res.data;
                    state.bWaitCursor = false;
                    commit('setSurveys', surveys);
                })
                .catch(error => {
                    console.log('Error en FetchSurveys, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        updateSurveyLoaded({ commit }, bLoaded) {
            commit('setSurveyLoaded', bLoaded);
        },

        updateLoadingSurvey({ commit }, bLoading) {
            commit('setLoadingSurvey', bLoading);
        },

        updateSurvey({ commit, state }, survey) {
            commit('setSurveyData', survey);
            commit('setSurveyRolleLabels', survey.alias);

            state.bSurveyLoaded = true;
            state.bLoadingSurvey = false;
        },

        initSurveyData({ commit }) {
            commit('initSurveyData');
            commit('setSurveyRolleLabels', []);
        },

        updateSurveyRolleLabels({ commit }, alias) {
            commit('setSurveyRolleLabels', alias);
        },

        updateSurveyUsers({ commit, state }, users) {
            commit('setSurveyRolleLabels', []);
            state.survey.usuarios = users;

            //console.log("users = ", users);
            //console.log("alias = ", state.survey.alias);

            commit('setSurveyRolleLabels', state.survey.alias);
        },

        getSurveyData({ commit, dispatch, state }, surveyID) {
            state.bWaitCursor = true;
            dispatch('initSurveyData');

            axios
                .get('/encuestas/getEncuestasById/' + surveyID + '/' + state.idToken, {
                    crossDomain: true
                })
                .then(res => {
                    //console.log('getSurveyData, res = ', res);
                    const survey = res.data;
                    if (survey.encuestaID !== 0) {
                        console.log('En getSurveyData, survey = ', survey);
                        dispatch('updateSurvey', survey);
                    }

                    state.bWaitCursor = false;
                })
                .catch(error => {
                    console.log('Error en getSurveyData, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        saveNewSurvey({ dispatch, state }, survey) {
            if (!state.idToken) {
                return;
            }
            console.log('Survey to save: ', survey);

            state.bWaitCursor = true;
            state.bSearchNewSurvey = true;

            axios
                .post('/encuestas/' + state.idToken, survey)
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('SaveNewSurvey, res = ', res);

                    //Se guarda el ID de la nueva encuesta, para poder seleccionarla después:
                    dispatch('updateNewSurveyID', res.data.encuestaID);

                    //Se vuelve a pedir al servidor todas las encuestas:
                    dispatch('fetchSurveys');
                })
                .catch(error => {
                    console.log(error);
                    state.bSearchNewSurvey = false;
                });
        },

        saveNewMultipleSurvey({ dispatch, state }, survey) {
            if (!state.idToken) {
                return;
            }
            console.log('Multiple survey to save: ', survey);

            state.bWaitCursor = true;
            state.bSearchNewSurvey = true;

            axios
                .post('/encuestas/saveEncuestaMasiva/' + state.idToken, survey)
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('SaveNewSurvey, res = ', res);

                    //Se guarda el ID de la nueva encuesta, para poder seleccionarla después:
                    dispatch('updateNewSurveyID', res.data.encuestaID);

                    //Se vuelve a pedir al servidor todas las encuestas:
                    dispatch('fetchSurveys');
                })
                .catch(error => {
                    console.log(error);
                    state.bSearchNewSurvey = false;
                });
        },

        editSurvey({ dispatch, state }, survey) {
            if (!state.idToken) {
                return;
            }
            console.log('Survey to save: ', survey);

            state.bWaitCursor = true;
            state.bSearchNewSurvey = true;

            axios
                .post('/encuestas/updateEncuesta/' + state.idToken, survey)
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('updateEncuesta, res = ', res);

                    //Se guarda el ID de la encuesta, para poder seleccionarla después:
                    dispatch('updateNewSurveyID', res.data.encuestaID);

                    //Se vuelve a pedir al servidor todas las encuestas:
                    dispatch('fetchSurveys');
                })
                .catch(error => {
                    console.log(error);
                    state.bSearchNewSurvey = false;
                });
        },

        updateSelectedQuestionnaireIndex({ commit }, index) {
            commit('setSelectedQuestionnaireIndex', index);
        },

        updateSearchNewQuestionnaire({ commit }, search) {
            commit('setSearchNewQuestionnaire', search);
        },

        updateNewQuestionnaireID({ commit }, id) {
            commit('setNewQuestionnaireID', id);
        },

        updateQuestionnaireGeneralAnswerSetID({ commit }, answerSetID) {
            commit('setQuestionnaireGeneralAnswerSetID', answerSetID);
        },

        getQuestionnaireData({ commit, dispatch, state }, questionnaireID) {
            state.bWaitCursor = true;
            axios
                .get(
                    '/cuestionarios/getCuestionariosSinCompetencias/' +
                        questionnaireID +
                        '/' +
                        state.idToken,
                    { crossDomain: true }
                )
                .then(res => {
                    commit('setQuestionnaireNames', []);
                    commit('setQuestionnaireGeneralAnswerSetID', 0);
                    commit('setQuestionnaireNames', []);
                    commit('setQuestionnaireSkills', []);
                    commit('setQuestionnaireSkillsLang', []);
                    commit('setQuestionnaireQuestions', []);
                    commit('setQuestionnaireQuestionsLang', []);

                    console.log('getQuestionnaireData, res = ', res);
                    const questionnaireNames = res.data.nombres;
                    const questionnaireQuestions = res.data.preguntas;
                    const questionnaireQuestionsLang = res.data.preguntasIdiomas;
                    if (
                        questionnaireNames !== undefined &&
                        questionnaireQuestions !== undefined &&
                        questionnaireQuestionsLang !== undefined
                    ) {
                        commit('setQuestionnaireNames', questionnaireNames);
                        commit('setQuestionnaireQuestions', questionnaireQuestions);
                        commit('setQuestionnaireQuestionsLang', questionnaireQuestionsLang);

                        dispatch('createQuestionnaireInfo');
                    }

                    state.bWaitCursor = false;
                })
                .catch(error => {
                    console.log('Error en getQuestionnaireData, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        getSkillQuestionnaireData({ commit, dispatch, state }, questionnaireID) {
            state.bWaitCursor = true;
            axios
                .get(
                    '/cuestionarios/getCuestionariosCompetencias/' +
                        questionnaireID +
                        '/' +
                        state.idToken,
                    { crossDomain: true }
                )
                .then(res => {
                    commit('setQuestionnaireNames', []);
                    commit('setQuestionnaireQuestions', []);
                    commit('setQuestionnaireQuestionsLang', []);
                    commit('setQuestionnaireGeneralAnswerSetID', 0);
                    commit('setQuestionnaireNames', []);
                    commit('setQuestionnaireSkills', []);
                    commit('setQuestionnaireSkillsLang', []);

                    console.log('getSkillQuestionnaireData, res = ', res);
                    const questionnaireGeneralAnswerSetID = res.data.setrespuestasid;
                    const questionnaireNames = res.data.nombres;
                    const questionnaireSkills = res.data.competencias;
                    const questionnaireSkillsLang = res.data.competenciasIdiomas;
                    const questionnaireQuestions = res.data.preguntas;
                    const questionnaireQuestionsLang = res.data.preguntasIdiomas;

                    if (
                        questionnaireGeneralAnswerSetID !== undefined &&
                        questionnaireNames !== undefined &&
                        questionnaireSkills !== undefined &&
                        questionnaireSkillsLang !== undefined &&
                        questionnaireQuestions !== undefined &&
                        questionnaireQuestionsLang !== undefined
                    ) {
                        commit(
                            'setQuestionnaireGeneralAnswerSetID',
                            questionnaireGeneralAnswerSetID
                        );
                        commit('setQuestionnaireNames', questionnaireNames);
                        commit('setQuestionnaireSkills', questionnaireSkills);
                        commit('setQuestionnaireSkillsLang', questionnaireSkillsLang);
                        commit('setQuestionnaireQuestions', questionnaireQuestions);
                        commit('setQuestionnaireQuestionsLang', questionnaireQuestionsLang);

                        dispatch('createSkillQuestionnaireInfo');
                    }
                    state.bWaitCursor = false;
                })
                .catch(error => {
                    console.log('Error en getSkillQuestionnaireData, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        createSkillQuestionnaireInfo({ commit, state }) {
            state.bWaitCursor = true;

            //Crea el arreglo para el único renglón que tendrá la tabla del nombre del cuestionario
            //y el arreglo para el header de las tablas del cuestionario, con una columna por idioma:

            var nameTable = []; //Arreglo con un solo renglón para la tabla del nombre del cuestionario.
            //Crea el único renglón para la tabla anterior:
            var nameTableRow = {
                id: 0
            };

            var questionnaireHeader = []; //Arreglo para el header de las tablas del cuestionario.
            const columnWidth = 100 / state.questionnaireNames.length;

            var i;
            for (i = 0; i < state.questionnaireNames.length; i++) {
                var j;
                var langName = '';
                for (j = 0; j < state.languages.length; j++) {
                    if (state.questionnaireNames[i].idiomaid === state.languages[j].idiomaid) {
                        langName = state.languages[j].idioma;
                        break;
                    }
                }
                const column = {
                    text: langName,
                    value: state.questionnaireNames[i].idiomaid.toString(),
                    sortable: false,
                    width: columnWidth + '%',
                    divider: true
                };

                //Se crea una nueva columna para el arreglo con el id del idioma como nombre de la columna y con el nombre como contenido:
                const idiomaid = state.questionnaireNames[i].idiomaid;
                nameTableRow[idiomaid] = state.questionnaireNames[i].nombre;

                questionnaireHeader.push(column);
            }
            nameTable.push(nameTableRow);
            commit('setQuestionnaireNameTable', nameTable);
            console.log('questionnaireNameTable = ', nameTable);
            commit('setQuestionnaireTablesHeader', questionnaireHeader);
            console.log('questionnaireHeader =', questionnaireHeader);

            //La tabla de preguntas es igual a las otras tablas de los cuestionarios, pero incluye una columna para
            //el número de pregunta (al princpio) y otra para el set de respuestas (al final):
            var questionHeader = JSON.parse(JSON.stringify(questionnaireHeader));
            var width = 90 / (questionHeader.length + 1);
            for (i = 0; i < questionHeader.length; i++) {
                questionHeader[i].width = width + '%';
            }

            const questionNumberColumn = {
                text: 'Número',
                value: 'num',
                sortable: false,
                width: '2%',
                divider: true,
                align: 'center'
            };
            //Agrega la columna para el número de pregunta al principio:
            questionHeader.splice(0, 0, questionNumberColumn);

            const answerSetColumn = {
                text: 'Set de Respuestas',
                value: 'answerSet',
                sortable: false,
                width: '2%',
                divider: true,
                align: 'center'
            };
            //Agrega la columna para el set de respuestas al final:
            questionHeader.push(answerSetColumn);

            //Agrega una columna al final para el botón de edición de cada pregunta:
            const editBtnColumn = {
                text: '',
                value: 'controls',
                sortable: false,
                width: '5%',
                divider: true,
                align: 'center'
            };
            questionHeader.push(editBtnColumn);

            console.log('questionnaireQuestionHeader = ', questionHeader);
            commit('setQuestionnaireQuestionHeader', questionHeader);

            //Arreglo para las tablas de todas las Competencias: ***********************************************

            var skillTable = []; //Arreglo para las tablas de las competencias, en todos los idiomas.
            var questionTable = []; //Arreglo para las tablas de todas las preguntas de todas las competencias.

            var questionNumber = 0;

            for (i = 0; i < state.questionnaireSkills.length; i++) {
                var skillOneRowTable = []; //Arreglo con un solo renglón, para cada competencia, con una columna por idioma.
                var skillTableRow = {
                    id: state.questionnaireSkills[i].competenciaid
                };

                var j;
                for (j = 0; j < state.questionnaireSkillsLang.length; j++) {
                    if (
                        state.questionnaireSkills[i].competenciaid ===
                        state.questionnaireSkillsLang[j].competenciaid
                    ) {
                        const idiomaid = state.questionnaireSkillsLang[j].idiomaid;
                        skillTableRow[idiomaid] = state.questionnaireSkillsLang[j].competencia;
                    }
                }
                skillOneRowTable.push(skillTableRow);
                skillTable.push(skillOneRowTable);

                //Arreglo para las tablas de las respuestas de la competencia: **********************************
                var skillQuestionsTable = [];

                for (j = 0; j < state.questionnaireQuestions.length; j++) {
                    //var questionOneRowTable = []; //Arreglo con un solo renglón, para cada pregunta, con una columna por idioma.

                    var questionTableRow = {
                        questionID: state.questionnaireQuestions[j].preguntaid,
                        num: 0,
                        answerSet: '',
                        answerSetID: 0
                    };
                    if (
                        state.questionnaireSkills[i].competenciaid ===
                        state.questionnaireQuestions[j].competenciaid
                    ) {
                        var k;
                        for (k = 0; k < state.questionnaireQuestionsLang.length; k++) {
                            if (
                                state.questionnaireQuestions[j].preguntaid ===
                                state.questionnaireQuestionsLang[k].preguntaid
                            ) {
                                const idiomaid = state.questionnaireQuestionsLang[k].idiomaid;
                                questionTableRow[idiomaid] =
                                    state.questionnaireQuestionsLang[k].pregunta;
                            }
                        }

                        var l;
                        for (l = 0; l < state.answerSets.length; l++) {
                            if (
                                state.questionnaireQuestions[j].setrespuestasid ===
                                state.answerSets[l].setrespuestasid
                            ) {
                                questionTableRow.answerSet = state.answerSets[l].nombre;
                                questionTableRow.answerSetID = state.answerSets[l].setrespuestasid;
                                break;
                            }
                        }

                        //questionOneRowTable.push(questionTableRow);
                        //skillQuestionsTable.push(questionOneRowTable);
                        questionNumber += 1;
                        questionTableRow.num = questionNumber;
                        skillQuestionsTable.push(questionTableRow);
                    }
                }
                questionTable.push(skillQuestionsTable);
            }

            commit('setQuestionnaireSkillTable', skillTable);
            console.log('skillTable = ', skillTable);

            commit('setQuestionnaireQuestionTable', questionTable);
            console.log('questionnaireQuestionTable = ', questionTable);

            state.bWaitCursor = false;
        },

        createQuestionnaireInfo({ commit, state }) {
            state.bWaitCursor = true;
            //Crea el arreglo para el único renglón que tendrá la tabla del nombre del cuestionario
            //y el arreglo para el header de las tablas del cuestionario, con una columna por idioma:

            var nameTable = []; //Arreglo con un solo renglón para la tabla del nombre del cuestionario.
            //Crea el único renglón para el arreglo anterior:
            var nameTableRow = {
                id: 0
            };

            var questionnaireHeader = []; //Arreglo para el header de las tablas del cuestionario.
            const columnWidth = 100 / state.questionnaireNames.length;

            var i;
            for (i = 0; i < state.questionnaireNames.length; i++) {
                var j;
                var langName = '';
                for (j = 0; j < state.languages.length; j++) {
                    if (state.questionnaireNames[i].idiomaid === state.languages[j].idiomaid) {
                        langName = state.languages[j].idioma;
                        break;
                    }
                }
                const column = {
                    text: langName,
                    value: state.questionnaireNames[i].idiomaid.toString(),
                    sortable: false,
                    width: columnWidth + '%',
                    divider: true
                };

                //Se crea una nueva columna para el arreglo con el id del idioma como nombre de la columna y con el nombre como contenido:
                const idiomaid = state.questionnaireNames[i].idiomaid;
                nameTableRow[idiomaid] = state.questionnaireNames[i].nombre;

                questionnaireHeader.push(column);
            }
            nameTable.push(nameTableRow);
            commit('setQuestionnaireNameTable', nameTable);
            console.log('questionnaireNameTable = ', nameTable);
            commit('setQuestionnaireTablesHeader', questionnaireHeader);
            console.log('questionnaireHeader = ', questionnaireHeader);

            //La tabla de preguntas es igual a la tabla del nombre del cuestionario, pero incluye
            //una columna para el número de respuestas:
            var questionHeader = JSON.parse(JSON.stringify(questionnaireHeader));
            var width = 92 / (questionHeader.length + 1);
            for (i = 0; i < questionHeader.length; i++) {
                questionHeader[i].width = width + '%';
            }

            const questionNumberColumn = {
                text: 'Número',
                value: 'num',
                sortable: false,
                width: '2%',
                divider: true,
                align: 'center'
            };
            //Agrega la columna para el número de pregunta al principio:
            questionHeader.splice(0, 0, questionNumberColumn);

            //Agrega una columna al final para el botón de edición de cada pregunta:
            const editBtnColumn = {
                text: '',
                value: 'controls',
                sortable: false,
                width: '5%',
                divider: true,
                align: 'center'
            };
            questionHeader.push(editBtnColumn);

            console.log('questionnaireQuestionHeader nuevo = ', questionHeader);
            commit('setQuestionnaireQuestionHeader', questionHeader);

            var questionTable = []; //Arreglo para las tablas de las preguntas.

            console.log('questionnaireQuestions = ', state.questionnaireQuestions);

            for (i = 0; i < state.questionnaireQuestions.length; i++) {
                var questionTableRow = {
                    questionID: state.questionnaireQuestions[i].preguntaid,
                    num: i + 1
                };

                var j;
                for (j = 0; j < state.questionnaireQuestionsLang.length; j++) {
                    if (
                        state.questionnaireQuestions[i].preguntaid ===
                        state.questionnaireQuestionsLang[j].preguntaid
                    ) {
                        const idiomaid = state.questionnaireQuestionsLang[j].idiomaid;
                        questionTableRow[idiomaid] = state.questionnaireQuestionsLang[j].pregunta;
                    }
                }

                questionTable.push(questionTableRow);
            }

            commit('setQuestionnaireQuestionTable', questionTable);
            console.log('questionnaireQuestionTable = ', questionTable);

            state.bWaitCursor = false;
        },

        updateQuestionnaireSkillsLang({ commit }, questionnaireSkillsLang) {
            commit('setQuestionnaireSkillsLang', questionnaireSkillsLang);
        },

        updateQuestionnaireNames({ state }, questionnaireToEdit) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;

            console.log('Questionnaire to edit = ', questionnaireToEdit);

            axios
                .post('/cuestionarios/updateCuestionario/' + state.idToken, questionnaireToEdit)
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('Questionnaire name saved, res = ', res);
                })
                .catch(error => {
                    state.bWaitCursor = false;
                });
        },

        updateQuestionnaireQuestions({ commit }, questionnaireQuestions) {
            commit('setQuestionnaireQuestions', questionnaireQuestions);
        },

        updateQuestionnaireQuestionsLang({ commit }, questionnaireQuestionsLang) {
            commit('setQuestionnaireQuestionsLang', questionnaireQuestionsLang);
        },

        updateQuestionnaireQuestionTable({ commit }, questionnaireQuestionTable) {
            commit('questionnaireQuestionTable', questionnaireQuestionTable);
        },

        updateQuestionnaireAnswerSet({ state }, infoToUpdate) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;

            console.log('Info to Update AnswerSet:', infoToUpdate);

            axios
                .post(
                    '/cuestionarios/updateSetRespuestasCuestionario/' + state.idToken,
                    infoToUpdate
                )
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('Questionnaire answer set saved, res = ', res);
                })
                .catch(error => {
                    state.bWaitCursor = false;
                });
        },

        updateQuestionnaireSkills({ state }) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;

            const compet_Idiomas = {
                competenciasIdiomas: state.questionnaireSkillsLang
            };

            //console.log("compet_Idiomas = ", compet_Idiomas);

            axios
                .post('/cuestionarios/updateCompetencia/' + state.idToken, compet_Idiomas)
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('Questionnaire names saved, res = ', res);
                })
                .catch(error => {
                    state.bWaitCursor = false;
                });
        },

        updateQuestionnaireQuestion({ state }, questionToEdit) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;

            axios
                .post('/cuestionarios/updatePregunta/' + state.idToken, questionToEdit)
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('Questionnaire question edited, res = ', res);
                })
                .catch(error => {
                    state.bWaitCursor = false;
                });
        },

        deleteQuestionnaire({ state }, questionnaireID) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;
            axios
                .delete(
                    '/cuestionarios/deleteCuestionario/' + questionnaireID + '/' + state.idToken,
                    { crossDomain: true }
                )
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('Questionnaire deleted, res = ', res);

                    if (res.data.encuestaBorrada === false) {
                        state.bQuestionnaireNotDeletedWarning = true;
                        state.bServerResponse = true;
                    } else {
                        state.bQuestionnaireNotDeletedWarning = false;
                        state.bServerResponse = true;
                    }
                })
                .catch(error => {
                    state.bWaitCursor = false;
                });
        },

        deleteSurvey({ state }, surveyID) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;
            axios
                .delete('/encuestas/deleteEncuesta/' + surveyID + '/' + state.idToken, {
                    crossDomain: true
                })
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('Survey deleted, res = ', res);

                    if (res.data.encuestaBorrada === false) {
                        state.bQuestionnaireNotDeletedWarning = true;
                        state.bServerResponse = true;
                    } else {
                        state.bQuestionnaireNotDeletedWarning = false;
                        state.bServerResponse = true;
                    }
                })
                .catch(error => {
                    state.bWaitCursor = false;
                });
        },

        updateQuestionnaireNotDeletedWarning({ commit }, bWarning) {
            commit('setQuestionnaireNotDeletedWarning', bWarning);
        },

        updateServerResponse({ commit }, bResponse) {
            commit('setServerResponse', bResponse);
        },

        updateSelectedSurveyIndex({ commit }, index) {
            commit('setSelectedSurveyIndex', index);
        },

        updateSearchNewSurvey({ commit }, search) {
            commit('setSearchNewSurvey', search);
        },

        updateNewSurveyID({ commit }, id) {
            commit('setNewSurveyID', id);
        },

        getAnswerSetData({ commit, dispatch, state }, answerSetID) {
            state.bWaitCursor = true;
            console.log('En getAnswerSetData...');
            axios
                .get('/setRespuestas/getInfoRespuestas/' + answerSetID + '/' + state.idToken, {
                    crossDomain: true
                })
                .then(res => {
                    console.log('getAnswerSetData, res = ', res);
                    const answers = res.data.respuestas;
                    const languageAnswers = res.data.respuestasIdiomas;

                    if (answers !== undefined && languageAnswers !== undefined) {
                        commit('setAnswers', answers);
                        commit('setLanguageAnswers', languageAnswers);
                        dispatch('createAnswerSetLanguages');
                    }
                    state.bWaitCursor = false;
                })
                .catch(error => {
                    console.log('Error en getAnswerSetData, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        createAnswerSetLanguages({ commit, state }) {
            state.bWaitCursor = true;
            var answerTable = [];
            var answerSetLanguages = []; //Arreglo con todos los idiomas del set de respuestas.

            var i;
            for (i = 0; i < state.answers.length; i++) {
                const answer = {
                    num: i + 1, //Número de respuesta
                    valoressetrespuestasid: state.answers[i].valoressetrespuestasid,
                    valor: state.answers[i].valor
                };
                var j;
                for (j = 0; j < state.languageAnswers.length; j++) {
                    if (
                        state.languageAnswers[j].valoressetrespuestasid ===
                        state.answers[i].valoressetrespuestasid
                    ) {
                        var k;

                        for (k = 0; k < state.languages.length; k++) {
                            if (state.languages[k].idiomaid === state.languageAnswers[j].idiomaid) {
                                var l;
                                var bLanguageFound = false;
                                for (l = 0; l < answerSetLanguages.length; l++) {
                                    if (
                                        answerSetLanguages[l].languageID ===
                                        state.languages[k].idiomaid
                                    ) {
                                        bLanguageFound = true;
                                        break;
                                    }
                                }
                                if (!bLanguageFound) {
                                    const lang = {
                                        languageID: state.languages[k].idiomaid,
                                        language: state.languages[k].idioma
                                    };
                                    answerSetLanguages.push(lang);
                                }
                                const idiomaid = state.languageAnswers[j].idiomaid;
                                answer[idiomaid] = state.languageAnswers[j].respuesta;
                                break;
                            }
                        }
                    }
                }
                //console.log("answer to push: ", answer);
                answerTable.push(answer);
            }

            console.log('AnswerTable: ', answerTable);
            commit('setAnswerTable', answerTable);

            //Genera el header para la tabla de respuestas:

            var answerHeader = [
                {
                    text: 'Número',
                    value: 'num',
                    sortable: false,
                    width: '5%',
                    align: 'center',
                    divider: true
                },
                {
                    text: 'Valor',
                    value: 'valor',
                    sortable: false,
                    width: '5%',
                    align: 'center',
                    divider: true
                }
            ];

            const columnWidth = 90 / answerSetLanguages.length;

            for (i = 0; i < answerSetLanguages.length; i++) {
                const column = {
                    text: answerSetLanguages[i].language,
                    value: answerSetLanguages[i].languageID.toString(),
                    sortable: false,
                    width: columnWidth + '%',
                    divider: true
                };
                answerHeader.push(column);
            }
            //console.log("answerHeader = ", answerHeader);
            var languagesAnswerSet = []; //arreglo con todos los idiomas, con una bandera especificando si cada idioma está seleccionado para el set de respuestas.
            for (i = 0; i < state.languages.length; i++) {
                const lang = {
                    languageID: state.languages[i].idiomaid,
                    language: state.languages[i].idioma,
                    selected: false
                };

                var j;
                for (j = 0; j < answerSetLanguages.length; j++) {
                    if (answerSetLanguages[j].languageID === state.languages[i].idiomaid) {
                        lang.selected = true;
                        break;
                    }
                }
                languagesAnswerSet.push(lang);
            }

            //console.log("languagesAnswerSet = ", languagesAnswerSet);

            commit('setLanguagesAnswerSet', languagesAnswerSet);
            commit('setAnswerTableHeader', answerHeader);

            state.bWaitCursor = false;
        },

        fetchAnswerSets({ commit, state }) {
            state.bWaitCursor = true;

            axios
                .get('/setRespuestas/getRespuestas/' + state.idToken, { crossDomain: true })
                .then(res => {
                    console.log('FetchAnswerSets, res = ', res);
                    const answerSets = res.data;
                    commit('setAnswerSets', answerSets);
                    state.bWaitCursor = false;
                })
                .catch(error => {
                    console.log('Error en FetchAnswerSets, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        updateAnswerSet({ state }, answerSetToEdit) {
            if (!state.idToken) {
                return;
            }
            console.log('AnswerSet to update: ', answerSetToEdit);

            state.bWaitCursor = true;
            state.bSearchNewAnswerSet = true;
            state.newAnswerSetName = answerSetToEdit.nombre;

            axios
                .post('/setRespuestas/updateSetRespuestas/' + state.idToken, answerSetToEdit)
                .then(res => {
                    state.bWaitCursor = false;
                    state.bSearchNewAnswerSet = true;
                    state.newAnswerSetName = answerSetToEdit.nombre;

                    //Se asegura de que los valores de las preguntas sean enteros y no strings:
                    var i;
                    for (i = 0; i < state.answers.length; i++) {
                        state.answers[i].valor = parseInt(state.answers[i].valor);
                    }

                    //Se crea el objeto con los dos arreglos a pasar en el post:
                    var answerInfo = {
                        respuestas: state.answers,
                        respuestasIdiomas: state.languageAnswers
                    };

                    console.log('answerInfo = ', answerInfo);

                    axios
                        .post('/setRespuestas/updateInfoSetRespuestas/' + state.idToken, answerInfo)
                        .then(res => {
                            state.bWaitCursor = false;
                            console.log('Respuestas saved, res = ', res);
                        })
                        .catch(error => {
                            state.bWaitCursor = false;
                        });
                })
                .catch(error => {
                    state.bWaitCursor = false;
                    console.log(error);
                });
        },
        saveNewAnswerSet({ state }, newAnswerSet) {
            if (!state.idToken) {
                return;
            }
            console.log('AnswerSet to save: ', newAnswerSet);

            state.bWaitCursor = true;
            state.bSearchNewAnswerSet = true;
            state.newAnswerSetName = newAnswerSet.nombre;

            axios
                .post('/setRespuestas/saveSetRespuestas/' + state.idToken, newAnswerSet)
                .then(res => {
                    console.log('New AnswerSet saved, res = ', res);

                    const newAnswerSetID = res.data.setrespuestasid;

                    var newAnswers = [];
                    var i;
                    for (i = 0; i < state.answers.length; i++) {
                        var answer = {
                            setrespuestasid: newAnswerSetID,
                            //Se asegura de pasar un entero y no un string:
                            valor: parseInt(state.answers[i].valor)
                        };
                        newAnswers.push(answer);
                    }

                    var newLanguageAnswers = [];
                    for (i = 0; i < state.languageAnswers.length; i++) {
                        var languageAnswer = {
                            idiomaid: state.languageAnswers[i].idiomaid,
                            respuesta: state.languageAnswers[i].respuesta,
                            tooltip: state.languageAnswers[i].tooltip
                        };
                        newLanguageAnswers.push(languageAnswer);
                    }

                    var answerInfo = {
                        respuestas: newAnswers,
                        respuestasIdiomas: newLanguageAnswers
                    };

                    console.log('answerInfo = ', answerInfo);

                    axios
                        .post('/setRespuestas/saveInfoSetRespuestas/' + state.idToken, answerInfo)
                        .then(res => {
                            state.bWaitCursor = false;
                            console.log('Respuestas saved, res = ', res);
                        })
                        .catch(error => {
                            state.bWaitCursor = false;
                            console.log(error);
                        });
                })
                .catch(error => {
                    state.bWaitCursor = false;
                    console.log(error);
                });
        },

        uploadNewQuestionnaire({ dispatch, state }, questionnaireFile) {
            console.log('Uploading Questionnaire File...');
            state.bWaitCursor = true;

            let formData = new FormData();
            formData.append('file', questionnaireFile);

            axios
                .post('/cuestionarios/import-excel/' + state.idToken, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('Success!!');
                    console.log('res = ', res);

                    //El servidor regresa el ID del nuevo cuestionario, así como si tiene competencias o no.
                    //Se piden todos los cuestionarios, y se selecciona el nuevo:
                    //  .
                    // res.data.competencias;
                    // res.data.cuestionarioid;
                    // res.data.nombre;
                    //state.bSearchNewQuestionnaire = true;
                    //state.newQuestionnaireName = res.data.nombre;
                    state.newQuestionnaireID = res.data.cuestionarioid;
                    dispatch('fetchQuestionnaires');
                })
                .catch(error => {
                    state.bWaitCursor = false;
                    console.log(error);
                });
        },

        importSurveyUsers({ dispatch, state }, usersToImport) {
            console.log('Uploading Import Users File...');
            state.bWaitCursor = true;

            let formData = new FormData();
            formData.append('file', usersToImport.file);

            axios
                .post(
                    '/usuarios/import-excel/' + usersToImport.surveyID + '/' + state.idToken,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                )
                .then(res => {
                    state.bWaitCursor = false;
                    //El servidor regresa todos los usuarios:
                    console.log('Usuarios importados!!!...');
                    //console.log("res = ", res);
                    const users = res.data;
                    console.log('res = ', users);

                    //Se actualizan los usuarios y la tabla de usuarios:
                    dispatch('updateSurveyUsers', users);
                })
                .catch(error => {
                    state.bWaitCursor = false;
                    console.log(error);
                });
        },

        importMultipleSurveyUsers({ dispatch, state }, usersFile) {
            console.log('Uploading Import Users File...');
            state.bWaitCursor = true;

            let formData = new FormData();
            formData.append('file', usersFile);

            axios
                .post('/usuarios/import-excel-masivo/' + state.idToken, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(res => {
                    state.bWaitCursor = false;
                    //El servidor regresa todos los usuarios:
                    console.log('Usuarios importados!!!...');
                    //console.log("res = ", res);
                    const users = res.data;
                    console.log('res = ', users);

                    //Se actualizan los usuarios y la tabla de usuarios:
                    dispatch('updateSurveyUsers', users);
                })
                .catch(error => {
                    state.bWaitCursor = false;
                    console.log(error);
                });
        },

        createSurveyUsers({ dispatch, state }, createUsersData) {
            console.log('CreateSurveyUsers...');
            state.bWaitCursor = true;

            axios
                .post(
                    '/usuarios/generateUsers/' +
                        createUsersData.surveyID +
                        '/' +
                        createUsersData.numberOfUsers +
                        '/' +
                        state.idToken
                )
                .then(res => {
                    state.bWaitCursor = false;
                    //El servidor regresa todos los usuarios (los anteriores y los nuevos):
                    console.log('Usuarios creados!!...');
                    state.survey.usuariosCreados = true;

                    const users = res.data;
                    console.log('res = ', users);

                    //Se actualizan los usuarios y la tabla de usuarios:
                    dispatch('updateSurveyUsers', users);
                })
                .catch(error => {
                    state.bWaitCursor = false;
                    console.log(error);
                });
        },

        editSurveyUser({ state }, userObject) {
            state.bWaitCursor = true;
            console.log('user to save: ', userObject);

            axios
                .post(
                    '/usuarios/updateUsuarioEncuesta/' + userObject.surveyID + '/' + state.idToken,
                    userObject.user
                )
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('res = ', res);
                })
                .catch(error => {
                    state.bWaitCursor = false;
                    console.log(error);
                });
        },

        addSurveyUser({ state }, userObject) {
            state.bWaitCursor = true;

            axios
                .post(
                    '/usuarios/addUsuarioEncuesta/' + userObject.surveyID + '/' + state.idToken,
                    userObject.user
                )
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('res = ', res);

                    //Se obtiene el id y el password asignado al usuario por el servidor:
                    const newUser = res.data;
                    //console.log("usuarios = ", state.survey.usuarios);
                    //Actualiza las tablas de usuarios con el id y el password:
                    var i;
                    for (i = 0; i < state.survey.usuarios.length; i++) {
                        if (state.survey.usuarios[i].usuarioID === 0) {
                            state.survey.usuarios[i].usuarioID = newUser.usuarioID;
                            state.survey.usuarios[i].password = newUser.password;
                            break;
                        }
                    }
                    //console.log("userTable = ", state.surveyUserTable);
                    for (i = 0; i < state.surveyUserTable.length; i++) {
                        if (state.surveyUserTable[i].usuarioID === 0) {
                            state.surveyUserTable[i].usuarioID = newUser.usuarioID;
                            state.surveyUserTable[i].password = newUser.password;
                            break;
                        }
                    }
                })
                .catch(error => {
                    state.bWaitCursor = false;
                    console.log(error);
                });
        },

        changeSurveyUserPasswd({ state }, userObject) {
            state.bWaitCursor = true;

            axios
                .post(
                    '/usuarios/regenerarPassword/' +
                        userObject.surveyID +
                        '/' +
                        userObject.userID +
                        '/' +
                        state.idToken
                )
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('res = ', res);

                    //Se obtiene el password asignado al usuario por el servidor:
                    const newPasswd = res.data.password;

                    //Actualiza las tablas de usuarios con el id y el password:
                    var i;
                    for (i = 0; i < state.survey.usuarios.length; i++) {
                        if (state.survey.usuarios[i].usuarioID === userObject.userID) {
                            state.survey.usuarios[i].password = newPasswd;
                            break;
                        }
                    }

                    for (i = 0; i < state.surveyUserTable.length; i++) {
                        if (state.surveyUserTable[i].usuarioID === userObject.userID) {
                            state.surveyUserTable[i].password = newPasswd;
                            break;
                        }
                    }
                })
                .catch(error => {
                    state.bWaitCursor = false;
                    console.log(error);
                });
        },

        deleteSurveyUser({ state }, userObject) {
            state.bWaitCursor = true;

            axios
                .delete(
                    '/usuarios/deleteUser/' +
                        userObject.userID +
                        '/' +
                        userObject.surveyID +
                        '/' +
                        state.idToken
                )
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('res = ', res);
                })
                .catch(error => {
                    state.bWaitCursor = false;
                    console.log(error);
                });
        },

        sendSurveyUserInvitation({ state }, userObject) {
            state.bWaitCursor = true;

            axios
                .post(
                    '/email/sendMailEncuestaUsuarioNormal/' +
                        userObject.surveyID +
                        '/' +
                        userObject.userID +
                        '/' +
                        state.idToken
                )
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('res = ', res);
                })
                .catch(error => {
                    state.bWaitCursor = false;
                    console.log(error);
                });
        },

        sendSurveyInvitations({ state }, surveyID) {
            state.bWaitCursor = true;

            axios
                .post('/email/sendMailEncuestaUsuariosNormales/' + surveyID + '/' + state.idToken)
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('res = ', res);
                    state.survey.invitacionMandada = true;
                })
                .catch(error => {
                    state.bWaitCursor = false;
                    console.log(error);
                });
        },

        processReport({ state }, reportInfo) {
            state.bWaitCursor = true;

            axios
                .get(
                    '/reportGenerator/runReport/' +
                        reportInfo.surveyID +
                        '/' +
                        reportInfo.languageID +
                        '/' +
                        reportInfo.retroalimentado +
                        '/' +
                        state.idToken
                )
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('ProcessReport res = ', res);

                    if (res.data !== 0 && res.data !== 1) {
                        state.iReportWarning = 0;
                        state.pdfPath = 'https://www.retroalimentame.com.mx/' + res.data;
                    } else if (res.data === 1) {
                        //El retroalimentado no ha contestado.
                        //Preguntar si se desea generar un reporte hipotético.
                        console.log('res.data = 1');
                        state.iReportWarning = 1;
                        state.pdfPath = '';
                    }
                    if (res.data === 0) {
                        //Hubo algún error desconocido al tratar de procesar el reporte...
                        console.log('res.data = 0');
                        state.iReportWarning = 2;
                        state.pdfPath = '';
                    }
                    state.bReportProcessed = true;
                })
                .catch(error => {
                    state.bWaitCursor = false;
                    console.log(error);
                });
        },

        excelExport({ state }, surveyID)
        {
            state.bWaitCursor = true;

            axios
                .get('/reportGenerator/createExcel/' + surveyID + '/' + state.idToken)
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('ExcelExport res = ', res);

                    if (res.data !== 0)
                    {
                        state.excelPath = 'https://www.retroalimentame.com.mx/' + res.data;
                    }
                    else
                    {
                        state.excelPath = '';
                    }
                    state.bExcelProcessed = true;
                })
                .catch(error => {
                    state.bWaitCursor = false;
                    console.log(error);
                });
        },

        belbinReport({ state }, reportInfo)
        {
            state.bWaitCursor = true;

            axios
                .get('/reportGenerator/runReportBelbin/'
                    + reportInfo.encuestaid + '/'
                    + reportInfo.idiomaid + '/'
                    + reportInfo.usuarioid + '/' + state.idToken)
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('BelbinReport res = ', res);

                    if (res.data !== 0)
                    {
                        state.belbinReportPath = 'https://www.retroalimentame.com.mx/' + res.data;
                    }
                    else
                    {
                        state.belbinReportPath = '';
                    }
                    state.bBelbinReportProcessed = true;
                })
                .catch(error => {
                    state.bWaitCursor = false;
                    console.log(error);
                });
        },

        testImgUpload({ state }, imgFile) {
            console.log('uploading file...');
            state.bWaitCursor = true;

            let formData = new FormData();
            formData.append('file', imgFile);

            axios.defaults.baseURL = 'http://192.168.1.70:8080';
            axios
                .post('/uploadFile', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('Success!!');
                })
                .catch(error => {
                    state.bWaitCursor = false;
                    console.log(error);
                });
        },

        testImgDownload({ state }) {
            console.log('Downloading file...');
            state.bWaitCursor = true;

            axios.defaults.baseURL = 'http://192.168.1.70:8080';
            axios
                .get('/downloadFile')
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('Success!!');
                })
                .catch(error => {
                    state.bWaitCursor = false;
                    console.log(error);
                });
        },

        fetchCompanies({ commit, state }) {
            state.bWaitCursor = true;

            axios
                .get('/empresas/getEmpresas/' + state.idToken, { crossDomain: true })
                .then(res => {
                    console.log('FetchCompanies, res = ', res);
                    const data = res.data;
                    const companies = [];
                    var i;
                    for (i = 0; i < data.length; i++) {
                        const company = data[i];
                        companies.push(company);
                    }
                    state.bWaitCursor = false;
                    commit('setCompanies', companies);
                })
                .catch(error => {
                    console.log('Error en FetchCompanies, error = ', error);
                    state.bWaitCursor = false;
                });
        },

        async getCompanyLogo({ commit, state }, logoInfo) {
            if (!state.idToken) {
                return;
            }
            state.bWaitCursor = true;

            axios
                .get('/downloadFile/' + logoInfo.id + '/' + state.idToken, {
                    crossDomain: true,
                    responseType: 'blob'
                })
                .then(res => {
                    //console.log('getCompanyLogo, res = ', res);
                    state.bWaitCursor = false;
                    let imgFile = new File([res.data], logoInfo.fileName, {
                        type: logoInfo.fileType
                    });
                    var logoFileURL = URL.createObjectURL(imgFile);

                    commit('setCompanyLogoImg', logoFileURL);
                })
                .catch(error => {
                    console.log('Error en getCompanyLogo, error = ', error);
                    let logoFileURL = require('@/assets/no-logo.png');
                    commit('setCompanyLogoImg', logoFileURL);
                    state.bWaitCursor = false;
                });
        },

        saveNewCompany({ dispatch, state }, companyToSave) {
            if (!state.idToken) {
                return;
            }
            console.log('Company to save: ', companyToSave);

            state.bWaitCursor = true;
            state.bSearchNewCompany = true;
            state.newCompanyName = companyToSave.company.empresanombre;

            axios
                .post('/empresas/' + state.idToken, companyToSave.company)
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('SaveNewCompany, res = ', res);

                    if (companyToSave.logoFile !== null) {
                        state.bWaitCursor = true;

                        let formData = new FormData();
                        formData.append('file', companyToSave.logoFile);

                        axios
                            .post(
                                '/uploadFile/' + res.data.empresaid + '/' + state.idToken,
                                formData,
                                {
                                    headers: {
                                        'Content-Type': 'multipart/form-data'
                                    }
                                }
                            )
                            .then(res => {
                                state.bWaitCursor = false;
                                console.log('Logo image file uploaded!');
                                //Se vuelve a pedir al servidor todas las empresas:
                                dispatch('fetchCompanies');
                            })
                            .catch(error => {
                                state.bWaitCursor = false;
                                console.log(error);
                            });
                    } else {
                        //Se vuelve a pedir al servidor todas las empresas:
                        dispatch('fetchCompanies');
                    }
                })
                .catch(error => {
                    console.log(error);
                    state.bSearchNewCompany = false;
                });
        },
        updateCompany({ dispatch, state }, companyToUpdate) {
            if (!state.idToken) {
                return;
            }
            console.log('Company to update: ', companyToUpdate);

            state.bWaitCursor = true;
            state.bSearchNewCompany = true;
            state.newCompanyName = companyToUpdate.company.empresanombre;

            axios
                .post(
                    '/empresas/' + companyToUpdate.company.empresaid + '/' + state.idToken,
                    companyToUpdate.company
                )
                .then(res => {
                    state.bWaitCursor = false;

                    if (companyToUpdate.logoFile !== null) {
                        state.bWaitCursor = true;

                        let formData = new FormData();
                        formData.append('file', companyToUpdate.logoFile);
                        console.log('formData = ', formData);

                        axios
                            .post(
                                '/uploadFile/' +
                                    companyToUpdate.company.empresaid +
                                    '/' +
                                    state.idToken,
                                formData,
                                {
                                    headers: {
                                        'Content-Type': 'multipart/form-data'
                                    }
                                }
                            )
                            .then(res => {
                                state.bWaitCursor = false;
                                console.log('Logo image file uploaded!');
                                //Se vuelve a pedir al servidor todas las empresas:
                                dispatch('fetchCompanies');
                            })
                            .catch(error => {
                                state.bWaitCursor = false;
                                console.log(error);
                            });
                    } else if (companyToUpdate.deleteLogo) {
                        state.bWaitCursor = true;
                        axios
                            .delete(
                                '/deleteFile/' +
                                    companyToUpdate.company.empresaid +
                                    '/' +
                                    state.idToken
                            )
                            .then(res => {
                                console.log('DeleteFile, res = ', res);
                                state.bWaitCursor = false;
                                console.log('Logo image file deleted!');
                                //Se vuelve a pedir al servidor todas las empresas:
                                dispatch('fetchCompanies');
                            })
                            .catch(error => {
                                (state.bWaitCursor = false), console.log(error);
                            });
                    } else {
                        //Se vuelve a pedir al servidor todas las empresas:
                        dispatch('fetchCompanies');
                    }
                })
                .catch(error => {
                    state.bWaitCursor = false;
                    console.log(error);
                    state.bSearchNewCompany = false;
                });
        },
        deleteCompany({ dispatch, state }, companyID) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;

            axios
                .delete('/empresas/deleteEmpresa/' + companyID + '/' + state.idToken)
                .then(res => {
                    state.bWaitCursor = false;
                    //Se vuelve a pedir al servidor todas las empresas:
                    dispatch('fetchCompanies');
                })
                .catch(error => {
                    console.log(error);
                });
        },
        updateSelectedCompanyIndex({ commit }, index) {
            commit('updateSelectedCompanyIndex', index);
        },

        updateSelectedLanguageIndex({ commit }, index) {
            commit('updateSelectedLanguageIndex', index);
        },
        saveNewLanguage({ dispatch, state }, newLanguage) {
            if (!state.idToken) {
                return;
            }
            //console.log("Language to save: ", newLanguage);

            state.bWaitCursor = true;
            state.bSearchNewLanguage = true;
            state.newLanguageName = newLanguage.idioma;

            axios
                .post('/idiomas/' + state.idToken, newLanguage)
                .then(res => {
                    state.bWaitCursor = false;
                    //Se vuelve a pedir al servidor todos los idiomas:
                    dispatch('fetchLanguages');
                })
                .catch(error => {
                    console.log(error);
                    state.bSearchNewLanguage = false;
                });
        },
        updateLanguage({ dispatch, state }, language) {
            if (!state.idToken) {
                return;
            }
            console.log('Language to save: ', language);

            state.bWaitCursor = true;
            state.bSearchNewLanguage = true;
            state.newLanguageName = language.idioma;

            axios
                .post('/idiomas/' + language.idiomaid + '/' + state.idToken, language)
                .then(res => {
                    state.bWaitCursor = false;
                    //Se vuelve a pedir al servidor todos los idiomas:
                    dispatch('fetchLanguages');
                })
                .catch(error => {
                    state.bWaitCursor = false;
                    console.log(error);
                    state.bSearchNewLanguage = false;
                });
        },
        deleteLanguage({ dispatch, state }, idiomaID) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;

            axios
                .delete('/idiomas/deleteIdioma/' + idiomaID + '/' + state.idToken)
                .then(res => {
                    state.bWaitCursor = false;
                    //Se vuelve a pedir al servidor todos los idiomas:
                    dispatch('fetchLanguages');
                })
                .catch(error => {
                    console.log(error);
                });
        },

        updateLanguagesAnswerSet({ commit }, languagesAnswerSet) {
            commit('setLanguagesAnswerSet', languagesAnswerSet);
        },

        updateSelectedAnswerSetIndex({ commit }, index) {
            commit('setSelectedAnswerSetIndex', index);
        },

        deleteAnswerSet({ dispatch, state }, answerSetID) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;

            axios
                .delete('/idiomas/deleteSetRespuestas/' + answerSetID + '/' + state.idToken)
                .then(res => {
                    state.bWaitCursor = false;
                    //Se vuelve a pedir al servidor todos los sets de respuestas:
                    dispatch('fetchAnswerSets');
                })
                .catch(error => {
                    console.log(error);
                });
        },

        updateAnswers({ commit }, answers) {
            commit('setAnswers', answers);
        },

        updateLanguageAnswers({ commit }, languageAnswers) {
            commit('setLanguageAnswers', languageAnswers);
        },

        fetchUsers({ commit, state }) {
            //En esta función se obtienen los usuarios administradores, no los de las encuestas.
            state.bWaitCursor = true;

            axios
                .get('/usuarios/getAdmin/' + state.idToken, { crossDomain: true })
                //axios.get('/usuarios/' + state.idToken, { crossDomain: true })
                .then(res => {
                    console.log('res de fetchUsuarios: ', res);
                    const users = res.data;
                    commit('setUsers', users);
                    state.bWaitCursor = false;
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },

        fetchAdministrators({ commit, state }) {
            state.bWaitCursor = true;

            axios
                .get('/usuarios/getAdmin/' + state.idToken, { crossDomain: true })
                .then(res => {
                    const data = res.data;
                    console.log('res de administradores: ', data);
                    const users = [];
                    var i;
                    for (i = 0; i < data.length; i++) {
                        const user = data[i];
                        users.push(user);
                    }
                    state.bWaitCursor = false;
                    console.log('Administrators: ', users);
                    commit('setAdministrators', users);
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },

        setDuplicatedUserError({ commit }, payload) {
            commit('setDuplicatedUserError', payload);
        },

        saveNewUser({ dispatch, state }, newUser) {
            //Checa que no haya un usuario registado con el mismo correo:

            state.bWaitCursor = true;
            console.log('email: ', newUser.email);

            axios
                .get('/usuarios/getByEmail/' + newUser.email + '/' + state.idToken, {
                    crossDomain: true
                })
                .then(res => {
                    state.bWaitCursor = false;
                    const data = res.data;
                    console.log('New User, res = ', data);
                    if (data.usuarioid === 0) {
                        //No se encontró un usuario con ese correo...
                        //console.log("Todo bien, podemos registrar usuario...");
                        dispatch('storeNewUser', newUser);
                    } //Ya hay un usuario con ese correo...
                    else {
                        dispatch('setDuplicatedUserError', true);
                    }
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },

        storeNewUser({ dispatch, state }, newUser) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;
            state.bSearchNewUser = true;
            state.newUserEmail = newUser.email;

            console.log('User to save: ', newUser);

            axios
                .post('/usuarios/' + state.idToken, newUser)
                .then(res => {
                    state.bWaitCursor = false;
                    //console.log("res de CreateUser: ", res);
                    //Se vuelve a pedir al servidor todos los usuarios:
                    dispatch('fetchUsers');
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                    state.bSearchNewUser = false;
                });
        },

        editUser({ dispatch, state }, user) {
            state.bWaitCursor = true;

            console.log('user = ', user);

            //Si el objeto user trae password quiere decir que hay que editar el password:
            console.log('user.password = ', user.password);
            if (user.password !== '') {
                //Cambia el password en la tabla de autenticación:
                console.log('Cambiando Password...');

                //Se crea un objeto con el ID y el password:
                const userPasswd = {
                    usuariosid: user.usuarioid,
                    password: user.password
                };

                axios
                    .post(
                        '/usuarios/updateUserPassword/' +
                            userPasswd.usuariosid +
                            '/' +
                            state.idToken,
                        userPasswd
                    )
                    .then(res => {
                        state.bWaitCursor = false;
                    })
                    .catch(error => {
                        console.log(error);
                        state.bWaitCursor = false;
                    });
            }

            //Edición de los datos del usuario:
            const userData = {
                usuarioid: user.usuarioid,
                activo: user.activo,
                email: user.email,
                nombre: user.nombre,
                appaterno: user.appaterno,
                apmaterno: user.apmaterno,
                empresaid: user.empresaid,
                tipoid: user.tipoid,
                cuestionarioid: user.cuestionarioid,
                numLicencias: user.numLicencias
            };
            console.log('user to save: ', userData);
            state.bWaitCursor = true;
            axios
                .post('/usuarios/' + user.usuarioid + '/' + state.idToken, userData)
                .then(res => {
                    state.bWaitCursor = false;
                    console.log('res de Edición de Usuario: ', res);
                    //Se vuelve a pedir al servidor todos los usuarios:
                    dispatch('fetchUsers');
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                    state.bSearchNewUser = false;
                });
        },
        updateSelectedUserIndex({ commit }, index) {
            commit('updateSelectedUserIndex', index);
        },

        deleteUser({ dispatch, state }, userID) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;

            axios
                .delete('/usuarios/deleteUser/' + userID + '/0/' + state.idToken)
                .then(res => {
                    state.bWaitCursor = false;
                    //Se vuelve a pedir al servidor todos los usuarios:
                    dispatch('fetchUsers');
                })
                .catch(error => {
                    console.log(error);
                });
        },

        //**Funciones ***************************************************************************************************

        showFunctionsForValuationDlg({ commit, dispatch, state }, companyID) {
            state.bWaitCursor = true;

            commit('setDisaggregatedFunctionsVal', []);

            //Se obtienen todas las funciones de la empresa y se guarda otro arreglo para las funciones primarias de la empresa:
            axios
                .get('/funciones/listFuncionesByEmpresaId/' + companyID + '/' + state.idToken, {
                    crossDomain: true
                })
                .then(res => {
                    console.log('res de lisFunctionesEmpresa: ', res);
                    const companyFunctions = res.data;
                    const primaryFunctions = [];

                    var i;
                    for (i = 0; i < companyFunctions.length; i++) {
                        if (companyFunctions[i].dependencia === 0) {
                            //Sólo se guardan las funciones primarias.
                            const primFunction = companyFunctions[i];
                            primaryFunctions.push(primFunction);
                        }
                    }
                    state.bWaitCursor = false;
                    console.log('Funciones primarias recibidas: ', primaryFunctions);
                    commit('setCompanyFunctionsVal', companyFunctions);
                    commit('setPrimaryFunctionsVal', primaryFunctions);
                    dispatch('updateShowValFunctionDlg', true);
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },

        showFunctionCatalogue({ commit, dispatch, state }) {
            state.bWaitCursor = true;

            commit('setDisaggregatedFunctions', []);

            //Se obtienen todas las funciones:
            axios
                .get('/funciones/' + state.idToken, { crossDomain: true })
                .then(res => {
                    //console.log("res de showFunctionCatalogue: ", res);
                    const data = res.data;
                    const functions = [];
                    var i;
                    for (i = 0; i < data.length; i++) {
                        if (data[i].dependencia === 0) {
                            //Sólo se guardan las funciones primarias.
                            const funct = data[i];
                            functions.push(funct);
                        }
                    }
                    state.bWaitCursor = false;
                    console.log('Funciones primarias recibidas: ', functions);
                    commit('setPrimaryFunctions', functions);
                    dispatch('updateShowSelectFunctionDlg', true);
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },
        fetchFunctionCatalogue({ commit, dispatch, state }) {
            //Obtiene las funciones primarias y despliega la ventana del catálogo general de funciones:

            state.bWaitCursor = true;

            commit('setDisaggregatedFunctions', []);

            //Se obtienen todas las funciones:
            axios
                .get('/funciones/' + state.idToken, { crossDomain: true })
                .then(res => {
                    console.log('res de fetchFunctionCatalogue: ', res);
                    const data = res.data;
                    const functions = [];
                    var i;
                    for (i = 0; i < data.length; i++) {
                        if (data[i].dependencia === 0) {
                            //Sólo se guardan las funciones primarias.
                            const funct = data[i];
                            functions.push(funct);
                        }
                    }
                    state.bWaitCursor = false;
                    console.log('Funciones primarias recibidas: ', functions);
                    commit('setPrimaryFunctions', functions);
                    router.push('/functions');
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },
        fetchPrimaryFunctions({ commit, dispatch, state }) {
            //Obtiene las funciones primarias:

            state.bWaitCursor = true;

            commit('setDisaggregatedFunctions', []);

            //Se obtienen todas las funciones:
            axios
                .get('/funciones/' + state.idToken, { crossDomain: true })
                .then(res => {
                    console.log('res de fetchPrimaryFunctions: ', res);
                    const data = res.data;
                    const functions = [];
                    var i;
                    for (i = 0; i < data.length; i++) {
                        if (data[i].dependencia === 0) {
                            //Sólo se guardan las funciones primarias.
                            const funct = data[i];
                            functions.push(funct);
                        }
                    }
                    state.bWaitCursor = false;
                    console.log('Funciones primarias recibidas: ', functions);
                    commit('setPrimaryFunctions', functions);
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },

        fetchSpecializedFunctions({ commit, dispatch, state }, funct) {
            state.bWaitCursor = true;

            commit('setSpecializedFunctions', []);

            axios
                .get(
                    '/funciones/listSubFuncionesModel/' + funct.dependencia + '/' + state.idToken,
                    { crossDomain: true }
                )
                .then(res => {
                    console.log('res de fetchSpecializedFunctions: ', res);
                    const data = res.data;
                    const functions = [];
                    var i;
                    for (i = 0; i < data.length; i++) {
                        const funct = data[i];
                        functions.push(funct);
                    }
                    state.bWaitCursor = false;

                    console.log('Funciones especializadas recibidas: ', functions);
                    commit('setSpecializedFunctions', functions);

                    if (funct.showFunctions === 1) {
                        commit('setSpecializedFunctionsToShow', functions);
                    }
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },

        fetchSpecializedFunctionsVal({ commit, dispatch, state }, funct) {
            state.bWaitCursor = true;

            commit('setSpecializedFunctionsVal', []);

            axios
                .get(
                    '/funciones/listSubFuncionesByEmpresa/' +
                        funct.companyID +
                        '/' +
                        funct.dependencia +
                        '/' +
                        state.idToken,
                    { crossDomain: true }
                )

                .then(res => {
                    console.log('res de fetchSpecializedFunctionsVal: ', res);
                    const data = res.data;
                    const functions = [];
                    var i;
                    for (i = 0; i < data.length; i++) {
                        const funct = data[i];
                        functions.push(funct);
                    }
                    state.bWaitCursor = false;

                    console.log('Funciones especializadas recibidas: ', functions);
                    commit('setSpecializedFunctionsVal', functions);

                    if (funct.showFunctions === 1) {
                        commit('setSpecializedFunctionsValToShow', functions);
                    }
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },

        fetchSpecializedFunctionsCompany({ commit, dispatch, state }, funct) {
            state.bWaitCursor = true;

            commit('setSpecializedFunctionsCompany', []);

            axios
                .get(
                    '/funciones/listAllSubFuncionesByEmpresa/' +
                        funct.companyID +
                        '/' +
                        funct.dependencia +
                        '/' +
                        state.idToken,
                    { crossDomain: true }
                )
                .then(res => {
                    console.log('res de fetchSpecializedFunctionsCompany: ', res);
                    const data = res.data;
                    const functions = [];
                    var i;
                    for (i = 0; i < data.length; i++) {
                        const funct = data[i];
                        functions.push(funct);
                    }
                    state.bWaitCursor = false;

                    console.log('Funciones especializadas recibidas: ', functions);
                    commit('setSpecializedFunctionsCompany', functions);

                    if (funct.showFunctions === 1) {
                        commit('setSpecializedFunctionsCompanyToShow', functions);
                    }
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },

        fetchDisaggregatedFunctions({ commit, dispatch, state }, funct) {
            state.bWaitCursor = true;

            commit('setDisaggregatedFunctions', []);

            axios
                .get(
                    '/funciones/listSubFuncionesModel/' + funct.dependencia + '/' + state.idToken,
                    { crossDomain: true }
                )
                .then(res => {
                    console.log('res de fetchDisaggregatedFunctions: ', res);
                    const data = res.data;
                    const functions = [];
                    var i;
                    for (i = 0; i < data.length; i++) {
                        const funct = data[i];
                        functions.push(funct);
                    }
                    state.bWaitCursor = false;
                    console.log('Funciones desagregadas recibidas: ', functions);
                    commit('setDisaggregatedFunctions', functions);
                    if (funct.showFunctions === 1) {
                        commit('setDisaggregatedFunctionsToShow', functions);
                    }
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },
        fetchDisaggregatedFunctionsVal({ commit, dispatch, state }, funct) {
            state.bWaitCursor = true;

            commit('setDisaggregatedFunctionsVal', []);

            axios
                .get(
                    '/funciones/listSubFuncionesByEmpresa/' +
                        funct.companyID +
                        '/' +
                        funct.dependencia +
                        '/' +
                        state.idToken,
                    { crossDomain: true }
                )
                .then(res => {
                    console.log('res de fetchDisaggregatedFunctionsVal: ', res);
                    const data = res.data;
                    const functions = [];
                    var i;
                    for (i = 0; i < data.length; i++) {
                        const funct = data[i];
                        functions.push(funct);
                    }
                    state.bWaitCursor = false;
                    console.log('Funciones desagregadas recibidas: ', functions);
                    commit('setDisaggregatedFunctionsVal', functions);
                    if (funct.showFunctions === 1) {
                        commit('setDisaggregatedFunctionsValToShow', functions);
                    }
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },
        fetchDisaggregatedFunctionsCompany({ commit, dispatch, state }, funct) {
            state.bWaitCursor = true;

            commit('setDisaggregatedFunctionsCompany', []);

            axios
                .get(
                    '/funciones/listAllSubFuncionesByEmpresa/' +
                        funct.companyID +
                        '/' +
                        funct.dependencia +
                        '/' +
                        state.idToken,
                    { crossDomain: true }
                )
                .then(res => {
                    console.log('res de fetchDisaggregatedFunctionsCompany: ', res);
                    const data = res.data;
                    const functions = [];
                    var i;
                    for (i = 0; i < data.length; i++) {
                        const funct = data[i];
                        functions.push(funct);
                    }
                    state.bWaitCursor = false;
                    console.log('Funciones desagregadas recibidas: ', functions);
                    commit('setDisaggregatedFunctionsCompany', functions);

                    if (funct.showFunctions === 1) {
                        commit('setDisaggregatedFunctionsCompanyToShow', functions);
                    }
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },
        fetchCompanyFunctions({ commit, dispatch, state }, companyID) {
            state.bWaitCursor = true;

            commit('setDisaggregatedFunctionsCompany', []);

            axios
                .get('/funciones/listFuncionesByEmpresa/' + companyID + '/' + state.idToken, {
                    crossDomain: true
                })
                //axios.get('/funciones/' + state.idToken, { crossDomain: true })
                .then(res => {
                    console.log('res de fetchCompanyFunctions: ', res);
                    const data = res.data;
                    const functions = [];
                    var i;
                    for (i = 0; i < data.length; i++) {
                        if (data[i].dependencia === 0) {
                            //Sólo se guardan las funciones primarias.
                            const funct = data[i];
                            functions.push(funct);
                        }
                    }
                    state.bWaitCursor = false;
                    console.log('Funciones primarias recibidas: ', functions);
                    commit('setPrimaryFunctionsCompany', functions);
                    dispatch('updateShowCompanyFunctionsDlg', true);
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },
        deleteCompanyFunction({ dispatch, commit, state }, functionToDelete) {
            if (!state.idToken) {
                return;
            }

            //console.log("Función a borrar:", functionToDelete);

            state.bWaitCursor = true;

            axios
                .get(
                    '/funciones/desasignaEmpresasFunciones/' +
                        functionToDelete.empresaid +
                        '/' +
                        functionToDelete.funcionesid +
                        '/' +
                        state.idToken
                )
                .then(res => {
                    state.bWaitCursor = false;
                    //Se vuelve a pedir al servidor las funciones de la empresa:

                    if (functionToDelete.tipo === 1) {
                        //dispatch('fetchCompanyFunctions', functionToDelete.empresaid);
                        state.bWaitCursor = true;
                        commit('setDisaggregatedFunctionsCompany', []);

                        axios
                            .get(
                                '/funciones/listFuncionesByEmpresa/' +
                                    functionToDelete.empresaid +
                                    '/' +
                                    state.idToken,
                                { crossDomain: true }
                            )
                            .then(res => {
                                //console.log("res de fetchCompanyFunctions: ", res);
                                const data = res.data;
                                const functions = [];
                                var i;
                                for (i = 0; i < data.length; i++) {
                                    if (data[i].dependencia === 0) {
                                        //Sólo se guardan las funciones primarias.
                                        const funct = data[i];
                                        functions.push(funct);
                                    }
                                }
                                state.bWaitCursor = false;
                                console.log('Funciones primarias recibidas: ', functions);
                                commit('setPrimaryFunctionsCompany', functions);

                                //Se obtienen las funciones especializadas de la función desasignada (sin mostrarse, con
                                //showFunction = 0), para que si el usuario hace click en la función primaria desasignada, sus
                                //funciones especializadas también aparezcan desasignadas:
                                var func = {
                                    companyID: functionToDelete.empresaid,
                                    dependencia: functionToDelete.funcionesid,
                                    showFunctions: 0 //Indica que specializedFunctionsToShow no debe ser llenado.
                                };
                                dispatch('fetchSpecializedFunctionsCompany', func);
                            })
                            .catch(error => {
                                console.log(error);
                                state.bWaitCursor = false;
                            });
                    } else {
                        //Se declara un objeto con los datos de la función padre, para poder obtener todas las funciones,
                        //ya sean especializadas o desagregadas, del mismo nivel jerárquico que la función desasignada:
                        var func = {
                            companyID: functionToDelete.empresaid,
                            dependencia: functionToDelete.dependencia,
                            showFunctions: 1 //Indica si specializedFunctionsToShow debe ser llenado.
                        };
                        if (functionToDelete.tipo === 2) {
                            //dispatch('fetchSpecializedFunctionsCompany', func);
                            state.bWaitCursor = true;
                            commit('setSpecializedFunctionsCompany', []);

                            axios
                                .get(
                                    '/funciones/listAllSubFuncionesByEmpresa/' +
                                        functionToDelete.empresaid +
                                        '/' +
                                        functionToDelete.dependencia +
                                        '/' +
                                        state.idToken,
                                    { crossDomain: true }
                                )
                                .then(res => {
                                    //console.log("res de fetchSpecializedFunctionsCompany: ", res);
                                    const data = res.data;
                                    const functions = [];
                                    var i;
                                    for (i = 0; i < data.length; i++) {
                                        const funct = data[i];
                                        functions.push(funct);
                                    }
                                    state.bWaitCursor = false;
                                    console.log('Funciones especializadas recibidas: ', functions);
                                    commit('setSpecializedFunctionsCompany', functions);
                                    commit('setSpecializedFunctionsCompanyToShow', functions);

                                    //Se obtienen las funciones desagregadas de la función desasignada (sin mostrarse, con
                                    //showFunction = 0), para que si el usuario hace click en la función especializada desasignada, sus
                                    //funciones desagregadas también aparezcan desasignadas:
                                    var func = {
                                        companyID: functionToDelete.empresaid,
                                        dependencia: functionToDelete.funcionesid,
                                        showFunctions: 0 //Indica que disggregatedFunctionsToShow no debe ser llenado.
                                    };
                                    dispatch('fetchDisaggregatedFunctionsCompany', func);
                                })
                                .catch(error => {
                                    console.log(error);
                                    state.bWaitCursor = false;
                                });
                        } else if (functionToDelete.tipo === 3) {
                            //Si la función que se desasigna es desagregada, simplemente se vuelven a obtener todas las
                            //funciones desagregadas de la función especiaizada padre:
                            dispatch('fetchDisaggregatedFunctionsCompany', func);
                        }
                    }
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },
        assignCompanyFunction({ dispatch, commit, state }, functionToAssign) {
            if (!state.idToken) {
                return;
            }

            //console.log("Función a asignar:", functionToAssign);

            state.bWaitCursor = true;

            axios
                .get(
                    '/funciones/asignaEmpresasFunciones/' +
                        functionToAssign.empresaid +
                        '/' +
                        functionToAssign.funcionesid +
                        '/' +
                        state.idToken
                )
                .then(res => {
                    state.bWaitCursor = false;
                    //Se vuelve a pedir al servidor las funciones de la empresa:

                    //dispatch('fetchCompanyFunctions', functionToAssign.empresaid);
                    if (functionToAssign.tipo === 1) {
                        //dispatch('fetchCompanyFunctions', functionToAssign.empresaid);
                        state.bWaitCursor = true;
                        commit('setDisaggregatedFunctionsCompany', []);

                        axios
                            .get(
                                '/funciones/listFuncionesByEmpresa/' +
                                    functionToAssign.empresaid +
                                    '/' +
                                    state.idToken,
                                { crossDomain: true }
                            )
                            .then(res => {
                                //console.log("res de fetchCompanyFunctions: ", res);
                                const data = res.data;
                                const functions = [];
                                var i;
                                for (i = 0; i < data.length; i++) {
                                    if (data[i].dependencia === 0) {
                                        //Sólo se guardan las funciones primarias.
                                        const funct = data[i];
                                        functions.push(funct);
                                    }
                                }
                                state.bWaitCursor = false;
                                console.log('Funciones primarias recibidas: ', functions);
                                commit('setPrimaryFunctionsCompany', functions);

                                //Se obtienen las funciones especializadas de la función asignada (sin mostrarse, con
                                //showFunction = 0), para que si el usuario hace click en la función primaria desasignada, sus
                                //funciones especializadas también aparezcan asignadas:
                                var func = {
                                    companyID: functionToAssign.empresaid,
                                    dependencia: functionToAssign.funcionesid,
                                    showFunctions: 0 //Indica que specializedFunctionsToShow no debe ser llenado.
                                };
                                dispatch('fetchSpecializedFunctionsCompany', func);
                            })
                            .catch(error => {
                                console.log(error);
                                state.bWaitCursor = false;
                            });
                    } else {
                        //Se declara un objeto con los datos de la función padre, para poder obtener todas las funciones,
                        //ya sean especializadas o desagregadas, del mismo nivel jerárquico que la función asignada:
                        var func = {
                            companyID: functionToAssign.empresaid,
                            dependencia: functionToAssign.dependencia,
                            showFunctions: 1 //Indica si specializedFunctionsToShow debe ser llenado.
                        };
                        if (functionToAssign.tipo === 2) {
                            //dispatch('fetchSpecializedFunctionsCompany', func);
                            state.bWaitCursor = true;
                            commit('setSpecializedFunctionsCompany', []);

                            axios
                                .get(
                                    '/funciones/listAllSubFuncionesByEmpresa/' +
                                        functionToAssign.empresaid +
                                        '/' +
                                        functionToAssign.dependencia +
                                        '/' +
                                        state.idToken,
                                    { crossDomain: true }
                                )
                                .then(res => {
                                    //console.log("res de fetchSpecializedFunctionsCompany: ", res);
                                    const data = res.data;
                                    const functions = [];
                                    var i;
                                    for (i = 0; i < data.length; i++) {
                                        const funct = data[i];
                                        functions.push(funct);
                                    }
                                    state.bWaitCursor = false;
                                    console.log('Funciones especializadas recibidas: ', functions);
                                    commit('setSpecializedFunctionsCompany', functions);
                                    commit('setSpecializedFunctionsCompanyToShow', functions);

                                    //Se obtienen las funciones desagregadas de la función asignada (sin mostrarse, con
                                    //showFunction = 0), para que si el usuario hace click en la función especializada asignada, sus
                                    //funciones desagregadas también aparezcan asignadas:
                                    var func = {
                                        companyID: functionToAssign.empresaid,
                                        dependencia: functionToAssign.funcionesid,
                                        showFunctions: 0 //Indica que disggregatedFunctionsToShow no debe ser llenado.
                                    };
                                    dispatch('fetchDisaggregatedFunctionsCompany', func);
                                })
                                .catch(error => {
                                    console.log(error);
                                    state.bWaitCursor = false;
                                });
                        } else if (functionToAssign.tipo === 3) {
                            //Si la función que se asigna es desagregada, simplemente se vuelven a obtener todas las
                            //funciones desagregadas de la función especiaizada padre:
                            dispatch('fetchDisaggregatedFunctionsCompany', func);
                        }
                    }
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },

        saveNewFunction({ dispatch, state }, newFunction) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;
            state.bSearchNewFunction = true;
            state.newFunctionName = newFunction.funcion;

            axios
                .post('/funciones/' + state.idToken, newFunction)
                .then(res => {
                    state.bWaitCursor = false;
                    //Se vuelve a pedir al servidor todas las funciones:
                    if (newFunction.tipo === 1) {
                        dispatch('fetchPrimaryFunctions');
                    } else {
                        var func = {
                            dependencia: newFunction.dependencia,
                            showFunctions: 1 //Indica que specializedFunctionsToShow debe ser llenado.
                        };
                        if (newFunction.tipo === 2) {
                            dispatch('fetchSpecializedFunctions', func);
                        } else {
                            if (newFunction.tipo === 3) {
                                dispatch('fetchDisaggregatedFunctions', func);
                            }
                        }
                    }
                })
                .catch(error => {
                    console.log(error);
                    state.bSearchNewFunction = false;
                });
        },

        updateFunction({ dispatch, state }, func) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;
            state.bSearchNewfunction = true;

            axios
                .post('/funciones/' + func.funcionesid + '/' + state.idToken, func)
                .then(res => {
                    state.bWaitCursor = false;
                    //Se vuelve a pedir al servidor todas las funciones:
                    if (func.tipo === 1) {
                        //Primaria
                        dispatch('fetchPrimaryFunctions');
                    } else if (func.tipo === 2) {
                        //Especializada
                        var funct = {
                            dependencia: func.dependencia,
                            showFunctions: 1 //Indica si specializedFunctionsToShow debe ser llenado.
                        };
                        dispatch('fetchSpecializedFunctions', funct);
                    } else if (func.tipo === 3) {
                        //Desagregada
                        var funct = {
                            dependencia: func.dependencia,
                            showFunctions: 1 //Indica si disaggregatedFunctionsToShow debe ser llenado.
                        };
                        dispatch('fetchDisaggregatedFunctions', funct);
                    }
                })
                .catch(error => {
                    state.bWaitCursor = false;
                    console.log(error);
                    state.bSearchNewFunction = false;
                });
        },

        deleteFunction({ dispatch, state }, funct) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;

            axios
                .delete('/funciones/deleteFunciones/' + funct.funcionID + '/' + state.idToken)
                .then(res => {
                    state.bWaitCursor = false;
                    //Se vuelve a pedir al servidor todas las funciones:
                    if (funct.tipo === 1) {
                        dispatch('fetchPrimaryFunctions');
                    } else {
                        var func = {
                            dependencia: funct.dependencia,
                            showFunctions: 1 //Indica si specializedFunctionsToShow debe ser llenado.
                        };
                        if (funct.tipo === 2) {
                            dispatch('fetchSpecializedFunctions', func);
                        } else if (funct.tipo === 3) {
                            dispatch('fetchDisaggregatedFunctions', func);
                        }
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        },
        updateSelectedFunctionIndex({ commit }, index) {
            commit('updateSelectedFunctionIndex', index);
        },
        updateSelectedPrimaryIndex({ commit }, index) {
            commit('updateSelectedPrimaryIndex', index);
        },
        updateSelectedSpecializedIndex({ commit }, index) {
            commit('updateSelectedSpecializedIndex', index);
        },
        updateSelectedDisaggregatedIndex({ commit }, index) {
            commit('updateSelectedDisaggregatedIndex', index);
        },
        updateSelectedPrimaryValIndex({ commit }, index) {
            commit('updateSelectedPrimaryValIndex', index);
        },
        updateSelectedSpecializedValIndex({ commit }, index) {
            commit('updateSelectedSpecializedValIndex', index);
        },
        updateSelectedDisaggregatedValIndex({ commit }, index) {
            commit('updateSelectedDisaggregatedValIndex', index);
        },
        updateSelectedPrimaryCompanyIndex({ commit }, index) {
            commit('updateSelectedPrimaryCompanyIndex', index);
        },
        updateSelectedSpecializedCompanyIndex({ commit }, index) {
            commit('updateSelectedSpecializedCompanyIndex', index);
        },
        updateSelectedDisaggregatedCompanyIndex({ commit }, index) {
            commit('updateSelectedDisaggregatedCompanyIndex', index);
        },

        //**Unidades de Negocio ***************************************************************************************************
        fetchBusinessUnits({ commit, dispatch, state }, companyID) {
            state.bWaitCursor = true;

            //console.log("En fetchBusinessUnits, companyID = ", companyID);

            axios
                .get(
                    '/unidadesDeNegocio/listUnidadesDeNegocio/' + companyID + '/' + state.idToken,
                    { crossDomain: true }
                )
                .then(res => {
                    //console.log('fetchBusinessUnits, res = ', res);
                    const data = res.data;
                    const units = [];
                    var i;
                    for (i = 0; i < data.length; i++) {
                        const unit = data[i];
                        units.push(unit);
                    }
                    state.bWaitCursor = false;
                    console.log('Unidades de Negocio recibidas:', units);
                    commit('setBusinessUnits', units);
                    dispatch('updateShowBusinessUnitsDlg', true);
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },

        fetchUserBusinessUnits({ commit, dispatch, state }, userID) {
            state.bWaitCursor = true;

            axios
                .get('/usuarios/usuariosUnidadesDeNegocio/' + userID + '/' + state.idToken, {
                    crossDomain: true
                })
                .then(res => {
                    const data = res.data;
                    const businessUnits = [];
                    var i;
                    for (i = 0; i < data.length; i++) {
                        const businessUnit = data[i];
                        businessUnits.push(businessUnit);
                    }
                    state.bWaitCursor = false;
                    console.log('Unid. de Negocio de usuario recibidas: ', businessUnits);
                    commit('initUserBusinessUnits', { userID, businessUnits });

                    state.userBusinessUnitsFetched = true;
                    // if (state.userFunctionsFetched && state.userRolesFetched && state.userBusinessUnitsFetched && state.userDepartmentsFetched) {
                    //     dispatch('updateUserConfigOK', true);
                    // }
                    if (
                        state.userRolesFetched &&
                        state.userBusinessUnitsFetched &&
                        state.userDepartmentsFetched
                    ) {
                        dispatch('updateUserConfigOK', true);
                    }
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },
        updateUserBusinessUnits({ commit }, businessUnits) {
            commit('setUserBusinessUnits', businessUnits);
        },
        saveNewBusinessUnit({ dispatch, state }, newUnit) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;
            state.bSearchNewBusinessUnit = true;
            state.newBusinessUnitName = newUnit.nombre;

            axios
                .post('/unidadesDeNegocio/' + state.idToken, newUnit)
                .then(res => {
                    //console.log("res de saveNewBusiessUnit: ", res);
                    state.bWaitCursor = false;
                    //Se vuelve a pedir al servidor todas las unidades de negocio:
                    dispatch('fetchBusinessUnits', newUnit.empresaid);
                })
                .catch(error => {
                    console.log(error);
                    state.bSearchNewBusinessUnit = false;
                });
        },
        updateBusinessUnit({ dispatch, state }, unit) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;
            state.bSearchNewBusinessUnit = true;

            //console.log("Update business unit, unit = ", unit);

            axios
                .post('/unidadesDeNegocio/' + unit.unidadnegocioid + '/' + state.idToken, unit)
                .then(res => {
                    state.bWaitCursor = false;
                    //Se vuelve a pedir al servidor todas las unidades de negocio:
                    dispatch('fetchBusinessUnits', unit.empresaid);
                })
                .catch(error => {
                    state.bWaitCursor = false;
                    console.log(error);
                    state.bSearchNewBusinessUnit = false;
                });
        },
        deleteBusinessUnit({ dispatch, state }, unit) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;

            axios
                .delete(
                    '/unidadesDeNegocio/deleteUnidadDeNegocio/' +
                        unit.unidadnegocioid +
                        '/' +
                        state.idToken
                )
                .then(res => {
                    state.bWaitCursor = false;
                    //Se vuelve a pedir al servidor todas las unidades de negocio:
                    dispatch('fetchBusinessUnits', unit.empresaid);
                    dispatch('fetchUserBusinessUnits', state.userID);
                })
                .catch(error => {
                    console.log(error);
                });
        },
        updateSelectedBusinessUnitIndex({ commit }, index) {
            commit('updateSelectedBusinessUnitIndex', index);
        },
        uploadUserBusinessUnits({ dispatch, state }, userID) {
            if (!state.idToken) {
                return;
            }

            var i;

            for (i = 0; i < state.userBusinessUnitsToSave.length; i++) {
                state.bWaitCursor = true;
                //console.log("usuarioUnidadNegocios[" + i + "] = ", state.userBusinessUnitsToSave[i]);
                axios
                    .post(
                        '/usuarios/saveUsuarioUnidadDeNegocio/' + state.idToken,
                        state.userBusinessUnitsToSave[i]
                    )
                    .then(res => {
                        //Cuando el servidor responde al último request se vuelven a pedir todas las unidades de neg. del usuario:
                        if (i === state.userBusinessUnitsToSave.length) {
                            state.bWaitCursor = false;
                            //Se vuelven a pedir al servidor todas las funidades de neg. del usuario:
                            dispatch('fetchUserBusinessUnits', userID);
                            state.userBusinessUnitsToSave = [];
                            //Se cierra la ventana de configuración:
                            //dispatch('updateShowUserConfigDlg', false);
                        }
                    })
                    .catch(error => {
                        state.bWaitCursor = false;
                        console.log(error);
                    });
            }
        },
        restoreUserBusinessUnits({ commit }) {
            commit('restoreUserBusinessUnits');
        },
        fetchBusinessUnitForUser({ commit, state }, businessUnitID) {
            state.bWaitCursor = true;

            //console.log('Request: /usuarios/getUsuarioUnidadDeNegocio/' + state.userID + '/' + businessUnitID + '/' + state.idToken);

            axios
                .get(
                    '/usuarios/getUsuarioUnidadDeNegocio/' +
                        state.userID +
                        '/' +
                        businessUnitID +
                        '/' +
                        state.idToken,
                    { crossDomain: true }
                )
                .then(res => {
                    state.bWaitCursor = false;

                    //console.log("Res de fetchBusinessUnitForUser: ", res);
                    const businessUnit = res.data;
                    console.log('U. de Neg. de usuario recibida: ', businessUnit);

                    commit('setBusinessUnitForUser', businessUnit);
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },
        updateBusinessUnitForUser({ commit }, businessUnit) {
            commit('setBusinessUnitForUser', businessUnit);
        },
        uploadUserBusinessUnit({ dispatch, state }, businessUnit) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;

            axios
                .post('/usuarios/saveUsuarioUnidadDeNegocio/' + state.idToken, businessUnit)
                .then(res => {
                    state.bWaitCursor = false;
                    //Se vuelven a pedir al servidor todas las funidades de neg. del usuario:
                    dispatch('fetchUserBusinessUnits', businessUnit.usuariosid);
                })
                .catch(error => {
                    state.bWaitCursor = false;
                    console.log(error);
                });
        },
        saveNewUserBusinessUnit({ dispatch, state }, newUnit) {
            if (!state.idToken) {
                return;
            }

            console.log('newUnit = ', newUnit);

            state.bWaitCursor = true;
            state.bSearchNewBusinessUnit = true;
            state.newBusinessUnitName = newUnit.nombre;

            const businessUnit = {
                empresaid: newUnit.empresaid,
                nombre: newUnit.nombre,
                ventas: newUnit.ventas,
                moneda: newUnit.moneda
            };

            axios
                .post('/unidadesDeNegocio/' + state.idToken, businessUnit)
                .then(res => {
                    state.bWaitCursor = false;

                    if (res.status === 200) {
                        //Se asigna la unidad de negocios al usuario si se especificó que se debía asignar:
                        if (newUnit.nombreUsuario !== '') {
                            const userBusinessUnit = {
                                usuariosunidadesdenegocioid: 0,
                                usuariosid: state.userID,
                                unidadnegocioid: res.data.unidadnegocioid, //Regresada por el servidor
                                nombre: newUnit.nombreUsuario,
                                status: 0 //Nuevo
                            };
                            dispatch('uploadUserBusinessUnit', userBusinessUnit);
                        }
                    }

                    //Se vuelve a pedir al servidor todas las unidades de negocio:
                    dispatch('fetchBusinessUnits', newUnit.empresaid);
                })
                .catch(error => {
                    console.log(error);
                    state.bSearchNewBusinessUnit = false;
                });
        },
        updateUserBusinessUnit({ dispatch, state }, unitToEdit) {
            if (!state.idToken) {
                return;
            }

            console.log('unit to edit = ', unitToEdit);

            var unit = {
                unidadnegocioid: unitToEdit.unidadnegocioid,
                nombre: unitToEdit.nombre,
                empresaid: unitToEdit.empresaid,
                moneda: unitToEdit.moneda,
                ventas: unitToEdit.ventas
            };

            state.bWaitCursor = true;
            state.bSearchNewBusinessUnit = true;

            console.log('Update business unit, unit = ', unit);

            axios
                .post('/unidadesDeNegocio/' + unit.unidadnegocioid + '/' + state.idToken, unit)
                .then(res => {
                    state.bWaitCursor = false;

                    if (res.status === 200) {
                        const userBusinessUnit = {
                            usuariosunidadesdenegocioid: unitToEdit.usuariosunidadesdenegocioid,
                            usuariosid: state.userID,
                            unidadnegocioid: unitToEdit.unidadnegocioid,
                            nombre: unitToEdit.nombreUsuario,
                            status: 2 //Editar por default (adelante se checa si se cambia).
                        };
                        if (unitToEdit.usuariosunidadesdenegocioid === 0) {
                            //No se había asignado antes. Se crea:
                            userBusinessUnit.status = 0; //Nuevo
                        } else if (unitToEdit.nombreUsuario === '') {
                            //La unidad fue desasignada. Hay que borrarla...
                            userBusinessUnit.status = 1; //Borrar
                        }

                        dispatch('uploadUserBusinessUnit', userBusinessUnit);
                    }

                    //Se vuelve a pedir al servidor todas las unidades de negocio:
                    dispatch('fetchBusinessUnits', unit.empresaid);
                })
                .catch(error => {
                    state.bWaitCursor = false;
                    console.log(error);
                    state.bSearchNewBusinessUnit = false;
                });
        },

        //**Direcciones ***************************************************************************************************
        fetchDepartments({ commit, dispatch, state }, companyID) {
            state.bWaitCursor = true;

            axios
                .get('/direcciones/listDirecciones/' + companyID + '/' + state.idToken, {
                    crossDomain: true
                })
                .then(res => {
                    console.log('fetchDepartments, res = ', res);
                    const data = res.data;
                    const departments = [];
                    var i;
                    for (i = 0; i < data.length; i++) {
                        const department = data[i];
                        departments.push(department);
                    }
                    state.bWaitCursor = false;
                    console.log('Direcciones obtenidas: ', departments);
                    commit('setDepartments', departments);
                    dispatch('updateShowDepartmentsDlg', true);
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },

        fetchUserDepartments({ commit, dispatch, state }, userID) {
            state.bWaitCursor = true;

            axios
                .get('/usuarios/usuariosDirecciones/' + userID + '/' + state.idToken, {
                    crossDomain: true
                })
                .then(res => {
                    const data = res.data;
                    const departments = [];
                    var i;
                    for (i = 0; i < data.length; i++) {
                        const department = data[i];
                        departments.push(department);
                    }
                    state.bWaitCursor = false;
                    console.log('Direcciones de usuario recibidas: ', departments);
                    commit('initUserDepartments', { userID, departments });

                    state.userDepartmentsFetched = true;
                    // if (state.userFunctionsFetched && state.userRolesFetched && state.userBusinessUnitsFetched && state.userDepartmentsFetched) {
                    //     dispatch('updateUserConfigOK', true);
                    // }
                    if (
                        state.userRolesFetched &&
                        state.userBusinessUnitsFetched &&
                        state.userDepartmentsFetched
                    ) {
                        dispatch('updateUserConfigOK', true);
                    }
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },
        updateUserDepartments({ commit }, departments) {
            commit('setUserDepartments', departments);
        },
        saveNewDepartment({ dispatch, state }, newDepartment) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;
            state.bSearchNewDepartment = true;
            state.newDepartmentName = newDepartment.direccion;

            //console.log("Save new department, unit = ", newDepartment);

            axios
                .post('/direcciones/' + state.idToken, newDepartment)
                .then(res => {
                    state.bWaitCursor = false;
                    //Se vuelve a pedir al servidor todas las direcciones:
                    dispatch('fetchDepartments', newDepartment.empresaid);
                })
                .catch(error => {
                    console.log(error);
                    state.bSearchNewDepartment = false;
                });
        },
        updateDepartment({ dispatch, state }, department) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;
            state.bSearchNewDepartment = true;

            //console.log("Department = ", department);

            axios
                .post('/direcciones/' + department.direccionesid + '/' + state.idToken, department)
                .then(res => {
                    state.bWaitCursor = false;
                    //Se vuelve a pedir al servidor todos los departamentos:
                    dispatch('fetchDepartments', department.empresaid);
                })
                .catch(error => {
                    state.bWaitCursor = false;
                    console.log(error);
                    state.bSearchNewDepartment = false;
                });
        },
        deleteDepartment({ dispatch, state }, department) {
            if (!state.idToken) {
                return;
            }

            console.log('empresa a borrar: ', department);

            state.bWaitCursor = true;

            axios
                .delete(
                    '/direcciones/deleteDireccion/' + department.direccionesid + '/' + state.idToken
                )
                .then(res => {
                    state.bWaitCursor = false;
                    //Se vuelve a pedir al servidor todos los departamentos:
                    dispatch('fetchDepartments', department.empresaid);
                })
                .catch(error => {
                    console.log(error);
                });
        },
        updateSelectedDepartmentIndex({ commit }, index) {
            commit('updateSelectedDepartmentIndex', index);
        },
        uploadUserDepartments({ dispatch, state }, userID) {
            if (!state.idToken) {
                return;
            }

            console.log('userDepartments to save: ', state.userDepartmentsToSave);

            var i;

            for (i = 0; i < state.userDepartmentsToSave.length; i++) {
                state.bWaitCursor = true;
                //console.log("usuarioDireccion[" + i + "] = ", state.userDepartmentsToSave[i]);
                axios
                    .post(
                        '/usuarios/saveUsuarioDireccion/' + state.idToken,
                        state.userDepartmentsToSave[i]
                    )
                    .then(res => {
                        console.log('res = ', res);
                        //Cuando el servidor responde al último request se vuelven a pedir todas las direcciones del usuario:
                        if (i === state.userDepartmentsToSave.length) {
                            state.bWaitCursor = false;
                            //Se vuelven a pedir al servidor todas las direcciones del usuario:
                            dispatch('fetchUserDepartments', userID);
                            state.userDepartmentsToSave = [];
                            //Se cierra la ventana de configuración:
                            //dispatch('updateShowUserConfigDlg', false);
                        }
                    })
                    .catch(error => {
                        state.bWaitCursor = false;
                        console.log(error);
                    });
            }
        },
        restoreUserDepartments({ commit }) {
            commit('restoreUserDepartments');
        },

        saveUserConfig({ dispatch, state }, userID) {
            //console.log("userFunctions = ", state.userFunctions);
            //console.log("originalUserFunctions = ", state.originalUserFunctions);
            var i;
            var bFound = false;

            //Funciones: ******************************************************************************************
            // state.userFunctionsToSave = [];

            // for (i = 0; i < state.userFunctions.length; i++) {
            //     var j;
            //     bFound = false;
            //     for (j = 0; j < state.originalUserFunctions.length; j++) {
            //         //console.log("userFunctions[" + i + "] = " + state.userFunctions[i]);
            //         //console.log("originalUserFunctions[" + j + "] = ")
            //         if (state.userFunctions[i].funcionesid === state.originalUserFunctions[j].funcionesid)
            //         //La función ya estaba desde antes. Se checa si se editó el nombre:
            //         {
            //             bFound = true;
            //             if (state.userFunctions[i].nombre !== state.originalUserFunctions[j].nombre)
            //             //El nombre cambió. Hay que agregarlo al arreglo que se va a mandar al servidor:
            //             {
            //                 //console.log("Nombre diferente en i = " + i + ", j = " + j);
            //                 const funct = {
            //                     usuariosfuncionesid: state.userFunctions[i].usuariosfuncionesid,
            //                     usuariosid: state.userFunctions[i].usuariosid,
            //                     funcionesid: state.userFunctions[i].funcionesid,
            //                     nombre: state.userFunctions[i].nombre,
            //                     status: 2 //Editar
            //                 };
            //                 state.userFunctionsToSave.push(funct);
            //             }
            //             break;
            //         }
            //     }
            //     if (!bFound)
            //     //El registro no se encontró en el arreglo original, por lo que se trata de un registro nuevo:
            //     {
            //         //console.log("Registro nuevo en i = " + i + ", j = " + j);
            //         const funct = {
            //             usuariosfuncionesid: 0,
            //             usuariosid: state.userFunctions[i].usuariosid,
            //             funcionesid: state.userFunctions[i].funcionesid,
            //             nombre: state.userFunctions[i].nombre,
            //             status: 0 //Nuevo
            //         };
            //         state.userFunctionsToSave.push(funct);
            //     }
            // }

            // //Ahora se comparan los arreglos al revés, para obtener los registros borrados. Si el registro estaba en el arreglo original
            // //pero no en el nuevo, quiere decir que se debe borrar el registro:
            // for (i = 0; i < state.originalUserFunctions.length; i++) {
            //     bFound = false;
            //     var j;
            //     for (j = 0; j < state.userFunctions.length; j++) {
            //         if (state.originalUserFunctions[i].funcionesid === state.userFunctions[j].funcionesid) {
            //             bFound = true;
            //             break;
            //         }
            //     }
            //     if (!bFound) {
            //         const funct = {
            //             usuariosfuncionesid: state.originalUserFunctions[i].usuariosfuncionesid,
            //             usuariosid: state.originalUserFunctions[i].usuariosid,
            //             funcionesid: state.originalUserFunctions[i].funcionesid,
            //             nombre: state.originalUserFunctions[i].funcion,
            //             status: 1 //Borrar
            //         };
            //         state.userFunctionsToSave.push(funct);
            //     }
            // }
            // //console.log("UserFunctionsToSave = ", state.userFunctionsToSave);
            // dispatch('uploadUserFunctions', userID);

            //Roles: ******************************************************************************************
            //console.log("userRoles = ", state.userRoles);
            //console.log("originalUserRoles = ", state.originalUserRoles);
            state.userRolesToSave = [];

            for (i = 0; i < state.userRoles.length; i++) {
                var j;
                bFound = false;
                for (j = 0; j < state.originalUserRoles.length; j++) {
                    if (state.userRoles[i].rolesid === state.originalUserRoles[j].rolesid) {
                        //El rol ya estaba desde antes. Se checa si se editó el nombre:
                        bFound = true;
                        if (state.userRoles[i].nombre !== state.originalUserRoles[j].nombre) {
                            //El nombre cambió. Hay que agregarlo al arreglo que se va a mandar al servidor:
                            //console.log("Nombre diferente en i = " + i + ", j = " + j);
                            const rol = {
                                usuariosrolesid: state.userRoles[i].usuariosrolesid,
                                usuariosid: state.userRoles[i].usuariosid,
                                rolesid: state.userRoles[i].rolesid,
                                nombre: state.userRoles[i].nombre,
                                status: 2 //Editar
                            };
                            state.userRolesToSave.push(rol);
                        }
                        break;
                    }
                }
                if (!bFound) {
                    //El registro no se encontró en el arreglo original, por lo que se trata de un registro nuevo:
                    //console.log("Registro nuevo en i = " + i + ", j = " + j);
                    const rol = {
                        usuariosrolesid: 0,
                        usuariosid: state.userRoles[i].usuariosid,
                        rolesid: state.userRoles[i].rolesid,
                        nombre: state.userRoles[i].nombre,
                        status: 0 //Nuevo
                    };
                    state.userRolesToSave.push(rol);
                }
            }

            //Ahora se comparan los arreglos al revés, para obtener los registros borrados. Si el registro estaba en el arreglo original
            //pero no en el nuevo, quiere decir que se debe borrar el registro:
            for (i = 0; i < state.originalUserRoles.length; i++) {
                bFound = false;
                var j;
                for (j = 0; j < state.userRoles.length; j++) {
                    if (state.originalUserRoles[i].rolesid === state.userRoles[j].rolesid) {
                        bFound = true;
                        break;
                    }
                }
                if (!bFound) {
                    const rol = {
                        usuariosrolesid: state.originalUserRoles[i].usuariosrolesid,
                        usuariosid: state.originalUserRoles[i].usuariosid,
                        rolesid: state.originalUserRoles[i].rolesid,
                        nombre: state.originalUserRoles[i].nombre,
                        status: 1 //Borrar
                    };
                    state.userRolesToSave.push(rol);
                }
            }
            //console.log("UserRolesToSave = ", state.userRolesToSave);
            dispatch('uploadUserRoles', userID);

            //Unidades de Negocio: ******************************************************************************************
            state.userBusinessUnitsToSave = [];
            state.originalUserBusinessUnits;
            //console.log("userBusinessUnits: ", state.userBusinessUnits);
            //console.log("originalUserBusinessUnits: ", state.originalUserBusinessUnits);

            for (i = 0; i < state.userBusinessUnits.length; i++) {
                var j;
                bFound = false;
                for (j = 0; j < state.originalUserBusinessUnits.length; j++) {
                    //ERRORL if (state.userBusinessUnits[i].unidadesdenegocioid === state.originalUserBusinessUnits[j].unidadesdenegocioid)
                    if (
                        state.userBusinessUnits[i].unidadnegocioid ===
                        state.originalUserBusinessUnits[j].unidadnegocioid
                    ) {
                        //La unidad de negocio ya estaba desde antes. Se checa si se editó el nombre:
                        bFound = true;
                        if (
                            state.userBusinessUnits[i].nombreUsuario !==
                            state.originalUserBusinessUnits[j].nombreUsuario
                        ) {
                            //El nombre cambió. Hay que agregarlo al arreglo que se va a mandar al servidor:
                            //console.log("Nombre diferente en i = " + i + ", j = " + j);
                            const businessUnit = {
                                usuariosunidadesdenegocioid:
                                    state.userBusinessUnits[i].usuariosunidadesdenegocioid,
                                usuariosid: state.userBusinessUnits[i].usuariosid,
                                //ERROR: unidadesdenegocioid: state.userBusinessUnits[i].unidadesdenegocioid,
                                unidadnegocioid: state.userBusinessUnits[i].unidadnegocioid,
                                nombre: state.userBusinessUnits[i].nombreUsuario,
                                status: 2 //Editar
                            };
                            state.userBusinessUnitsToSave.push(businessUnit);
                        }
                        break;
                    }
                }
                if (!bFound) {
                    //El registro no se encontró en el arreglo original, por lo que se trata de un registro nuevo:
                    //console.log("Registro nuevo en i = " + i + ", j = " + j);
                    const businessUnit = {
                        usuariosunidadesdenegocioid: 0,
                        usuariosid: state.userBusinessUnits[i].usuariosid,
                        //EROR: unidadesdenegocioid: state.userBusinessUnits[i].unidadesdenegocioid,
                        unidadnegocioid: state.userBusinessUnits[i].unidadnegocioid,
                        nombre: state.userBusinessUnits[i].nombreUsuario,
                        status: 0 //Nuevo
                    };
                    state.userBusinessUnitsToSave.push(businessUnit);
                }
            }

            //Ahora se comparan los arreglos al revés, para obtener los registros borrados. Si el registro estaba en el arreglo original
            //pero no en el nuevo, quiere decir que se debe borrar el registro:
            for (i = 0; i < state.originalUserBusinessUnits.length; i++) {
                bFound = false;
                var j;
                for (j = 0; j < state.userBusinessUnits.length; j++) {
                    //Error: if (state.originalUserBusinessUnits[i].unidadesdenegocioid === state.userBusinessUnits[j].unidadesdenegocioid) {
                    if (
                        state.originalUserBusinessUnits[i].unidadnegocioid ===
                        state.userBusinessUnits[j].unidadnegocioid
                    ) {
                        bFound = true;
                        break;
                    }
                }
                if (!bFound) {
                    const businessUnit = {
                        usuariosunidadesdenegocioid:
                            state.originalUserBusinessUnits[i].usuariosunidadesdenegocioid,
                        usuariosid: state.originalUserBusinessUnits[i].usuariosid,
                        //Error: unidadesdenegocioid: state.originalUserBusinessUnits[i].unidadesdenegocioid,
                        unidadnegocioid: state.originalUserBusinessUnits[i].unidadnegocioid,
                        nombre: state.originalUserBusinessUnits[i].nombreUsuario,
                        status: 1 //Borrar
                    };
                    state.userBusinessUnitsToSave.push(businessUnit);
                }
            }
            //console.log("UserBusinessUnitsToSave = ", state.userBusinessUnitsToSave);
            dispatch('uploadUserBusinessUnits', userID);

            //Direcciones: ******************************************************************************************

            state.userDepartmentsToSave = [];

            for (i = 0; i < state.userDepartments.length; i++) {
                var j;
                bFound = false;
                for (j = 0; j < state.originalUserDepartments.length; j++) {
                    if (
                        state.userDepartments[i].direccionesid ===
                        state.originalUserDepartments[j].direccionesid
                    ) {
                        //La dirección ya estaba desde antes. Se checa si se editó el nombre:
                        bFound = true;
                        if (
                            state.userDepartments[i].nombreUsuario !==
                            state.originalUserDepartments[j].nombreUsuario
                        ) {
                            //El nombre cambió. Hay que agregarlo al arreglo que se va a mandar al servidor:
                            //console.log("Nombre diferente en i = " + i + ", j = " + j);
                            const department = {
                                usuariosdireccionesid:
                                    state.userDepartments[i].usuariosdireccionesid,
                                usuariosid: state.userDepartments[i].usuariosid,
                                direccionesid: state.userDepartments[i].direccionesid,
                                nombre: state.userDepartments[i].nombreUsuario,
                                status: 2 //Editar
                            };
                            state.userDepartmentsToSave.push(department);
                        }
                        break;
                    }
                }
                if (!bFound) {
                    //El registro no se encontró en el arreglo original, por lo que se trata de un registro nuevo:
                    //console.log("Registro nuevo en i = " + i + ", j = " + j);
                    const department = {
                        usuariosdireccionesid: 0,
                        usuariosid: state.userDepartments[i].usuariosid,
                        direccionesid: state.userDepartments[i].direccionesid,
                        nombre: state.userDepartments[i].nombreUsuario,
                        status: 0 //Nuevo
                    };
                    state.userDepartmentsToSave.push(department);
                }
            }

            //Ahora se comparan los arreglos al revés, para obtener los registros borrados. Si el registro estaba en el arreglo original
            //pero no en el nuevo, quiere decir que se debe borrar el registro:
            for (i = 0; i < state.originalUserDepartments.length; i++) {
                bFound = false;
                var j;
                for (j = 0; j < state.userDepartments.length; j++) {
                    if (
                        state.originalUserDepartments[i].direccionesid ===
                        state.userDepartments[j].direccionesid
                    ) {
                        bFound = true;
                        break;
                    }
                }
                if (!bFound) {
                    const department = {
                        usuariosdireccionesid:
                            state.originalUserDepartments[i].usuariosdireccionesid,
                        usuariosid: state.originalUserDepartments[i].usuariosid,
                        direccionesid: state.originalUserDepartments[i].direccionesid,
                        nombre: state.originalUserDepartments[i].nombreUsuario,
                        status: 1 //Borrar
                    };
                    state.userDepartmentsToSave.push(department);
                }
            }
            //console.log("UserDepartmentsToSave = ", state.userDepartmentsToSave);
            dispatch('uploadUserDepartments', userID);
        },

        assignFunction(
            { dispatch, state },
            empresaFuncion //Se asigna a una empresa la función seleccionada. //Si empresaFuncion es null, simplemente se cierra la ventana sin hacer ninguna asignación.
        ) {
            if (!state.idToken) {
                return;
            }

            if (empresaFuncion !== null) {
                console.log('Función seleccionada: ', empresaFuncion);
                axios
                    .post('/funciones/addEmpresasFunciones/' + state.idToken, empresaFuncion)
                    .then(res => {
                        state.bWaitCursor = false;
                        console.log('res = ', res);

                        //Si la función ya se había asignado antes, se despliega un mensaje de error:
                        if (res.data.status !== 0) {
                            //Función Duplicada
                            dispatch('updateFunctionDuplicated', true);
                        } else {
                            dispatch('updateFunctionAssigned', true);
                            //Se vuelven a pedir al servidor todas las funciones de la empresa:
                            //PENDIENTE: Checar si hay que modificar:
                            dispatch('fetchCompanyFunctions', empresaFuncion.empresaid);
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            } //empresaFuncion === null, se cierra la ventana...
            else {
                dispatch('updateShowSelectFunctionDlg', false);
            }
        },

        assignValFunction(
            { commit, dispatch, state },
            functionID //Se asigna a una valuación la función seleccionada. //Si functionID es null, simplemente se cierra la ventana sin hacer ninguna asignación.
        ) {
            if (!state.idToken) {
                return;
            }

            if (functionID !== null && functionID !== 0) {
                commit('setValFunction', functionID);
                dispatch('updateShowValFunctionDlg', false);
            } //functionID === null, Sólo se cierra la ventana, sin actualizar nada...
            else {
                dispatch('updateShowValFunctionDlg', false);
            }
        },

        updateFunctionAssigned({ commit, state }, payload) {
            if (!state.idToken) {
                return;
            }
            commit('setFunctionAssigned', payload);
        },
        updateFunctionDuplicated({ commit, state }, payload) {
            if (!state.idToken) {
                return;
            }
            commit('setFunctionDuplicated', payload);
        },
        updateValFunctionName({ commit, state }, payload) {
            if (!state.idToken) {
                return;
            }
            commit('setValFunctionName', payload);
        },
        updateValFunctionID({ commit, state }, payload) {
            if (!state.idToken) {
                return;
            }
            commit('setValFunctionID', payload);
        },
        updateSpecializedFunctionsToShow({ commit, state }, payload) {
            if (!state.idToken) {
                return;
            }
            commit('setSpecializedFunctionsToShow', payload);
        },
        updateDisaggregatedFunctionsToShow({ commit, state }, payload) {
            if (!state.idToken) {
                return;
            }
            commit('setDisaggregatedFunctionsToShow', payload);
        },
        updateSpecializedFunctionsValToShow({ commit, state }, payload) {
            if (!state.idToken) {
                return;
            }
            commit('setSpecializedFunctionsValToShow', payload);
        },
        updateDisaggregatedFunctionsValToShow({ commit, state }, payload) {
            if (!state.idToken) {
                return;
            }
            commit('setDisaggregatedFunctionsValToShow', payload);
        },
        updateSpecializedFunctionsCompanyToShow({ commit, state }, payload) {
            if (!state.idToken) {
                return;
            }
            commit('setSpecializedFunctionsCompanyToShow', payload);
        },
        updateDisaggregatedFunctionsCompanyToShow({ commit, state }, payload) {
            if (!state.idToken) {
                return;
            }
            commit('setDisaggregatedFunctionsCompanyToShow', payload);
        },
        updateCompanyLogoImg({ commit, state }, logo) {
            if (!state.idToken) {
                return;
            }
            commit('setCompanyLogoImg', logo);
        },
        updateReportProcessed({ commit, state }, payload) {
            if (!state.idToken) {
                return;
            }
            commit('setReportProcessed', payload);
        },
        updateReportWarning({ commit, state }, payload) {
            if (!state.idToken) {
                return;
            }
            commit('setReportWarning', payload);
        },
        updatePdfPath({ commit, state }, strPath) {
            if (!state.idToken) {
                return;
            }
            commit('setPdfPath', strPath);
        },
        updateExcelProcessed({ commit, state }, payload) {
            if (!state.idToken) {
                return;
            }
            commit('setExcelProcessed', payload);
        },
        updateExcelPath({ commit, state }, strPath) {
            if (!state.idToken) {
                return;
            }
            commit('setExcelPath', strPath);
        },
        updateBelbinReportProcessed({ commit, state }, payload) {
            if (!state.idToken) {
                return;
            }
            commit('setBelbinReportProcessed', payload);
        },
        updateBelbinReportPath({ commit, state }, strPath) {
            if (!state.idToken) {
                return;
            }
            commit('setBelbinReportPath', strPath);
        },
        updateSurveyNumQuestions({ commit, state }, numQuestions) {
            if (!state.idToken) {
                return;
            }
            commit('setSurveyNumQuestions', numQuestions);
        },

        updateSessionExpires({ commit, state }, bExpires) {
            if (!state.idToken) {
                return;
            }
            commit('setSessionExpires', bExpires);
        },

        updateSessionTimeLeft({ commit, state }, strTimeLeft) {
            if (!state.idToken) {
                return;
            }
            commit('setSessionTimeLeft', strTimeLeft);
        },

        updateSessionEnding({ commit, state }, bEnding) {
            if (!state.idToken) {
                return;
            }
            commit('setSessionEnding', bEnding);
        },

        updateSessionEnded({ commit, state }, bEnded) {
            if (!state.idToken) {
                return;
            }
            commit('setSessionEnded', bEnded);
        },

        updateSurveysToDisplay({ commit, state }, surveys) {
            if (!state.idToken) {
                return;
            }
            commit('setSurveysToDisplay', surveys);
        },

        fetchUserLogs({ dispatch, state }, email) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;

            axios
                .get('/actividad/getByEmail/' + email + '/' + state.idToken, {
                    crossDomain: true
                })
                .then(res => {
                    console.log('fetchUserLogs, res = ', res);
                    dispatch('updateUserActivityLogs', res.data);
                    state.bWaitCursor = false;
                });
        },

        updateUserActivityLogs({ commit }, logs) {
            commit('setUserActivityLogs', logs);
        }
    },

    getters: {
        showNuestrasHerramientasDxTx: state => {
            return state.bShowNuestrasHerramientasDxTx;
        },
        showComoFuncionaTxt: state => {
            return state.bShowComoFuncionaTxt;
        },
        showRecursosTxt: state => {
            return state.bShowRecursosTxt;
        },
        showDocumentosInteresTxt: state => {
            return state.bShowDocumentosInteresTxt;
        },
        showGuiaInterpretacionTxt: state => {
            return state.bShowGuiaInterpretacionTxt;
        },
        showContactoTxt: state => {
            return state.bShowContactoTxt;
        },
        version: state => {
            return state.version;
        },
        appTitle: state => {
            return state.appTitle;
        },
        mainLogo: state => {
            return state.mainLogo;
        },
        mainLogoAppBar: state => {
            return state.mainLogoAppBar;
        },
        retroalimentameLogo: state => {
            return state.retroalimentameLogo;
        },
        mainBackgroundImg: state => {
            return state.mainBackgroundImg;
        },
        disclaimerImg: state => {
            return state.disclaimerImg;
        },
        waitCursor: state => {
            return state.bWaitCursor;
        },
        failedLogin: state => {
            return state.bFailedLogin;
        },
        inactiveUser: state => {
            return state.bInactiveUser;
        },
        isAuthenticated(state) {
            return state.idToken !== null && state.idToken !== undefined;
        },
        duplicatedUserError(state) {
            return state.bDuplicatedUserError;
        },
        user(state) {
            return state.user;
        },
        userName(state) {
            return state.userName;
        },
        loggedUserID(state) {
            return state.userID;
        },
        userWithNoSurveys(state) {
            return state.bUserWithNoSurveys;
        },
        userWithNoPendingSurveys(state) {
            return state.bUserWithNoPendingSurveys;
        },
        userType(state) {
            return state.user.tipoid;
        },
        companyID(state) {
            return state.companyID;
        },
        questionnaireID(state) {
            return state.questionnaireID;
        },
        company(state) {
            return state.company;
        },
        companySales(state) {
            return state.companySales;
        },
        companySalesCurrency(state) {
            return state.companySalesCurrency;
        },
        results(state) {
            return state.results;
        },
        companyReportResults(state) {
            return state.companyReportResults;
        },
        departmentReportResults(state) {
            return state.departmentReportResults;
        },
        isAdmin(state) {
            return state.bAdmin;
            //return false;
        },
        // showUserConfigDlg(state) {
        //     return state.bUserConfigDlg;
        // },
        userConfigOK(state) {
            return state.userConfigOK;
        },
        userTypes(state) {
            return state.userTypes;
        },
        selectedUserTypeIndex: state => {
            return state.selectedUserTypeIndex;
        },
        questionnaires(state) {
            return state.questionnaires;
        },
        selectedQuestionnaireIndex: state => {
            return state.selectedQuestionnaireIndex;
        },
        searchNewQuestionnaire: state => {
            return state.bSearchNewQuestionnaire;
        },
        newQuestionnaireID: state => {
            return state.newQuestionnaireID;
        },
        questionnaireGeneralAnswerSetID(state) {
            return state.questionnaireGeneralAnswerSetID;
        },
        questionnaireNames(state) {
            return state.questionnaireNames;
        },
        questionnaireNameTable(state) {
            return state.questionnaireNameTable;
        },
        questionnaireSkills(state) {
            return state.questionnaireSkills;
        },
        questionnaireSkillsLang(state) {
            return state.questionnaireSkillsLang;
        },
        questionnaireQuestions(state) {
            return state.questionnaireQuestions;
        },
        questionnaireQuestionsLang(state) {
            return state.questionnaireQuestionsLang;
        },
        questionnaireSkillTable(state) {
            return state.questionnaireSkillTable;
        },
        questionnaireQuestionHeader(state) {
            return state.questionnaireQuestionHeader;
        },
        questionnaireQuestionTable(state) {
            return state.questionnaireQuestionTable;
        },
        questionnaireTablesHeader(state) {
            return state.questionnaireTablesHeader;
        },
        questionnaireNotDeletedWarning(state) {
            return state.bQuestionnaireNotDeletedWarning;
        },
        serverResponse(state) {
            return state.bServerResponse;
        },
        surveyQuestModulesTeams(state) {
            return state.surveyQuestModulesTeams;
        },
        surveyQuestModulesCulture(state) {
            return state.surveyQuestModulesCulture;
        },
        surveyQuestModulesIndex(state) {
            return state.surveyQuestModulesIndex;
        },
        surveyQuestModulesLifeCircleDx(state)
        {
            return state.surveyQuestModulesLifeCircleDx;
        },
        surveyQuestModulesLifeCircleDxLeadership(state)
        {
            return state.surveyQuestModulesLifeCircleDxLeadership;
        },
        surveys(state) {
            return state.surveys;
        },
        surveysToDisplay(state) {
            return state.surveysToDisplay;
        },
        survey(state) {
            return state.survey;
        },
        surveyLoaded(state) {
            return state.bSurveyLoaded;
        },
        loadingSurvey(state) {
            return state.bLoadingSurvey;
        },
        selectedSurveyIndex: state => {
            return state.selectedSurveyIndex;
        },
        searchNewSurvey: state => {
            return state.bSearchNewSurvey;
        },
        newSurveyID: state => {
            return state.newSurveyID;
        },
        surveyRolleLabels: state => {
            return state.surveyRolleLabels;
        },
        rolleLabelTable: state => {
            return state.rolleLabelTable;
        },
        surveyUserTable: state => {
            return state.surveyUserTable;
        },
        answerSets(state) {
            return state.answerSets;
        },
        selectedAnswerSetIndex: state => {
            return state.selectedAnswerSetIndex;
        },
        answers(state) {
            return state.answers;
        },
        languageAnswers(state) {
            return state.languageAnswers;
        },
        answerTable(state) {
            return state.answerTable;
        },
        answerTableHeader(state) {
            return state.answerTableHeader;
        },
        languagesAnswerSet(state) {
            return state.languagesAnswerSet;
        },
        companies(state) {
            return state.companies;
        },
        companyLogoImg(state) {
            return state.companyLogoImg;
        },
        selectedCompanyIndex: state => {
            return state.selectedCompanyIndex;
        },
        languages: state => {
            return state.languages;
        },
        selectedLanguageIndex: state => {
            return state.selectedLanguageIndex;
        },
        users(state) {
            return state.users;
        },
        administrators(state) {
            return state.administrators;
        },
        selectedUserIndex: state => {
            return state.selectedUserIndex;
        },
        primaryFunctions(state) {
            return state.primaryFunctions;
        },
        primaryFunctionsVal(state) {
            return state.primaryFunctionsVal;
        },
        primaryFunctionsCompany(state) {
            return state.primaryFunctionsCompany;
        },
        specializedFunctions(state) {
            return state.specializedFunctions;
        },
        specializedFunctionsVal(state) {
            return state.specializedFunctionsVal;
        },
        specializedFunctionsCompany(state) {
            return state.specializedFunctionsCompany;
        },
        thereAreSpecializedFunctions(state) {
            return state.bSpecialized;
        },
        thereAreSpecializedFunctionsVal(state) {
            return state.bSpecializedVal;
        },
        thereAreSpecializedFunctionsCompany(state) {
            return state.bSpecializedCompany;
        },
        disaggregatedFunctions(state) {
            return state.disaggregatedFunctions;
        },
        disaggregatedFunctionsVal(state) {
            return state.disaggregatedFunctionsVal;
        },
        disaggregatedFunctionsCompany(state) {
            return state.disaggregatedFunctionsCompany;
        },
        thereAreDisaggregatedFunctions(state) {
            return state.bDisaggregated;
        },
        thereAreDisaggregatedFunctionsVal(state) {
            return state.bDisaggregatedVal;
        },
        thereAreDisaggregatedFunctionsCompany(state) {
            return state.bDisaggregatedCompany;
        },
        companyFunctions(state) {
            return state.companyFunctions;
        },
        companyFunctionsVal(state) {
            return state.companyFunctionsVal;
        },
        functionsExt(state) {
            return state.functionsExt;
        },
        // userFunctions(state) {
        //     return state.userFunctions;
        // },
        selectedFunctionIndex: state => {
            return state.selectedFunctionIndex;
        },
        selectedPrimaryIndex: state => {
            return state.selectedPrimaryIndex;
        },
        selectedSpecializedIndex: state => {
            return state.selectedSpecializedIndex;
        },
        selectedDisaggregatedIndex: state => {
            return state.selectedDisaggregatedIndex;
        },
        selectedPrimaryValIndex: state => {
            return state.selectedPrimaryValIndex;
        },
        selectedSpecializedValIndex: state => {
            return state.selectedSpecializedValIndex;
        },
        selectedDisaggregatedValIndex: state => {
            return state.selectedDisaggregatedValIndex;
        },
        selectedPrimaryCompanyIndex: state => {
            return state.selectedPrimaryCompanyIndex;
        },
        selectedSpecializedCompanyIndex: state => {
            return state.selectedSpecializedCompanyIndex;
        },
        selectedDisaggregatedCompanyIndex: state => {
            return state.selectedDisaggregatedCompanyIndex;
        },
        roles(state) {
            return state.roles;
        },
        rolesExt(state) {
            return state.rolesExt;
        },
        userRoles(state) {
            return state.userRoles;
        },
        selectedRoleIndex: state => {
            return state.selectedRoleIndex;
        },
        businessUnits(state) {
            return state.businessUnits;
        },
        businessUnitsExt(state) {
            return state.businessUnitsExt;
        },
        userBusinessUnits(state) {
            return state.userBusinessUnits;
        },
        selectedBusinessUnitIndex: state => {
            return state.selectedBusinessUnitIndex;
        },
        businessUnitForUser(state) {
            return state.businessUnitForUser;
        },
        departments(state) {
            return state.departments;
        },
        departmentsExt(state) {
            return state.departmentsExt;
        },
        userDepartments(state) {
            return state.userDepartments;
        },
        selectedDepartmentIndex: state => {
            return state.selectedDepartmentIndex;
        },
        showDepartmentsDlg: state => {
            return state.bShowDepartmentsDlg;
        },
        showBusinessUnitsDlg: state => {
            return state.bShowBusinessUnitsDlg;
        },
        showCompanyFunctionsDlg: state => {
            return state.bShowCompanyFunctionsDlg;
        },
        showSelectFunctionDlg: state => {
            return state.bShowSelectFunctionDlg;
        },
        showValFunctionDlg: state => {
            return state.bShowValFunctionDlg;
        },
        bFunctionAssigned: state => {
            return state.bFunctionAssigned;
        },
        bFunctionDuplicated: state => {
            return state.bFunctionDuplicated;
        },
        companySize: state => {
            return state.companySize;
        },
        valFunctionName: state => {
            return state.valFunctionName;
        },
        valFunctionID: state => {
            return state.valFunctionID;
        },
        factoresEmpresaID: state => {
            return state.factoresEmpresaID;
        },
        showResultsDlg: state => {
            return state.bShowResultsDlg;
        },
        showCompanyReportResultsDlg: state => {
            return state.bShowCompanyReportResultsDlg;
        },
        showDepartmentReportResultsDlg: state => {
            return state.bShowDepartmentReportResultsDlg;
        },
        departmentNameForReport: state => {
            return state.selectedDeptForReport;
        },
        specializedFunctionsToShow: state => {
            return state.specializedFunctionsToShow;
        },
        disaggregatedFunctionsToShow: state => {
            return state.disaggregatedFunctionsToShow;
        },
        specializedFunctionsValToShow: state => {
            return state.specializedFunctionsValToShow;
        },
        disaggregatedFunctionsValToShow: state => {
            return state.disaggregatedFunctionsValToShow;
        },
        specializedFunctionsCompanyToShow: state => {
            return state.specializedFunctionsCompanyToShow;
        },
        disaggregatedFunctionsCompanyToShow: state => {
            return state.disaggregatedFunctionsCompanyToShow;
        },
        userSurveys: state => {
            return state.userSurveys;
        },
        userSurvey: state => {
            return state.userSurvey;
        },
        userSurveyLangID: state => {
            return state.userSurveyLangID;
        },
        userSurveyData: state => {
            return state.userSurveyData;
        },
        surveyCompany: state => {
            return state.surveyCompany;
        },
        surveyNumQuestions: state => {
            return state.surveyNumQuestions;
        },
        showThankYouDlg: state => {
            return state.bShowThankYouDlg;
        },
        reportProcessed: state => {
            return state.bReportProcessed;
        },
        reportWarning: state => {
            return state.iReportWarning;
        },
        pdfPath: state => {
            return state.pdfPath;
        },
        excelProcessed: state => {
            return state.bExcelProcessed;
        },
        excelPath: state => {
            return state.excelPath;
        },
        belbinReportProcessed: state => {
            return state.bBelbinReportProcessed;
        },
        belbinReportPath: state => {
            return state.belbinReportPath;
        },
        sendUserSurveyError: state => {
            return state.bSendUserSurveyError;
        },
        sessionExpires: state => {
            return state.sessionExpires;
        },
        sessionTimeLeft: state => {
            return state.sessionTimeLeft;
        },
        sessionEnding: state => {
            return state.sessionEnding;
        },
        sessionEnded: state => {
            return state.sessionEnded;
        },
        userActivityLogs: state => {
            return state.userActivityLogs;
        }
    }
});
